export default {
  "100_items_page": "100 items/page",
  "10_items_page": "10 items/page",
  "50_items_page": "50 items/page",
  abandon_editing: "Abandon editing",
  abbreviation: "Abbreviation",
  abbreviation_cannot_be_empty: "Abbreviation cannot be empty",
  abbreviation_must_be_letters_or_numbers_and_no_longer_than_8_cha:
    "Abbreviation must be letters or numbers, and no longer than 8 characters",
  abnormal: "Abnormal",
  abnormal_behavior_monitoring: "Abnormal behavior monitoring",
  abnormal_cage_layer: "Abnormal cage layer",
  abnormal_chicken_cage_statistics: "Abnormal cage statistics",
  abnormal_file: "Abnormal file",
  abnormal_network: "Abnormal network",
  abnormal_pig_behavior_alarm: "Abnormal pig behavior alarm",
  abnormal_pig_count_heads: "Abnormal pig count",
  abnormal_pig_quantity_alarm: "Abnormal quantity alarm",
  abnormal_points: "Abnormal points",
  abnormal_quantity: "Abnormal quantity",
  abnormal_robot_restart: "Abnormal robot restart",
  abnormal_video_file_pls_confirm: "Abnormal video file, please confirm!",
  abn_cage: "Abn. cage",
  about: "About",
  about_the_device: "About the device",
  above_alarm: "Above alarm",
  above_alarm_temp_below_alarm_temp: "Above alarm temp >Below alarm temp",
  above_isotherm: "Above isotherm",
  accelerate: "Accelerate",
  accessories: "Accessories",
  access_channel_quantity_limit: "Access channel quantity limit",
  access_control_device: "Access Control Device",
  access_control_terminal: "Access control terminal",
  access_to_location_information_required_to_obtain_gps_data:
    "Access to location information required to obtain GPS data",
  account: "Account",
  account_format_allows_letters_or_numbers_only:
    "Account format allows letters or numbers only",
  account_format_should_be_letters_or_numbers_and_length_should_no:
    "Account format should be letters or numbers, and length should not exceed 20",
  account_is_locked_unlocked_after_10_minutes:
    "Account is locked, unlocked after 10 minutes.",
  account_login: "Account Login",
  account_management: "Account management",
  account_must_be_numbers_or_chinese_characters_and_no_longer_than:
    "Account must be numbers or Chinese characters, and no longer than 20 characters",
  account_not_exist: "Account not exist",
  account_password_modification: "Account password modification",
  acrel: "Acrel",
  actual_alarm_reason: "Actual alarm reason",
  actual_payments: "Actual payments",
  actual_time: "Actual time",
  add: "Add",
  added: "Added",
  added_successfully: "Added Successfully",
  added_to_cloud: "Added to cloud",
  added_to_download_queue: "Added to download queue",
  adding_mode: "Adding mode",
  adding_patrol_plan_failed: "Adding patrol plan failed.",
  adding_patrol_plan_succeeded: "Adding patrol plan succeeded.",
  adding_qr_code_points_is_not_allowed: "Adding QR code points is not allowed",
  adding_recording_lock_failed: "Adding recording lock failed.",
  adding_recording_lock_failed_conflicts_with_existing_recording_l:
    "Adding recording lock failed, conflicts with existing recording lock time.",
  adding_recording_lock_succeeded: "Adding recording lock succeeded.",
  adding_recording_plan_failed: "Adding recording plan failed.",
  adding_recording_plan_succeeded: "Adding recording plan succeeded.",
  address: "Address",
  addr_manage: "Address manage",
  add_address: "Add address",
  add_area: "Add area",
  add_associated_group: "Add associated group",
  add_channels: "Add Channels",
  add_company_information: "Add company information",
  add_curve: "Add Curve",
  add_data_permi: "Add data permission",
  add_department: "Add department",
  add_device: "Add Device",
  add_email: "Add Email",
  add_failed: "Add failed",
  add_img: "Add Image",
  add_inspection_point: "Add inspection point",
  add_manually: "Add Manually",
  add_manufacturer: "Add manufacturer",
  add_map: "Add Map",
  add_new_cage_position: "Add new cage position",
  add_new_point: "Add new point",
  add_new_shipping_address: "Add new Shipping address",
  add_patrol: "Add Patrol",
  add_point: "Add point",
  add_push_notification_personnel: "Add push notification personnel",
  add_res: "Add Res",
  add_resource: "Add Resource",
  add_res_type: "Add Res Type",
  add_robot: "Add robot",
  add_row: "Add Row",
  add_rule: "Add rule",
  add_shielded_area: "Add Shielded Area",
  add_spin_drift_to_results: "Add spin drift to results",
  add_successful: "Add successful.",
  add_temp_difference_rule: "Add Temp. Difference Rule",
  add_temp_range: "Add Temp. Range",
  add_to_cart: "Add to cart",
  add_to_cloud_success: "Add to cloud succeeded",
  add_user: "Add user",
  add_video: "Add Video",
  add_views: "Add Views",
  add_your_dedicated_engineer: "Add your dedicated engineer",
  adjust_line_number: "Adjust line number",
  adjust_order: "Adjust order",
  adjust_volume_brightness_through_device_buttons:
    "Adjust volume/brightness through device buttons",
  admin: "Admin",
  administrative_region_vector_layer: "Administrative Region Vector Layer",
  administrator_management: "Administrator management",
  admin_account: "Admin account",
  admin_account_cannot_be_empty: "Admin account cannot be empty",
  admin_account_must_be_letters_or_numbers_and_no_longer_than_20_c:
    "Admin account must be letters or numbers, and no longer than 20 characters",
  admin_cannot_be_deld: "Admin cannot be deleted.",
  advance: "Advance",
  advanced: "Advanced",
  ad_domain_login: "AD Domain Login",
  after_enabling_thermal_imgs_will_be_automatically_captured_when_:
    "After enabling, thermal images will be automatically captured when an alarm is triggered.",
  after_locking_the_robot_will_only_stay_in_place_and_will_not_per:
    "After locking, the robot will only stay in place and will not perform preset inspection tasks",
  after_logging_out_the_info_related:
    "After logging out, the information related to the account will be removed from the system, please operate with caution",
  after_sales_service: "After-sales service",
  after_successfully_modifying_the_wifi_information_you_need_to_re:
    "After successfully modifying the WIFI information, you need to restart the device and modify the mobile hotspot for the changes to take effect",
  after_switching_the_false_alarm_filtering_switch_the_fire_inform:
    "After switching the false alarm filtering switch, the fire information message in the upper right corner will be cleared. Are you sure  to switch?",
  after_the_channel_is_seled_the_channel_info_including_video_prev:
    "After the channel is selected, the channel info including video preview, video playback, video plan, event alarm viewing, device alarm viewing, etc can be viewed via platform.",
  after_the_wifi_name_is_modified_you_need_to_reconnect_the_device:
    "After the Wi-Fi name is modified, you need to reconnect the device Wi-Fi.",
  after_unlocking_the_robot_will_perform_preset_inspection_tasks:
    "After unlocking, the robot will perform preset inspection tasks",
  agent: "Agent",
  agent_cannot_be_empty: "Agent cannot be empty",
  age_in_days: "Age in days",
  agree: "Agree",
  agreement: "Agreement",
  air_pressure: "Air pressure",
  ais_layer: "AIS Layer",
  ai_analysis_basis: "AI analysis basis",
  ai_result_display: "AI result display",
  alarm: "Alarm",
  alarms_with_repeated_occurrences_equal_to_or_less_than_this_thre:
    "Alarms with repeated occurrences equal to or less than this threshold will be filtered out.",
  alarm_analysis: "Alarm analysis",
  alarm_area: "Alarm Area",
  alarm_attributes: "Alarm attributes",
  alarm_auto_photo: "Alarm auto photo",
  alarm_category: "Alarm Category",
  alarm_center: "Alarm Center",
  alarm_condition: "Alarm condition",
  alarm_config: "Alarm configuration",
  alarm_count: "Alarm count",
  alarm_count_threshold_times: "Alarm count threshold (Times)",
  alarm_description: "Alarm description",
  alarm_details: "Alarm details",
  alarm_device: "Alarm Device",
  alarm_enable_time: "Alarm enable time",
  alarm_end_time: "Alarm End Time",
  alarm_events: "Alarm events",
  alarm_filter_duration_s: "Alarm Filter Duration (s)",
  alarm_filter_time: "(Alarm)Filter Time",
  alarm_handling: "Alarm handling",
  alarm_handling_time: "Alarm handlingT",
  alarm_high_low_temp: "Alarm high low temp.",
  alarm_history: "Alarm History",
  alarm_information: "Alarm Information",
  alarm_information_query_alm_info_qry:
    "Alarm Information Query (Alm Info Qry)",
  alarm_input: "Alarm Input",
  alarm_in_progress: "Alarm in progress",
  alarm_item: "Alarm item",
  alarm_item_config: "Alarm item configuration",
  alarm_layer: "Alarm Layer",
  alarm_level: "Alarm Level",
  alarm_linkage: "Alarm linkage",
  alarm_management: "Alarm management",
  alarm_name: "Alarm name",
  alarm_occurred_times: "Alarm occurred * times",
  alarm_on_off: "Alarm On/Off",
  alarm_points: "Alarm points",
  alarm_preview: "Alarm Preview",
  alarm_processing: "Alarm Processing",
  alarm_processing_template: "Alarm Processing Template",
  alarm_prompt_control: "Alarm prompt control",
  alarm_query_aq: "Alarm Query",
  alarm_query_failed: "Alarm query failed.",
  alarm_record: "Alarm Record",
  alarm_record_handling: "Alarm record handling",
  alarm_region_setting: "Alarm region setting",
  alarm_report: "Alarm report",
  alarm_result: "Alarm result",
  alarm_result_details: "Alarm result details",
  alarm_result_storage_time: "Alarm result storage time",
  alarm_retrieval: "Alarm retrieval",
  alarm_sensitivity: "Alarm sensitivity",
  alarm_settings: "Alarm settings",
  alarm_shielding_rule_settings: "Alarm shielding rule settings",
  alarm_snapshot: "Alarm snapshot",
  alarm_snapshot_completed: "Alarm snapshot completed",
  alarm_snapshot_interrupted: "Alarm snapshot interrupted",
  alarm_snapshot_in_progress: "Alarm snapshot in progress",
  alarm_sound: "Alarm sound",
  alarm_source: "Alarm source",
  alarm_source_name: "Alarm Source Name",
  alarm_start_time: "Alarm start time",
  alarm_statistics: "Alarm statistics",
  alarm_status: "Alarm status",
  alarm_strategy: "Alarm strategy",
  alarm_table: "Alarm Table",
  alarm_template: "Alarm Template",
  alarm_temp_setting: "Alarm temp. setting",
  alarm_threshold: "Alarm threshold",
  alarm_time: "Alarm Time",
  alarm_trigger_time: "Alarm trigger time",
  alarm_type: "Alarm Type",
  alarm_viewing: "Alarm viewing",
  album: "Album",
  algorithm_alarm: "Algorithm alarm",
  algorithm_information_not_configured: "Algorithm information not configured",
  algorithm_name: "Algorithm name",
  algorithm_operating_channel: "Algorithm operating channel",
  algorithm_recognition: "Algorithm recognition",
  algorithm_recognition_failed: "Algorithm recognition failed",
  algorithm_syncing: "Algorithm syncing",
  algorithm_type_cannot_be_empty: "Algorithm type cannot be empty",
  algorithm_ver_number: "Algorithm version number",
  alg_op_plan: "Alg. op. plan",
  alignment_distance: "Alignment Distance",
  align_style_setting: "Align Style Setting",
  alipay: "AliPay",
  aliyuncom: "aliyun.com",
  all: "All",
  allow_input_of_1_to_20_characters_which_can_be_numbers_letters_o:
    "Allow input of 1 to 20 characters, which can be numbers, letters, -, or _.",
  all_alarm_areas_have_been_cleared: "All alarm areas have been cleared.",
  all_anomalies: "All anomalies",
  all_appraise: "All appraise",
  all_coops: "All coops",
  all_day: "All day",
  all_day_alarm: "All-day alarm",
  all_devices: "All devices",
  all_order: "All order",
  all_seled_files_have_been_downloaded:
    "All selected files have been downloaded.",
  all_shared_channels_of_the_platform_will_be_cleared:
    "All shared channels of the platform will be cleared.",
  already_alarmed: "Already alarmed",
  already_latest_ver: "Already latest version",
  already_synchronized: "Already synchronized",
  altitude: "Altitude",
  ammonia: "Ammonia",
  amplify: "Amplify",
  analysis_settings: "Analysis Settings",
  analyze: "Analyze",
  analyzed: "Analyzed",
  analyze_all: "Analyze All",
  angle: "Angle",
  angle_restricted_to_integers_in_the_range_90_90:
    "Angle restricted to integers in the range [-90, 90)",
  animal_warning: "Animal warning",
  anomalies_in_ope_pls_try_again: "Anomalies in operation, please try again.",
  anomalies_in_points_need_to_retrieve_them_from_the_platform:
    "Anomalies in points, need to retrieve them from the platform",
  anonymity: "Anonymity",
  another_user_is_currently_operating_pls_try_again_later:
    "Another user is currently operating, please try again later.",
  an_error_occurred: "An error occurred",
  an_existing_device_is_currently_connected_pls_wait:
    "An existing device is currently connected. Please wait.",
  api_interface_timeout: "API interface timeout",
  application: "Application",
  application_exception: "Application Exception",
  application_name: "Application name",
  application_restart: "Application restart",
  application_status: "Application Status",
  application_system_alarm: "Application System Alarm",
  application_ver: "Application version",
  applied_fov: "Applied FOV",
  applying_for_memory_permission: "Applying for memory permission",
  appraise: "Appraise",
  app_binding_status: "App binding status",
  app_ver: "App version",
  apr: "Apr",
  arctic: "Arctic",
  area_intrusion: "Area intrusion",
  area_name_cannot_be_empty: "Area name cannot be empty.",
  are_there_other_hotspots_with_the_same_name_around_the_device:
    "Are there other hotspots with the same name around the device",
  are_you_sure_to_clear_all_area_rules_for_the_current_device:
    "Are you sure  to clear all area rules for the current device?",
  are_you_sure_to_del_the_n1_inspection_task:
    "Are you sure to delete the {n1} inspection task?",
  are_you_sure_to_del_the_template: "Are you sure to delete the template",
  are_you_sure_to_del_this_resource: "Are you sure  to delete this resource?",
  are_you_sure_to_del_this_resource_type:
    "Are you sure to delete this resource type?",
  are_you_sure_to_del_this_shieled_area:
    "Are you sure to delete this shieled area?",
  are_you_sure_to_del_this_will_affect_historical_information_view:
    "Are you sure to delete? (This will affect historical information viewing on video preview, playback, recording plan, alarm records, and temperature measurement data)",
  are_you_sure_to_exit: "Are you sure you want to exit",
  are_you_sure_you_want_to_del_the_data_item_named_n1:
    "Are you sure you want to delete the data item named {n1}?",
  are_you_sure_you_want_to_del_the_data_item_with_resource_id_x:
    "Are you sure you want to delete the data item with resource ID X？",
  are_you_sure_you_want_to_del_the_line:
    "Are you sure you want to delete the ? line?",
  are_you_sure_you_want_to_del_the_seled_report:
    "Are you sure you want to delete the selected report?",
  are_you_sure_you_want_to_del_this_config:
    "Are you sure you want to delete this configuration?",
  are_you_sure_you_want_to_exit: "Are you sure you want to exit?",
  are_you_sure_you_want_to_exit_exiting_will_disable_the_alarm_lin:
    "Are you sure you want to exit? Exiting will disable the alarm linkage.",
  are_you_sure_you_want_to_export_all_data_permi_items:
    "Are you sure you want to export all data permission items?",
  are_you_sure_you_want_to_restart_the_robot:
    "Are you sure you want to restart the robot?",
  are_you_sure_you_want_to_resume_re_execute_the_xxx_inspection_ta:
    "Are you sure you want to resume/re-execute the XXX inspection task?",
  are_you_sure_you_want_to_resume_the_n1_inspection_task:
    "Are you sure you want to resume the {n1} inspection task?",
  are_you_sure_you_want_to_re_execute_the_n1_inspection_task:
    "Are you sure you want to re-execute the {n1} inspection task?",
  are_you_sure_you_want_to_terminate_the_n1_inspection_task:
    "Are you sure you want to terminate the {n1} inspection task?",
  array_size: "Array Size",
  asbestos_board: "Asbestos board",
  ascending: "Ascending",
  ascending_order_by_name: "Ascending order by name",
  ascending_order_by_time: "Ascending order by time",
  associated_cage_number: "Associated cage number",
  associated_channel: "Associated channel",
  associated_channel_cannot_be_empty: "Associated channel cannot be empty",
  associated_code: "Associated code",
  associated_column_number: "Associated column number",
  associated_component: "Associated component",
  associated_component_eg_menu: "Associated component, e.g., Menu",
  associated_group: "Associated group",
  associated_group_identifier_cannot_be_empty:
    "Associated group identifier cannot be empty",
  associated_group_names_cannot_be_duplicated:
    "Associated group names cannot be duplicated",
  associated_group_name_length_cannot_exceed:
    "Associated group name length cannot exceed",
  associated_img_capture_direction: "Associated image capture direction",
  associated_map: "Associated map",
  associated_organization: "Associated organization",
  associated_point: "Associated point",
  associated_robot: "Associated robot",
  associated_task: "Associated task",
  associate_ir_img: "Associate IR Image",
  associate_region: "Associate Region",
  association_name: "Association name",
  association_successful: "Association successful",
  asynchronous: "Asynchronous",
  asynchronously_starting_recording_plan:
    "Asynchronously starting recording plan.",
  atmospheric_ambient_temp: "Atmospheric Ambient Temp.",
  atmospheric_temp_is_out_of_range: "Atmospheric temp. is out of range",
  atmospheric_temp_is_required: "Atmospheric temp. is required",
  atmospheric_transmissivity: "Atmospheric Transmissivity",
  atmos_temp: "Atmos. Temp.",
  attribute: "Attribute",
  at_least_one_comprehensive_judgment_rule_must_be_seled:
    "At least one comprehensive judgment rule must be selected",
  audio: "Audio",
  aug: "Aug",
  authentication: "Authentication",
  authentication_failed_and_the_upload_was_terminated:
    "Authentication failed, and the upload was terminated",
  authorization_successful: "Authorization successful",
  authorization_successfully_revoked: "Authorization successfully revoked",
  authorize: "Authorize",
  authorize_use_of_robot_ope_information:
    "Authorize use of robot operation information",
  auth_failed: "Authentication failed",
  auth_failed_app_will_exit: "Auth failed, app will exit.",
  auth_failed_incorrect_username_password_or_device_model:
    "Authentication failed, incorrect username, password, or device model.",
  auto: "Auto",
  autofocus_core_the_blackbody_temp_x_10:
    "Note: For autofocus core, the blackbody temperature x 10",
  automatically_turn_off_io: "Auto IO Off",
  automatic_blinding_succeeded: "Automatic blinding succeeded",
  automatic_gain: "Automatic Gain",
  automatic_time_synchronization: "Automatic Time Synchronization",
  automatic_tracking_is_not_possible_pls_switch_the_linkage_contro:
    "Automatic tracking is not possible, please switch the linkage control of the device to Target Tracking mode.",
  automobile_night_vision: "Automobile night vision",
  auto_0: "Auto 0",
  auto_brightness_adjustment: "Auto brightness adjustment",
  auto_change_gain_mode: "(ATU)Automatically Change Gain Mode",
  auto_cloud_connection_successful: "Auto cloud connection successful",
  auto_excl: "Auto Excl.",
  auto_excl_speed: "Auto Excl. Speed",
  auto_focus: "Auto Focus",
  auto_login: "Auto Login",
  auto_mode: "Auto mode",
  auto_mode_restoration_time: "Auto mode restoration time",
  auto_power_off: "Auto Power-Off",
  auto_save: "Auto save",
  auto_temp_scale_enabled: "Auto temperature scale enabled",
  auto_time_sync_set_successfully: "Auto time sync set successfully",
  average: "Average",
  average_egg_production: "Average egg production",
  average_egg_production_rate: "Average egg production rate",
  average_temp: "Average temperature",
  average_temp_equal_to: "Average temperature equal to",
  average_weight: "Average weight",
  average_weight_per_pig: "Average weight per pig",
  avg: "Avg.",
  avg_temp_big_than: "Avg. temp. >",
  avg_temp_less_than: "Avg. temp. <",
  axis: "Axis",
  azimuth_angle: "Azimuth angle",
  a_channel_cannot_belong_to_multiple_associated_groups_whether_as:
    "A channel cannot belong to multiple associated groups. Whether associated channels within the same associated group trigger alarms simultaneously will be considered as a reference for integrated assessment to avoid false alarms.",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_enc:
    "A file is being downloaded. Please confirm whether to modify the encryption type.",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_pwd:
    "A file is being downloaded. Please confirm whether to modify the Wi-Fi password.",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_wif:
    "A file is being downloaded. Please confirm whether to modify the Wi-Fi name.",
  a_locked_robot_cannot_execute_inspection_tasks_as_planned_confir:
    "A locked robot cannot execute inspection tasks as planned. Confirm to lock robot?",
  a_max_of_6_video_streams_can_be_displayed_at_most:
    "A maximum of 6 video streams can be displayed at most",
  a_max_of_n_target_points_are_allowed:
    "A maximum of {n} target points are allowed",
  a_max_of_n_videos_can_be_displayed:
    "A maximum of {n} videos can be displayed",
  a_quick_report_is_created_pls_wait: "A quick report is created, please wait",
  a_window: "A window",
  background_api_ver: "Background API version",
  back_to_home_page: "Back to home page",
  back_to_ir_searcher_app: "Back to IR Searcher App",
  back_to_the_previous_menu: "Back to the Previous Menu",
  ballistics: "Ballistics",
  ballistic_calculation: "Ballistic calculation",
  ballistic_coefficient: "Ballistic coefficient",
  bark: "Bark",
  base_map: "Base map",
  base_map_control: "Base Map Control",
  base_map_transparency: "Base Map Transparency",
  basic_info: "Basic Info.",
  basic_information: "Basic information",
  basic_information_config: "Basic information configuration",
  basic_setting: "Basic Setting",
  batch_add: "Batch add",
  batch_create: "Batch create",
  batch_delete: "Batch delete",
  batch_dl: "Batch DL",
  batch_download_logs: "Batch download logs",
  batch_import: "Batch Import",
  batch_remove: "Batch Remove",
  batch_revoke_authorization: "Batch revoke authorization",
  batch_settings: "Batch settings",
  batch_sync: "Batch sync",
  batch_unbind: "Batch Unbind",
  battery: "Battery",
  battery_abnormal: "Battery abnormal",
  battery_alarm_threshold: "Battery alarm threshold",
  battery_capacity: "Battery capacity",
  battery_current: "Battery current",
  battery_information: "Battery information",
  battery_is_low_and_will_be_shut_down_soon:
    "The battery is low and will be shut down soon",
  battery_level: "Battery level",
  battery_life: "Battery life",
  battery_model: "Battery model",
  battery_status: "Battery status",
  battery_temp: "Battery temperature",
  battery_type: "Battery type",
  battery_voltage: "Battery voltage",
  baud_rate: "Baud Rate",
  below_alarm: "Below alarm",
  below_alarm_temp_above_alarm_temp: "Below alarm temp < above alarm temp",
  below_isotherm: "Below isotherm",
  beta: "BETA",
  beyond_range: "Beyond range",
  bill_management: "Bill management",
  binding_now: "Binding now",
  bind_app: "Bind app",
  bind_now: "Bind now",
  bird: "Bird",
  black_body_temp: "Black Body Temp.",
  black_hot: "Black Hot",
  black_or_white_paint: "Black or white paint",
  blank_page: "Blank Page",
  blind_element_settings_saved_successfully:
    "Blind element settings saved successfully",
  blind_element_setting_mode: "Blind element setting mode",
  blind_element_setting_mode_has_exited:
    "Blind element setting mode has exited",
  blind_spot_radius: "Blind spot radius",
  blink: "Blink",
  blocked: "Blocked",
  blue: "Blue",
  bluehot: "Bluehot",
  bluetooth_authorization_is_required_to_discover_new_devices:
    "Bluetooth authorization is required to discover new devices",
  bluetooth_device_disconnected: "Bluetooth device disconnected",
  bluetooth_device_not_found_yet: "Bluetooth device not found yet",
  bluetooth_permi_required: "Bluetooth permission required",
  blue_shades: "Blue Shades",
  boat_with_ais: "Boat with AIS",
  bottom_left: "Bottom-left",
  bottom_right: "Bottom-right",
  bound: "Bound",
  bound_rebind: "Bound, rebind",
  brass_mirror: "Brass mirror",
  brass_oxide: "Brass oxide",
  brazilian_portuguese: "Brazilian-Portuguese",
  brightness: "Brightness",
  brightness_adjustment: "Brightness adjustment",
  brightness_settings: "Brightness settings",
  bright_black_paint: "Bright black paint (spray on rough iron)",
  bright_paint: "Bright paint( all colors)",
  broadcast_lan: "Broadcast Lan",
  browser_time: "Browser time",
  browsing_history: "Browsing History",
  building_details: "Building details",
  building_name: "Building name",
  building_statistics: "Building statistics",
  built_in_firmware_ver_number: "Built-in firmware version number",
  bullet: "Bullet",
  bullet_camera: "Bullet camera",
  bullet_diameter: "Bullet diameter",
  bullet_information: "Bullet information",
  bullet_length: "Bullet length",
  bullet_list: "Bullet list",
  bullet_manufacturer: "Bullet manufacturer",
  bullet_name_already_exists_pls_edit_again:
    "Bullet name already exists, please edit again",
  bullet_weight: "Bullet weight",
  business_alarm: "Alarm",
  business_alarm_email_subject:
    "[System Notification] Event Alarm Statistics Notification",
  business_execution_error: "Business execution error.",
  button_settings: "Button settings",
  buy_now: "Buy now",
  by_count: "By count",
  by_day: "By Day",
  by_frequency: "By frequency",
  by_hour: "By Hour",
  by_level: "By level",
  by_minute: "By Minute",
  by_month: "By Month",
  by_name: "By Name",
  by_organization_structure: "by organization structure",
  by_second: "By Second",
  by_threshold: "By threshold",
  by_time: "By Time",
  by_week: "By Week",
  by_year: "By Year",
  cage: "*cage",
  cage_name: "Cage name",
  cage_no: "Cage No.",
  cage_view: "Cage view",
  calcimine: "Calcimine",
  calibrate: "Calibrate",
  calibrated: "Calibrated",
  calibrate_device: "Calibrate Device",
  calibrate_failed: "Calibrate Failed",
  calibrate_succeeded: "Calibrate Succeeded",
  calibration: "Calibration",
  calibration_method: "Calibration Method",
  calibration_status: "Calibration Status",
  camera: "Camera",
  camera_ip: "Camera IP",
  camera_ip_left: "Camera IP (left)",
  camera_ip_right: "Camera IP (right)",
  camera_name: "Camera name",
  camera_name_left: "Camera name (left)",
  camera_permi_required: "Camera permission required",
  camera_permi_required_to_accurately_obtain_azimuth_information:
    "Camera permission required to accurately obtain azimuth information",
  camera_status: "Camera status",
  camera_status_left: "Camera status (left)",
  camera_status_right: "Camera status (right)",
  camera_type: "Camera type",
  camera_type_right: "Camera type (right)",
  cancel: "Cancel",
  canceled: "Canceled",
  cancel_download: "Cancel download",
  cancel_search: "Cancel search",
  cancel_sel: "Cancel selection",
  cancel_the_download: "Cancel the download",
  cannot_be_greater_than_the_max_val:
    "Cannot be greater than the maximum value",
  cannot_be_less_than_the_min_val: "Cannot be less than the minimum value",
  cannot_duplicate_with_other_rules: "Cannot duplicate with other rules",
  cannot_sel_two_constants_at_the_same_time:
    "Cannot select two constants at the same time",
  can_be_purchased_after_login_auth:
    "Can be purchased after login authentication",
  can_not_join_group_shop_from_cart: "Can not join group shop from cart",
  capacity: "Capacity",
  capacity_is_less_than_200_mb:
    "The remaining SD card capacity is less than 200 MB, the recording ends.",
  capacity_is_less_than_200_mb_cannot_recording:
    "The remaining SD card capacity is less than 200 MB, the recording ends",
  caps_lock_is_on: "Caps Lock is on",
  capture_time: "Capture time",
  car: "Car",
  carbon_dioxide: "Carbon dioxide",
  carbon_dioxide_cloud_map: "Carbon dioxide",
  carbon_dioxide_concentration: "Carbon dioxide concentration",
  carbon_dioxide_ppm: "Carbon dioxide (ppm)",
  carbon_dioxide_sensor_status: "Carbon dioxide sensor status",
  carbon_monoxide: "Carbon Monoxide",
  carbon_plate: "Carbon plate",
  cargo_ship: "Cargo ship",
  cart: "Cart",
  category: "Category",
  category_cannot_be_empty: "Category cannot be empty",
  category_featured: "Category Featured",
  celsius: "Celsius",
  center_ip: "Center IP",
  center_port: "Center Port",
  center_spot: "Center Spot",
  certificated: "Certificated",
  certificate_information_retrieval_error_pls_contact_the_administ:
    "Certificate information retrieval error, please contact the administrator.",
  certificate_installation_error_pls_contact_the_administrator:
    "Certificate installation error, please contact the administrator.",
  certificate_must_be_in_lic_format: "Certificate must be in .lic format.",
  certificate_verification_failed: "Certificate verification failed",
  change_avatar: "Change avatar",
  change_bound_phone_number: "Change bound phone number",
  change_from_0_to_1: "Change from {0} to {1}",
  channel: "Channel",
  channels: "channel(s)",
  channels_not_shared: "Channels Not Shared",
  channel_addition_exception: "Channel addition exception.",
  channel_data_does_not_exist: "Channel data does not exist",
  channel_does_not_exist: "Channel does not exist",
  channel_id: "Channel ID",
  channel_information: "Channel information",
  channel_no: "Channel No.",
  channel_not_found_in_the_platform: "Channel not found in the platform.",
  channel_no_is_required: "Channel No. is required",
  channel_number: "Channel number",
  channel_offline: "Channel Offline",
  channel_type: "Channel Type",
  chan_id: "Chan ID",
  chan_name: "Chan Name",
  charging: "Charging",
  charging_point: "Charging point",
  charging_points: "Charging points",
  chars_less_than: "Character num <",
  chart_combination_of_numbers_capital_and_lowercase:
    "1-32 chart combination of numbers, capital and lower-case letters",
  chassis: "Chassis",
  chassis_malfunction: "Chassis malfunction",
  checking: "Checking",
  check_for_updates: "Check for updates",
  check_if_its_the_device_network: "Check if it's the device network",
  chicken_cage: "Chicken cage",
  chicken_coop: "Chicken coop",
  chicken_coop_management: "Chicken coop management",
  chicken_mouth_open_alarm: "Chicken mouth open",
  chicken_recognition: "Chicken recognition",
  china_bright: "china(bright)",
  chinese_characters_not_permitted: "Chinese characters not permitted",
  choose_bullet: "Choose bullet",
  choose_every_time: "Choose Every Time",
  choose_firearm: "Choose firearm",
  choose_from_the_dropdown_list_do_not_copy_and_paste_from_other_f:
    "Choose from the dropdown list, do not copy and paste from other files.",
  circle: "Circle",
  city: "City",
  clean_up_alarm_interval: "Clean Up Alarm Interval",
  clean_up_by_space: "Clean up by space",
  clean_up_temp_interval: "Clean Up Temp. Interval",
  clear: "Clear",
  clear_cache: "Clear cache",
  clear_calibration_failed: "Clear Calibration Failed",
  clear_calibration_succeeded: "Clear Calibration Succeeded",
  clear_cart: "Clear cart",
  clear_model_information: "Clear model information",
  clear_successful: "Clear successful",
  clicks: "Clicks",
  click_on_the_map_to_retrieve_information_from_any_location:
    "Click on the map to retrieve information from any location.",
  click_resource_to_see_detail_infomation:
    "Click resource to see detail infomation",
  click_to_sel_alarm_source: "Click to select alarm source",
  click_to_sel_export_information: "Click to select export information",
  click_to_sel_parent_directory: "Click to select parent directory.",
  click_to_upload: "Click to upload",
  click_to_upload_avatar: "Click to upload avatar",
  click_to_view: "Click to view",
  clip: "Clip",
  clip_failed: "Clip failed",
  clip_success: "Clip succeeded",
  clockwise: "Clockwise",
  clockwise_deviation_from_due_north_angle:
    "Clockwise deviation from due north angle",
  close: "Close",
  close_all: "Close All",
  close_all_playback: "Close all playback",
  close_distance_highlight: "Close-distance highlight",
  close_distance_highlight_display: "Close-distance highlight display",
  close_distance_pedestrian_warning: "Close-distance pedestrian warning",
  close_distance_vehicle_warning: "Close-distance vehicle warning",
  close_factory_password: "Close factory password",
  close_playback: "Close playback",
  close_prompt: "Close prompt",
  close_video: "Close video",
  closing_pls_wait: "Closing, please wait...",
  cloud: "Cloud",
  cloud_connection_successful: "Cloud connection successful",
  cloud_download: "Cloud Download",
  cloud_import: "Cloud Import",
  cloud_import_directory: "Cloud Import Directory",
  cloud_login: "Cloud Login",
  cloud_platform_connection_failed: "Cloud platform connection failed",
  cloud_platform_connection_successful: "Cloud platform connection successful",
  cloud_platform_settings: "Cloud platform settings",
  cloud_resource: "Cloud Resource",
  cloud_status: "Cloud Status",
  cloud_user: "Cloud User",
  coarse_tuning: "Coarse Tuning",
  cold_spot: "Cold Spot",
  collect_interval: "Collection Interval",
  color: "Color",
  color_highlights: "Color Highlights",
  color_palette: "Color Palette",
  column_cage_layer_suspected_discovery:
    "* column * cage * layer suspected discovery*",
  column_name: "Column name",
  column_x_cage_x_layer_x: "Column x, Cage x, Layer x",
  commodity_amount: "Commodity Amount",
  communication_status: "Communication status",
  company_n: "Company name",
  compiled_ver_number: "Compiled version number",
  complete: "Complete",
  composite_report: "Composite report",
  comprehensive_analysis_basis: "Comprehensive analysis basis",
  comprehensive_intelligent_analysis_level:
    "Comprehensive intelligent analysis level",
  com_is_required: "COM is required",
  concrete: "Concrete",
  config: "Configurate",
  configure_device_wifi: "Configure device Wi-Fi",
  configure_rules: "Configure rules",
  configure_storage_strategy: "Configure storage strategy",
  config_not_supported: "Config. not supported.",
  config_region: "Config Region",
  config_tool: "Config. Tool",
  config_tool_is_running: "Config. tool is running.",
  confirm: "Confirm",
  confirmed: "Confirmed",
  confirm_and_continue: "Confirm and Continue",
  confirm_clearing_all_map_markers: "Confirm clearing all map markers?",
  confirm_deletion: "Confirm deletion",
  confirm_deletion_of_xxx_inspection_task:
    "Confirm deletion of XXX inspection task?",
  confirm_intelligent_import_ope: "Confirm intelligent import operation?",
  confirm_its_an_anomaly: "Confirm it's an anomaly",
  confirm_its_a_false_alarm: "Confirm it's a false alarm",
  confirm_logout: "Confirm logout",
  confirm_log_in_again: "Log in again",
  confirm_new_password: "Confirm new password",
  confirm_or_not: "Confirm or not",
  confirm_permanent_deletion_this_action_is_not_recoverable:
    "Confirm permanent deletion? This action is not recoverable",
  confirm_pwd: "Confirm Password",
  confirm_restore_default_ope: "Confirm restore default operation",
  confirm_stopping_device_alarm: "Confirm stopping device alarm",
  confirm_termination_of_xxx_inspection_task:
    "Confirm termination of XXX inspection task?",
  confirm_the_cull_after_culling_the_target_will_no_longer_be_dete:
    "Confirm the cull? After culling, the target will no longer be detected.",
  confirm_the_unbinding_ope: "Confirm the unbinding operation.",
  confirm_to_del: "Confirm to delete",
  confirm_to_delrobot: "Confirm to delete...robot?",
  confirm_to_deltenant: "Confirm to delete...tenant?",
  confirm_to_del_all_regions: "Confirm to delete all regions",
  confirm_to_del_the_cur_path: "Confirm to delete the current path",
  confirm_to_del_the_file: "Confirm to delete the file",
  confirm_to_del_the_selected_file: "Confirm to delete the selected file",
  confirm_to_del_this_chicken_house: "Confirm to delete this chicken house",
  confirm_to_del_this_pig_house: "Confirm to delete this pig house?",
  confirm_to_del_this_pig_pen: "Confirm to delete this pig pen?",
  confirm_to_disableuser: "Confirm to disable...user?",
  confirm_to_exit: "Confirm to exit",
  confirm_to_exit_the_upgrade: "Confirm to exit the upgrade",
  confirm_to_export_all_tenant_management_data_items:
    "Confirm to export all tenant management data items?",
  confirm_to_export_all_user_data_items:
    "Confirm to export all user data items?",
  confirm_to_format: "Confirm to format",
  confirm_to_import_all_points: "Confirm to import all points?",
  confirm_to_remove_this_robot: "Confirm to remove this robot?",
  confirm_to_resetpassword: "Confirm to reset...password?",
  confirm_to_reset_password: "Confirm to reset password?",
  confirm_to_restart: "Confirm to restart",
  confirm_to_restore: "Confirm to restore",
  confirm_to_revoke_authorization_for_this_user_role:
    "Confirm to revoke authorization for this user role?",
  confirm_to_revoke_this_userrole: "Confirm to revoke this user...role?",
  confirm_to_unbind_the_user: "Confirm to unbind the user",
  confrim_to_del_the_row: "Confrim to delete the / row?",
  connect: "Connect",
  connected: "Connected",
  connected_devices: "Connected devices",
  connecting: "Connecting",
  connecting_to_the_device: "Connecting to the device",
  connection_disconnected: "Connection disconnected",
  connection_disconnected_pls_exit_and_try_again:
    "Connection disconnected, please exit and try again",
  connection_failed_incorrect_ip_port_or_device_network:
    "Connection failed, incorrect IP, port, or device network.",
  connection_guide: "Connection Guide",
  connection_succeeded: "Connection succeeded",
  connect_device: "Connect device",
  connect_device_manually: "Connect device manually",
  connect_failed: "Connect failed",
  connect_port_failed_device_is: "Connect port failed, device is",
  connect_via_device_access_point: "Connect via device access point",
  consignee_phone_number: "Consignee phone number",
  constant: "Constant",
  consumer_hotline: "Consumer hotline",
  contact: "Contact",
  contact_cannot_be_empty: "Contact cannot be empty",
  contact_customer_service: "Contact customer service",
  contact_information: "Contact information",
  contact_phone_number: "Contact phone number",
  content: "Content",
  content_page: "Content Page",
  continue_patrol: "Continue Patrol",
  continue_recording: "Continue recording",
  continuous: "Continuous",
  continuous_rangefinding: "Continuous rangefinding",
  contrast: "Contrast",
  control_commands_cannot_be_enabled_during_video_recording:
    "Control commands cannot be enabled during video recording",
  control_switch: "Control Switch",
  conventional_resolution: "Conventional Resolution",
  coop_name: "Coop name",
  coordinate_conversion_failed: "Coordinate conversion failed",
  coordinate_system: "Coordinate System",
  copper_coated_with_solder: "Copper coated with solder",
  copper_wire: "Copper wire",
  copy: "Copy",
  copy_to_clipboard_failed: "Copy to clipboard failed",
  copy_to_clipboard_succeed: "Copy to clipboard succeed",
  core_ver: "Core Version",
  coriolis_effect: "Coriolis effect",
  corporate_account: "Corporate account",
  corporate_jurisdical_person: "Corporate jurisdical person",
  corporate_name: "Corporate name",
  corresponding_internal_network_port: "Corresponding internal network port",
  corresponding_permission_is_required:
    "The corresponding permission is required in the APP settings to enable this function.",
  cotton_textiles_all_colors: "Cotton textiles(all colors)",
  count: "Count",
  counterclockwise: "Counterclockwise",
  county: "County",
  coupon: "Coupon",
  coupon_simple: "CO",
  cpu_overload: "CPU Overload",
  cracked_eggs: "Cracked eggs",
  cracked_egg_alarm: "Cracked egg alarm",
  cracked_egg_analysis: "Cracked egg",
  create: "Create",
  create_account: "Create account",
  create_config: "Create configuration",
  create_new_group: "Create New Group",
  create_new_house: "Create new house",
  create_new_page: "Create New Page",
  create_new_patrol: "Create New Patrol",
  create_new_pen: "Create new pen",
  create_new_role: "Create new role",
  create_new_task: "Create new task",
  create_new_template: "Create new template",
  create_new_user: "Create new user",
  create_new_view: "Create New View",
  create_order: "Create Order",
  create_organization: "Create organization",
  create_success: "Create success",
  create_time: "Create Time",
  creation_date: "Creation date",
  creation_failed: "Creation failed",
  creation_successful: "Creation successful",
  creator: "Creator",
  critical: "Critical",
  crossing_areas_are_not_allowed_to_be_drawn_pls_redraw:
    "Crossing areas are not allowed to be drawn. Please redraw!",
  cruise_ship: "Cruise ship",
  cumulative_sales: "Cumulative sales",
  currently_in_continuous_rangefinding_mode:
    "Currently in continuous rangefinding mode",
  current_channel_has_no_downloadable_recordings:
    "Current channel has no downloadable recordings.",
  current_computer_has_not_occupied_the_config_lock:
    "Current computer has not occupied the configuration lock.",
  current_coop: "Current coop",
  current_graphics_card_does_not_support_playing_h265_stream_pls_d:
    "Current graphics card does not support playing H.265 stream. Please download the operation manual for settings.",
  current_height: "Current height",
  current_location: "Current location",
  current_network_is_lan_pls_switch:
    "Current network is LAN, please switch to external network sharing",
  current_organization: "Current organization",
  current_patrol: "Current Patrol",
  current_patrol_is_previewing_cant_del:
    "Current patrol is previewing, can't delete",
  current_phone_number: "Current phone number",
  current_point: "Current point",
  current_recording_plan_and_linked_recording_stream_do_not_match_:
    "Current recording plan and linked recording stream do not match, resulting in the recording of two separate files, doubling the storage space, do you want to continue?",
  current_software_ver_beta: "Current software version beta",
  current_view: "Current View",
  current_view_has_been_associated_with_patrol_and_cannot_be_deld:
    "Current view has been associated with patrol and cannot be deleted",
  current_view_is_in_preview_mode_and_cannot_be_deld:
    "Current view is in preview mode and cannot be deleted.",
  current_view_is_using_and_cannot_be_deld:
    "Current view is using and cannot be deleted.",
  cur_device: "Current Device",
  customer_service: "Customer service",
  custom_spot: "Custom spot",
  custom_time_period: "Custom time period",
  cycle_setting_cannot_be_empty: "Cycle setting cannot be empty.",
  d: "D",
  daily_new: "Daily new",
  daily_new_alarms: "Daily new alarms",
  daily_weight_gain: "Daily weight gain",
  data: "Data",
  database_table: "Database table",
  data_already_exists: "Data already exists.",
  data_append_failed: "Data append failed.",
  data_cannot_be_empty: "Data cannot be empty",
  data_center: "Data Center",
  data_collection: "Data collection",
  data_deletion_failed: "Data deletion failed.",
  data_does_not_exist: "Data does not exist.",
  data_duplicate: "Data duplicate",
  data_error: "Data error",
  data_format_error_pls_contact_the_administrator:
    "Data format error, please contact the administrator",
  data_insertion_failed: "Data insertion failed.",
  data_load_failed: "Data load failed",
  data_monitoring: "Data monitoring",
  data_out_of_range: "Data out of range",
  data_permis: "Data permissions",
  data_permi_class_name: "Data permission class name",
  data_permi_class_name_cannot_be_empty:
    "Data permission class name cannot be empty",
  data_permi_field: "Data permission field",
  data_permi_field_cannot_be_empty: "Data permission field cannot be empty",
  data_permi_name: "Data permission name",
  data_permi_name_cannot_be_empty: "Data permission name cannot be empty",
  data_permi_range: "Data permission range",
  data_permi_remarks: "Data permission remarks",
  data_permi_type: "Data permission type",
  data_permi_type_cannot_be_empty: "Data permission type cannot be empty",
  data_retrieval_failed: "Data retrieval failed",
  data_source: "Data source",
  data_statistics: "Data statistics",
  data_status: "Data status",
  data_type: "Data Type",
  data_update_failed: "Data update failed.",
  date: "Date",
  date_and_time: "Date and Time",
  date_setting: "Date Setting",
  day: "Day",
  days: "*days",
  day_age_days: "Day age (days)",
  day_age_must_be_0_or_a_positive_integer_and_no_longer_than_5_cha:
    "Day age must be 0 or a positive integer, and no longer than 5 characters",
  day_ago: "day ago",
  dde: "DDE",
  dead_chickens: "Dead chickens",
  dead_chicken_alarm: "Dead chicken",
  dead_chicken_analysis: "Dead chicken",
  dec: "Dec",
  decelerate: "Decelerate",
  default_anti_keyword: "Default",
  default_charging_point: "Default charging point",
  default_group: "Default Group",
  default_keyword: "Default keyword",
  default_map: "Default map",
  default_organiztion: "Default Organiztion",
  default_password_is_12345678: "Default password is 12345678",
  default_path_cannot_be_removed: "Default path cannot be removed",
  default_role: "Default role",
  default_settings: "Default Settings",
  default_template: "Default Template",
  default_template_cannot_be_deld: "Default template cannot be deleted.",
  default_template_name_cannot_be_modified:
    "Default template name cannot be modified.",
  del: "Delete",
  deld_inspection_point_successfully: "Deleted inspection point successfully",
  delete_original_file: "Delete original file",
  deleting: "Deleting",
  deleting_linkage_strategy_failed: "Deleting linkage strategy failed.",
  deleting_linkage_strategy_succeeded: "Deleting linkage strategy succeeded.",
  deleting_patrol_plan_failed: "Deleting patrol plan failed.",
  deleting_patrol_plan_succeeded: "Deleting patrol plan succeeded.",
  deleting_qr_code_points_is_not_allowed: "Deleting QR code  is not allowed",
  deleting_the_area_will_also_del_related_push_notifications_are_y:
    "Deleting the area will also delete related push notifications. Are you sure you want to proceed with the deletion?",
  del_account: "Delete Account",
  del_all: "Delete All",
  del_chicken_house: "Delete chicken house",
  del_config: "Delete configuration",
  del_control: "Delete Control",
  del_failed: "Delete failed",
  del_from_cloud: "Delete From Cloud",
  del_map: "Delete map",
  del_page: "Delete Page",
  del_pig_house: "Delete pig house",
  del_pig_pen: "Delete pig pen",
  del_point: "Delete point",
  del_robot: "Delete robot",
  del_role: "Delete role",
  del_selected: "Delete Selected",
  del_sel_file: "Delete selected file",
  del_success: "Delete success",
  del_task: "Delete task",
  del_template: "Delete template",
  del_tenant: "Delete tenant",
  del_user: "Delete user",
  department: "Department",
  department_name: "Department name",
  department_name_cannot_be_empty: "Department name cannot be empty",
  department_status: "Department status",
  deposit: "Deposit",
  depth_camera: "Depth camera",
  depth_camera_abnormal: "Depth camera abnormal",
  descending: "Descending",
  descending_order_by_name: "Descending order by name",
  descending_order_by_time: "Descending order by time",
  description_of_alarm_handling: "Description of alarm handling",
  desel_all: "Deselect all",
  desel_user_authorization: "Deselect user authorization?",
  desert: "Desert",
  details: "Details",
  detail_info: "Detailed Info.",
  detect: "detect",
  detection_distance: "Detection Distance",
  detection_item: "Detection item",
  detection_value: "Detection value",
  detector_temp: "Detector Temp.",
  developing: "Developing",
  device: "Device",
  device_alarm: "Device alarm",
  device_alarm_source: "Device Alarm Source",
  device_alarm_stopped_successfully: "Device alarm stopped successfully.",
  device_alarm_stop_failed: "Device alarm stop failed.",
  device_alarm_subscription: "Device alarm subscription",
  device_alarm_template_number: "Device alarm template number",
  device_alias_already_exists_in_this_organization:
    "Device alias already exists in this organization.",
  device_alias_required: "Device Alias (Required)",
  device_already_added: "Device already added.",
  device_authority: "Device authority",
  device_auth_failed: "Device authentication failed.",
  device_battery_level: "Device Battery Level",
  device_calibration: "Device Calibration",
  device_channel_number_error: "Device channel number error.",
  device_command_parameter_error: "Device command parameter error.",
  device_config: "Device Config.",
  device_connected: "Device connected",
  device_connected_to_the_app: "Device connected to the App",
  device_connection_failed: "Device connection failed",
  device_deletion_failed: "Device deletion failed",
  device_disconnected: "Device disconnected",
  device_disconnected_pls_reconnect: "Device disconnected, please reconnect",
  device_discovery: "Device Discovery",
  device_does_not_exist: "Device does not exist.",
  device_driver: "Device driver",
  device_exception: "Device exception.",
  device_file: "Device file",
  device_find_error: "Device find error",
  device_id: "Device ID",
  device_import_failed_information_table:
    "Device Import Failed Information Table",
  device_import_information_table: "Device Import Information Table",
  device_import_information_table_do_not_include_empty_lines_or_sp:
    "Device import information table (Do not include empty lines or spaces)",
  device_info: "Device Info",
  device_information_management: "Device Information Management",
  device_ip: "Device IP",
  device_ip_or_port_number_error: "Device IP or port number error.",
  device_ip_or_port_number_is_incorrect:
    "Device IP or port number is incorrect.",
  device_is_not_added_to_cloud: "Device is not added to cloud",
  device_is_offline: "Device is offline",
  device_is_offline_no_stream_information:
    "Device is offline, no stream information.",
  device_language_sel: "Device Language Selection",
  device_layer: "Device Layer",
  device_linkage: "Device Linkage",
  device_link_guide: "Device link guide",
  device_list: "Device list",
  device_location: "Device Location",
  device_login: "Device login",
  device_malfunction: "Device malfunction",
  device_mgt: "Device Mgt.",
  device_model: "Device Model",
  device_monitoring: "Device monitoring",
  device_name: "Device Name",
  device_name_cannot_be_empty: "Device name cannot be empty",
  device_name_exists: "Device name exists",
  device_network_connection_exception: "Device network connection exception",
  device_network_issue: "Device network issue",
  device_not_found_in_the_platform: "Device not found in the platform.",
  device_not_retrieved: "Device not retrieved",
  device_offline: "Device Offline",
  device_ops: "Device Ops",
  device_or_channel_does_not_exist: "Device or channel does not exist.",
  device_or_channel_query_failed: "Device or channel query failed.",
  device_pan_tilt_control_stop_exception_pls_check_the_device:
    "Device pan-tilt control stop exception, please check the device.",
  device_password: "Device Password",
  device_playback_streaming_failed: "Device playback streaming failed.",
  device_preset_control_exception_pls_check_the_device:
    "Device preset control exception, please check the device.",
  device_preset_deletion_exception_pls_check_the_device:
    "Device preset deletion exception, please check the device.",
  device_ptz_control_start_failed_pls_check_the_device:
    "Device PTZ control start failed, please check the device.",
  device_reboot: "Device reboot",
  device_rebooted_successfully: "Device rebooted successfully",
  device_rebooting_pls_wait: "Device rebooting, please wait",
  device_registration_save_error: "Device registration save error.",
  device_registration_save_error_pls_check_if_the_device_and_chann:
    "Device registration save error, please check if the device and channel information are correct.",
  device_sdk_invocation_error: "Device SDK invocation error.",
  device_searching: "Device searching",
  device_service_read_failed_pls_disconnect_and_reconnect:
    "Device service read failed, please disconnect and reconnect",
  device_status: "Device Status",
  device_status_left: "Device status (left)",
  device_status_right: "Device status (right)",
  device_type: "Device type",
  device_username: "Device Username",
  device_ver: "Device version",
  device_view: "Device view",
  device_wifi_has_been_modified_manual_device_restart_required_for:
    "Device Wi-Fi has been modified, manual device restart required for changes to take effect",
  diagonal_flip: "Diagonal Flip",
  dialog_box: "Dialog Box",
  dictionary_label: "Dictionary label",
  dictionary_name: "Dictionary name",
  digital_camera: "Digital Camera",
  digital_camera_exception: "Digital camera exception",
  digital_camera_information: "Digital camera information",
  dimension: "Dimension",
  diopter_adjustment_range: "Diopter Adjustment Range",
  directory: "Directory",
  directory_name: "Directory name",
  direct_switching: "Direct Switching",
  dirty_chicken_cage_alarm: "Dirty chicken cage",
  disable: "Disable",
  disabled_successfully: "Disabled successfully",
  disable_audio: "Disable Audio",
  disable_img_super_resolution: "Disable Image Super-Resolution",
  disable_img_super_resolution_and_reboot:
    "Disable Image Super-Resolution and reboot?",
  disable_ipc_popup: "Disable IPC Popup",
  disable_panor_popup: "Disable Panor Popup",
  disable_popup: "Disable Popup",
  disable_successful: "Disable successful",
  disable_super_resolution_and_reboot: "Disable Super-Resolution and reboot?",
  disagree: "Disagree",
  disaster: "Disaster",
  disconnect: "Disconnect",
  disconnected: "Disconnected",
  discount_amount: "Discount amount",
  disk_offline: "Disk Offline",
  display: "Display",
  display_brightness: "Display brightness",
  display_order: "Display order",
  display_order_cannot_be_empty: "Display order cannot be empty",
  display_resolution: "Display Resolution",
  display_settings: "Display settings",
  display_time: "Display time",
  disposal_advice: "Disposal advice",
  disposal_advice_cannot_be_empty: "Disposal advice cannot be empty",
  disposal_advice_should_not_exceed_100_characters:
    "Disposal advice should not exceed 100 characters",
  disposal_status: "Disposal status",
  distance: "Distance",
  distance_cost: "Distance cost",
  distance_from_origin: "Distance from origin",
  distance_from_origin_cannot_be_empty: "Distance from origin cannot be empty",
  distance_from_origin_meters: "Distance",
  distance_from_origin_should_be_a_non_negative_number:
    "Distance from origin should be a non-negative number",
  distance_is_out_of_range: "Distance is out of range",
  distance_is_required: "Distance is required",
  distance_price: "Distance price",
  distance_unit: "Distance Unit",
  distance_value: "Distance value",
  diving_support_vessel: "Diving support vessel",
  dmc: "DMC",
  does_not_support_low_energy_bluetooth:
    "Does not support low-energy Bluetooth",
  dont_have_an_account: "Don't have an account",
  dont_have_an_account_yet: "Don't have an account yet?",
  down: "Down",
  download: "Download",
  downloaded: "Downloaded",
  downloading: "Downloading",
  download_center: "Download Center",
  download_completed: "Download completed",
  download_completed_pls_check_in_phone_gallery:
    "Download completed, please check in phone gallery",
  download_exception_pls_try_again_later:
    "Download exception, please try again later",
  download_failed: "Download failed",
  download_failed_items: "Download Failed Items",
  download_finish: "Download finish",
  download_firmware: "Download firmware",
  download_logs: "Download logs",
  download_management: "Download Management",
  download_path: "Download Path",
  download_start: "Download Start",
  download_success: "Download success",
  download_success_install_now: "Download success，install now",
  download_template: "Download Template",
  download_the_upgrade_package_to_your_phone:
    "Download the upgrade package to your phone",
  do_not_encode_manually: "Do not encode manually.",
  do_not_power_off_during_the_upgrade: "Do not power off during the upgrade",
  do_not_remind_again: "Do not remind again",
  do_you_want_to_del: "Do you want to delete?",
  do_you_want_to_logout: "Do you want to logout?",
  do_you_want_to_overwrite_this_file: "Do you want to overwrite this file",
  do_you_want_to_upgrade_to: "Do you want to upgrade to",
  drag_model: "Drag model",
  draw_temp_ellipse: "Draw temperature ellipse",
  dredging_or_subsea_ope_ship: "Dredging or subsea operation ship",
  drone: "Drone",
  dual_spectrum_fusion_registration: "Dual-spectrum Fusion Registration",
  dual_spectrum_registration: "Dual-spectrum Registration",
  duplicated_group_name_pls_rename: "Duplicated group name, please rename.",
  duplicated_patrol_name_pls_rename: "Duplicated patrol name, please rename.",
  duplicated_view_name_pls_rename: "Duplicated view name, please rename.",
  duplicate_area: "Duplicate Area",
  duplicate_domain_value: "Duplicate domain value.",
  duplicate_field_value: "Duplicate Field Value",
  duplicate_name: "Duplicate Name",
  duplicate_resource_name_as_in_the_0th_row:
    "Duplicate resource name as in the {0}th row",
  duplicate_resource_name_as_in_the_2nd_row:
    "Duplicate resource name as in the 2nd row.",
  duplicate_task_name: "Duplicate task name",
  duplicate_template_name: "Duplicate template name",
  duplication_file_name: "Duplication file name",
  duration: "Duration",
  duration_for_ai_recognition_frame_extraction:
    "Duration for AI recognition frame extraction",
  during_the_acquisition_of_device_io_channel_information_if_there:
    "During the acquisition of device IO channel information, if there is no data for more than 5 minutes, please contact the device manufacturer or technical support.",
  dwell_time: "Dwell Time",
  d_view: "3D View",
  each_page: "Each Page",
  east_northeast: "East-northeast",
  east_southeast: "East-southeast",
  edit: "Edit",
  edit_address: "Edit address",
  edit_associated_group: "Edit associated group",
  edit_inspection_actions: "Edit inspection actions",
  edit_integrated_judgment_rules: "Edit integrated judgment rules",
  edit_manufacturer: "Edit manufacturer",
  edit_patrol: "Edit Patrol",
  edit_report_conclusions: "Edit report conclusions",
  edit_shielded_area: "Edit Shielded Area",
  egg_laying_chicken_customer_administrator:
    "Egg-laying chicken customer administrator",
  egg_production: "Egg production",
  egg_production_analysis: "Egg production analysis",
  egg_production_count: "Egg production count",
  egg_production_rate: "Egg production rate",
  egg_production_rate_statistics: "Egg production rate statistics",
  egg_production_statistics: "Egg production statistics",
  electric: "Electric",
  electric_ceramies: "Electric ceramies",
  elevating_inspection: "Elevating inspection",
  email: "Email",
  email_address_cannot_be_empty: "Email address cannot be empty",
  email_cannot_be_empty: "Email cannot be empty",
  email_server_account: "Email server account",
  email_server_ip: "Email server IP",
  email_server_password: "Email server password",
  email_server_port: "Email server port",
  email_server_settings: "Email server settings",
  emap: "Emap",
  emap_module: "Emap Module",
  emergency_event: "Emergency event",
  emergency_event_videos_are_only_stored_on_the_deviceif_you_want_:
    "Emergency event videos are only stored on the device.If you want to save them to your phone, please download them locally",
  emergency_stop: "Emergency stop",
  emergency_stop_status: "Emergency stop status",
  emergency_stop_switch: "Emergency stop switch",
  emissivity: "Emissivity",
  emissivity_is_out_of_range: "Emissivity is out of range",
  emissivity_is_required: "Emissivity is required",
  empty: "Empty",
  empty_task_file: "Empty task file",
  empty_username_or_pwd: "Empty username or password",
  enable: "Enable",
  enabled_successfully: "Enabled successfully",
  enable_audio: "Enable Audio",
  enable_avg_temp: "Enable Avg. Temp.",
  enable_device_wifi: "Enable device Wi-Fi",
  enable_edge_alarm_bar: "Enable Edge Alarm Bar",
  enable_frame: "Enable Frame",
  enable_gpu: "Enable GPU",
  enable_img_super_resolution: "Enable Image Super-Resolution",
  enable_img_super_resolution_and_reboot:
    "Enable Image Super-Resolution and reboot?",
  enable_ipc_popup: "Enable IPC Popup",
  enable_level: "Enable Level",
  enable_max_temp: "Enable Max. Temp.",
  enable_min_temp: "Enable Min. Temp.",
  enable_opengles: "Enable OpenGLES",
  enable_panor_popup: "Enable Panor Popup",
  enable_popup: "Enable Popup",
  enable_pwd: "Enable Password",
  enable_status: "Enable Status",
  enable_successful: "Enable successful",
  enable_super_resolution_and_reboot: "Enable Super-Resolution and reboot?",
  enable_temp_rise_alarm: "Enable temperature rise alarm",
  enable_the_device_hotspot_with_which_pair_the_phone_wlan:
    "Enable the device hotspot, with which pair the phone WLAN",
  enable_the_phone_hotspot_with_which_pair_the_device_wlan:
    "Enable the phone hotspot, with which pair the device WLAN",
  enable_zeroing_weather: "Enable zeroing weather",
  encapsulation: "Encapsulation",
  encoder: "Encoder",
  encryption_type: "Encryption type",
  end: "End",
  ended: "Ended",
  end_action: "End action",
  end_date: "End date",
  end_date_can_not_be_earlier_than_current_data:
    "End date can not be earlier than current data.",
  end_date_required: "End date required",
  end_multiplier: "End multiplier",
  end_page: "End Page",
  end_time: "End Time",
  end_time_required: "End time required",
  end_tour: "End tour",
  end_zoom_speed: "End zoom speed",
  end_zoom_speed_should_be_lower_than_start_zoom_speed:
    "End zoom speed should be lower than start zoom speed",
  enforcement_vessel: "Enforcement vessel",
  english: "English",
  enlarge: "Enlarge",
  ensure_the_mobile_hotspot_settings_match_the_device:
    "Ensure the mobile hotspot settings match the device;",
  enter_alias: "Enter Alias",
  enter_channel_alias_for_filtering: "Enter channel alias for filtering",
  enter_content_filter: "Enter Content Filter",
  enter_latitude_longitude_eg_27658_120255:
    "Enter Latitude. Longitude (e.g., 27.658, 120.255)",
  enter_password_to_unlock: "Enter password to unlock",
  enter_the_wifi_settings_of_the_smartphone:
    "Enter the Wi-Fi settings of the smartphone",
  entries_page: "*entries/page",
  entry_date: "Entry date",
  entry_time: "Entry time",
  env_monitoring: "Environmental monitoring",
  env_param: "Env. Param.",
  "env_temp_alarm_threshold_℃": "Environmental temperature alarm threshold (℃)",
  env_temp_monitoring: "Environmental temperature monitoring",
  eos_base_map_management: "E.O.S base map management",
  eos_device: "E.O.S. Device",
  eos_name: "E.O.S name",
  epidemic_prevention_and_control: "Epidemic Prevention and Control",
  epoxy_glass_substrate: "Epoxy glass substrate",
  equal_to: "Equal to",
  equipment_channel: "Equipment channel",
  error: "Error",
  error_device: "Error Device",
  error_in_the_0_row: "Error in the {0} row",
  error_in_the_1st_row: "Error in the 1st row",
  error_in_video_file: "Error in video file",
  error_prompt: "Error Prompt",
  estimated_execution_time: "Estimated execution time",
  estimated_weight_of_pigs: "Estimated weight of pigs",
  evaluate: "Evaluate",
  event: "Event",
  event_alarm_config: "Event Alarm Configuration",
  event_alarm_data: "Event alarm data",
  event_alarm_linkage: "Event alarm linkage",
  event_alarm_settings: "Event Alarm Settings",
  event_alarm_statistics_sending_settings:
    "Event alarm statistics sending settings",
  event_alarm_subscription: "Event alarm subscription",
  event_alarm_template_number: "Event alarm template number",
  event_alarm_voice_settings: "Event Alarm Voice Settings",
  event_does_not_exist: "Event does not exist.",
  event_handle: "Event Handle",
  event_level: "Event Level",
  event_linkage: "Event Linkage",
  event_linkage_is_already_added_for_the_device_source:
    "Event linkage is already added for the device source.",
  event_record_does_not_exist: "Event record does not exist.",
  event_type: "Event Type",
  every_day: "Every day",
  every_hour: "Every hour",
  every_six_hours: "Every six hours",
  every_three_hours: "Every three hours",
  every_twelve_hours: "Every twelve hours",
  every_twenty_four_hours: "Every twenty-four hours",
  every_two_hours: "Every two hours",
  example_set_from_1800_to_600_meaning_enable_from_600_pm_to_600_a:
    "Example: Set from 18:00 to 6:00, meaning enable from 6:00 PM to 6:00 AM next day",
  excavator: "Excavator",
  exceptional: "Exceptional?",
  execute: "Execute",
  execute_immediately: "Execute immediately",
  execution_frequency: "Execution frequency",
  execution_method: "Execution method",
  execution_strategy: "Execution strategy",
  exercise_caution: "Exercise caution",
  exit: "Exit",
  exited: "Exited",
  exiting_pls_wait: "Exiting,please wait",
  exiting_will_disable_the_alarm_linkage:
    "Exiting will disable the alarm linkage",
  exit_successful: "Exit Successful",
  exit_system: "Exit system",
  expiration_time: "Expiration time",
  expired: "Expired",
  export: "Export",
  exporting: "Exporting",
  export_all_reports: "Export All Reports",
  export_all_rules: "Export All Rules",
  export_as_fvms_player_format: "Export as FVMS Player format",
  export_as_fvms_specific_format_only_playable_with_fvms_player:
    "Export as FVMS specific format, only playable with FVMS Player.",
  export_as_media_format: "Export as media format",
  export_as_vis_3000_player_format: "Export as VIS-3000 Player format",
  export_as_vis_3000_specific_format_only_playable_with_vis_3000_p:
    "Export as VIS-3000 specific format, only playable with VIS-3000 Player.",
  export_curve: "Export Curve",
  export_data: "Export Data",
  export_failed: "Export failed",
  export_information: "Export Information",
  export_media_format_files_such_as_mkv_mp4_etc_which_can_be_playe:
    "Export media format files such as MKV, MP4, etc., which can be played using local players.",
  export_report: "Export Report",
  export_report_successfully: "Export Report Successfully",
  export_success: "Export succeeded",
  export_table: "Export Table",
  export_temp: "Export Temp.",
  export_template: "Export Template",
  export_time: "Export Time",
  export_user_files: "Export user files",
  export_video: "Export Video",
  export_video_failed: "Export video failed",
  export_video_success: "Export video succeeded",
  external_network: "External network",
  external_network_address_settings: "External network address settings",
  ext_connect_dev_online_ratio: "Ext Connect Dev Online Ratio",
  e_mail: "E-mail",
  face_capture: "Face capture",
  face_img_path: "Face Image Path",
  factory_reset: "Factory Reset",
  factory_reset_failed: "Factory reset failed",
  factory_reset_succeeded: "Factory reset succeeded",
  fahrenheit: "Fahrenheit",
  failed: "Failed",
  failed_to_add_belonging_map_has_been_deld:
    "Failed to add, belonging map has been deleted",
  failed_to_add_device_pls_confirm_the_connection_is_normal:
    "Failed to add device, please confirm the connection is normal",
  failed_to_add_inf_temp_measurement_area:
    "Failed to add infrared temperature measurement area.",
  failed_to_add_preset: "Failed to add preset.",
  failed_to_add_role_name_already_exists:
    "Failed to add, role name already exists",
  failed_to_add_role_permis_already_exist:
    "Failed to add, role permissions already exist",
  failed_to_add_template: "Failed to add template",
  failed_to_be_deleted_pls_plug_and_unplug_sd_card:
    "Some files failed to be deleted. Please plug and unplug the SD card again",
  failed_to_create_facial_recognition_database:
    "Failed to create facial recognition database.",
  failed_to_create_new_inspection_point_duplicate_point_name:
    "Failed to create new inspection point, duplicate point name",
  failed_to_create_upgrade_file: "Failed to create upgrade file",
  failed_to_del_data_in_cloud: "Failed to delete data in cloud",
  failed_to_del_inf_temp_measurement_area:
    "Failed to delete infrared temperature measurement area.",
  failed_to_del_inspection_point: "Failed to delete inspection point",
  failed_to_del_map_associated_with_inspection_template:
    "Failed to delete, map associated with inspection template",
  failed_to_del_map_point_associated_with_inspection_task:
    "Failed to delete, map point associated with inspection task",
  failed_to_del_map_point_associated_with_inspection_template:
    "Failed to delete, map point associated with inspection template",
  failed_to_del_preset: "Failed to delete preset.",
  failed_to_del_template: "Failed to delete template",
  failed_to_exchange_templates: "Failed to exchange templates.",
  failed_to_export_alarm_records: "Failed to export alarm records.",
  failed_to_get_canvas: "Failed to get canvas",
  failed_to_get_certificate_information:
    "Failed to get certificate information",
  failed_to_get_inf_temp_measurement_area:
    "Failed to get infrared temperature measurement area.",
  failed_to_get_points_network_connection_abnormal:
    "Failed to get points, network connection abnormal",
  failed_to_get_preset_patrol_plan: "Failed to get preset patrol plan.",
  failed_to_get_scan_patrol_plan: "Failed to get scan patrol plan.",
  failed_to_get_template_list: "Failed to get template list",
  failed_to_get_the_first_alarm_event: "Failed to get the first alarm event.",
  failed_to_get_the_upgrade_status_pls_check_the_device_connection:
    "Failed to get the upgrade status. Please check the device connection.",
  failed_to_get_video_information_pls_retry:
    "Failed to get video information. Please retry.",
  failed_to_invoke_preset: "Failed to invoke preset.",
  failed_to_invoke_wiper: "Failed to invoke wiper.",
  failed_to_modify_email_account_already_exists:
    "Failed to modify, email account already exists",
  failed_to_modify_mute_notifications: "Failed to modify mute notifications",
  failed_to_modify_phone_number_already_exists:
    "Failed to modify, phone number already exists",
  failed_to_modify_push_switch: "Failed to modify push switch",
  failed_to_modify_role_name_already_exists:
    "Failed to modify, role name already exists",
  failed_to_modify_role_permis_already_exist:
    "Failed to modify, role permissions already exist",
  failed_to_modify_template: "Failed to modify template.",
  failed_to_obtain_location: "Failed to obtain location",
  failed_to_obtain_the_certificate_pls_contact_the_administrator:
    "Failed to obtain the certificate, please contact the administrator.",
  failed_to_obtain_the_machine_code_pls_contact_the_administrator:
    "Failed to obtain the machine code, please contact the administrator.",
  failed_to_play_audio: "Failed to play audio",
  failed_to_play_pls_refresh_and_reload:
    "Failed to play, please refresh and reload",
  failed_to_query_recording_plan: "Failed to query recording plan.",
  failed_to_rename: "Failed to rename",
  failed_to_retrieve_address: "Failed to retrieve address.",
  failed_to_retrieve_channel_information:
    "Failed to retrieve channel information",
  failed_to_retrieve_location_information:
    "Failed to retrieve location information",
  failed_to_retrieve_navigation_device_information:
    "Failed to retrieve navigation device information",
  failed_to_retrieve_recording_plan: "Failed to retrieve recording plan.",
  failed_to_retrieve_upgrade_information:
    "Failed to retrieve upgrade information",
  failed_to_retrieve_upgrade_status_pls_check_if_the_device_is_con:
    "Failed to retrieve upgrade status. Please check if the device is connected.",
  failed_to_save_blind_element_settings:
    "Failed to save blind element settings",
  failed_to_save_img: "Failed to save image",
  failed_to_set_auto_time_sync_pls_contact_administrator:
    "Failed to set auto time sync, please contact administrator",
  failed_to_set_manual_time_sync_the_reason_for_failure_is_an_inva:
    "Failed to set manual time sync. The reason for failure is an invalid date. Please re-enter the correct date.",
  failed_to_set_parameters_for_inf_temp_measurement_area:
    "Failed to set parameters for infrared temperature measurement area.",
  failed_to_set_template: "Failed to set template",
  failed_to_start_analysis: "Failed to start analysis",
  failed_to_stop_rangefinding: "Failed to stop rangefinding",
  failed_to_update_bullet_library: "Failed to update bullet library",
  failed_to_update_firearm_library: "Failed to update firearm library",
  failed_to_update_fire_severity: "Failed to update fire severity",
  failed_to_update_inspection_point: "Failed to update inspection point",
  failed_to_update_manufacturer_library:
    "Failed to update manufacturer library",
  failed_to_update_sight_library: "Failed to update sight library",
  fail_to_send_pls_update_again: "Fail to send,pls update again",
  false_alarm: "False alarm",
  false_alarm_shielding: "False alarm shielding",
  far_focus: "Far Focus",
  fast: "Fast",
  fast_forward: "Fast Forward",
  fast_play_speed: "Fast play speed",
  fattening_pig_customer_administrator: "Fattening pig customer administrator",
  fault: "Fault",
  favorite: "Favorite",
  favorites: "Favorites",
  feather: "Feather",
  feathers: "*feathers",
  feb: "Feb",
  febrile_pigs: "Febrile pigs",
  feedback: "Feedback",
  feeder: "Feeder",
  feeder_analysis: "Feeder",
  fee_mode: "Fee Mode",
  female: "Female",
  file_already_exists: "File already exists",
  file_downloading_pls_wait: "File downloading, please wait",
  file_format: "File Format",
  file_format_error_pls_upload_img_types_such_as_jpg_or_png:
    "File format error, please upload image types such as JPG or PNG.",
  file_format_validation_failed: "File format validation failed",
  file_library: "File library",
  file_name: "File Name",
  file_name_is_required: "File name is required",
  file_name_should_not_contain_special:
    'File name should not contain *<>|\\`":.?/',
  file_not_found: "File not found",
  file_not_found_pls_confirm_device:
    "File not found,please confirm the device was connnected and the SD card was insered",
  file_path: "File path",
  file_saving_period: "File saving period",
  file_saving_period_can_not_be_empty: "File saving period can not be empty.",
  file_size: "File Size",
  file_type: "File Type",
  file_upload_failed_pls_check_ftp_server_config:
    "File upload failed,please check FTP server configuration.",
  file_upload_size_cannot_exceed_200mb: "File upload size cannot exceed 200MB!",
  file_verification_failed_pls_replace_the_upgrade_file_or_re_impo:
    "File verification failed, please replace the upgrade file or re-import",
  filter: "Filter",
  filter_criteria: "Filter criteria",
  filter_false_alarm: "Filter False Alarm",
  filter_time: "Filter Time",
  find: "Find",
  fine_tuning: "Fine Tuning",
  fingerprint: "Fingerprint",
  finished: "Finished",
  fire: "Fire",
  firearm_information: "Firearm information",
  firearm_list: "Firearm list",
  firearm_name_already_exists_pls_edit_again:
    "Firearm name already exists, please edit again",
  fire_alarmfa: "Fire Alarm",
  fire_area: "Fire area",
  fire_behavior_change_thermal: "Fire behavior change (thermal)",
  fire_detection: "Fire detection",
  fire_extinguished: "Fire extinguished",
  fire_info: "Fire Info",
  fire_level_cannot_be_empty: "Fire level cannot be empty",
  fire_location: "Fire Location",
  fire_point_altitude: "Fire point altitude",
  fire_point_coordinates: "Fire point coordinates",
  fire_recognition_algorithm_visible: "Fire recognition algorithm (visible)",
  fire_setting: "Fire Setting",
  fire_severity: "Fire Severity",
  fire_status: "Fire Status",
  fire_type: "Fire Type",
  firmware: "Firmware",
  firmware_transfer_requires_phone_to_be_connected_to_the_devices_:
    "Firmware transfer requires phone to be connected to the device's WiFi network",
  firmware_update: "Firmware Update",
  firmware_upgrade: "Firmware upgrade",
  firmware_version: "Firmware version",
  firmware_ver_is_low_pls_upgrade_to_the_latest_ver:
    "Firmware version is low, please upgrade to the latest version",
  first_execution_time: "First execution time",
  first_login_pls_change_your_password:
    "First login, please change your password",
  fishing_boat: "Fishing boat",
  five_minutes: "Five minutes",
  flip: "Flip",
  flower_blue: "Flower-blue",
  focal_length: "Focal Length",
  focus: "Focus",
  fold: "Fold",
  folder: "Folder",
  font: "Font",
  font_color: "Font Color",
  font_setting: "Font Setting",
  font_size: "Font Size",
  forest_fire: "Forest Fire",
  forest_fire_alarm_merge_rule_settings:
    "Forest fire alarm merge rule settings",
  forest_fire_false_alarm_filtering_rule_settings:
    "Forest fire false alarm filtering rule settings",
  forest_fire_integrated_judgment_rule_settings:
    "Forest fire integrated judgment rule settings",
  forest_fire_intelligent_judgment_rule_settings:
    "Forest fire intelligent judgment rule settings",
  forest_fire_intelligent_judgment_switch_settings:
    "Forest fire intelligent judgment switch settings",
  forest_fire_overview: "Forest Fire Overview",
  forest_fire_prevention: "Forest Fire Prevention",
  forest_green: "Forest Green",
  forgot_pwd: "Forgot password",
  format_sd_card: "Format SD Card",
  format_success: "Format succeeded",
  forsale: "ForSale",
  for_rent: "ForRent",
  for_the_alarm_rule_of_high_temp_greater_than_the_alarm_level_tem:
    "For the alarm rule of high temperature greater than, the alarm level temperature should increase step by step.",
  four_windows: "Four windows",
  fov: "FOV",
  fpa_temp: "FPA Temp.",
  fps: "FPS",
  fpv: "FPV",
  frames_with_ai_recognition_confidence_equal_to_or_less_than_this:
    "Frames with AI recognition confidence equal to or less than this threshold will be considered as non-recognized objects at the specified position.",
  frame_range: "Frame Range",
  frame_rate: "Frame Rate",
  frame_rate_setting: "Frame Rate Setting",
  frame_temp: "Frame Temp.",
  free_shipping: "Free Shipping",
  french: "French",
  frequency: "Frequency",
  friday: "Fri.",
  front_of_the_car: "Front of the car",
  front_radar: "Front radar",
  front_radar_exception: "Front radar exception",
  front_radar_information: "Front radar information",
  ft: "ft",
  ftp_connection: "FTP connection",
  ftp_service_error_pls_quit_and_login_again:
    "FTP service error, please quit and login again. ",
  ftp_settings: "FTP settings",
  full_frame: "Full frame",
  full_region_name: "Full Region Name",
  full_region_name_is_required: "Full region name is required",
  full_screen: "Full Screen",
  function: "Function",
  function_authority: "Function authority",
  function_name: "Function name",
  fuse: "Fuse",
  fuse_mode: "Fuse mode",
  fusion_ratio: "Fusion Ratio",
  gain_mode: "Gain Mode",
  gallery: "Gallery",
  galvanized_bright_iron_plate: "Galvanized bright iron plate",
  gas_concentration: "Gas concentration",
  gas_detection_mode: "Gas detection mode",
  gas_enhancement: "Gas enhancement",
  gas_parameter_settings: "Gas parameter settings",
  gas_sensor: "Gas sensor",
  gas_sensor_information: "Gas sensor information",
  gas_sensor_malfunction: "Gas sensor malfunction",
  gateway: "Gateway",
  gear_shifting_in_progress_pls_try_again_later:
    "Gear shifting in progress, please try again later",
  gender: "Gender",
  general: "General",
  general_prompt: "General Prompt",
  geographical_location_info_not_obtained_yet:
    "Geographical location info not obtained yet",
  german: "German",
  get_array_size_failed: "Get array size failed",
  get_atmospheric_temp_failed: "Get atmospheric temp. failed",
  get_brightness_failed: "Get brightness failed",
  get_contrast_failed: "Get contrast failed",
  get_dde_enabled_failed: "Get DDE enabled failed",
  get_dde_failed: "Get DDE failed",
  get_detector_temp_failed: "Get detector temp. failed",
  get_distance_failed: "Get distance failed",
  get_emissisivity_failed: "Get emissisivity failed",
  get_encryption_type_failed: "Get encryption type failed",
  get_filter_enabled_failed: "Get filter enabled failed",
  get_from_compass: "Get from compass",
  get_from_gps: "Get from GPS",
  get_gain_mode_failed: "Get gain mode failed",
  get_image_flip_failed: "Get image flip failed",
  get_img_again: "Get image again",
  get_measurement_range_failed: "Get measurement range failed",
  get_osd_failed: "Get OSD failed",
  get_palette_failed: "Get Palette Failed",
  get_parameters: "Get Parameters",
  get_product_id_failed: "Get product id failed",
  get_product_number_failed: "Get product number failed",
  get_product_temp_failed: "Get product temp. failed",
  get_reflected_temp_failed: "Get reflected temp. failed",
  get_the_price_after_login_auth: "Get the price after login authentication",
  get_transmittance_failed: "Get transmittance failed",
  get_weather: "Get weather",
  glass_surface: "Glass(surface)",
  global: "Global",
  going: "Going",
  gold_plated_copper: "Gold-plated copper",
  got_it: "Got it",
  go_here: "Go Here",
  go_to: "Goto",
  go_to1: "Go to",
  go_to_enable: "Go to enable",
  go_to_page_: "Go to page *",
  go_to_settings: "Go to settings",
  go_to_wifi_settings_on_the_phone: "Go to Wi-Fi settings on the phone",
  gps_malfunction: "GPS malfunction",
  gps_status: "GPS status",
  gps_status_display: "GPS status display",
  graphics_card_does_not_suppot: "Graphics card does not suppot.",
  graphic_details: "Graphic details",
  greater_than: "Greater than",
  green: "Green",
  greenhot: "Greenhot",
  greenred: "GreenRed",
  green_shades: "Green Shades",
  group: "Group",
  group_buy: "Group buy",
  group_shop: "Group shop",
  guidance_throughout_product_usage_upgraded_experience_more_fan_b:
    "Guidance throughout product usage, upgraded experience, more fan benefits…",
  h: "H",
  h265_playback_instructions: "H.265 playback instructions",
  handheld_device: "Handheld device",
  handheld_mode: "Handheld Mode",
  handheld_online_mode: "Handheld&Online Mode",
  handled_successfully: "Handled Successfully",
  handler: "Handler",
  handle_and_push: "Handle and Push",
  handling: "Handling",
  handling_result: "Handling result",
  header_title: "Header Title",
  header_title_setting: "Header Title Setting",
  heads: "*heads",
  health: "Health",
  healthy_illumination_threshold: "Healthy illumination threshold",
  height_rangefinding: "Height rangefinding",
  hello_0_detection_1_triggered_a_fire_alarm_at_2_with_an_alarm_le:
    "Hello, {0} Detection {1} triggered a fire alarm at {2}, with an alarm level of {3}, and the fire point coordinates are {4}.",
  help: "Help",
  hide: "Hide",
  hierarchical_alarm_information_shielding:
    "Hierarchical alarm information shielding",
  high: "High",
  highlight: "Highlight",
  highlight_type: "Highlight Type",
  high_frequency: "High frequency",
  high_gain: "High Gain",
  high_highlight: "High Highlight",
  high_speed_vessel: "High-speed vessel",
  high_temp: "High Temp.",
  high_temperature: "High temperature",
  high_temperature_low_temperature: "High temperature > low temperature",
  high_temp_equal_to: "High temperature equal to",
  high_temp_mode: "High temperature mode",
  high_temp_value: "High temperature value",
  hikvision: "Hikvision",
  histogram: "Histogram",
  historical_data: "Historical Data",
  ho: "HO",
  home_page: "Home Page",
  horizontal: "Horizontal",
  horizontal_angle: "Horizontal angle",
  horizontal_angle_offset: "Horizontal Angle Offset",
  horizontal_click_value: "Horizontal click value",
  horizontal_mounting_angle: "Horizontal mounting angle",
  horizontal_right_left: "Horizontal (right, left -)",
  hot_iron: "Hot iron",
  hot_sale: "Hot Sale",
  hot_spot: "Hot Spot",
  hours: "Hours",
  hour_ago: "hour ago",
  house_name_must_be_numbers_or_chinese_characters_and_no_longer_t:
    "House name must be numbers or Chinese characters, and no longer than 20 characters",
  hovercraft: "Hovercraft",
  how_to_connect_the_device: "How to connect the device",
  human: "Human",
  humidity: "Humidity",
  humidity_cloud_map: "Humidity",
  humidity_rh: "Humidity (%RH)",
  humidity_sensor_status: "Humidity sensor status",
  hungarian: "Hungarian",
  hydrogen_sulfide: "Hydrogen Sulfide",
  ice: "Ice",
  icefire: "IceFire",
  icon: "Icon",
  icon_size_limit_5mb: "Icon size limit: 5MB.",
  identical: "Identical",
  identification_distance: "Identification Distance",
  idle: "Idle",
  idle_action: "Idle action",
  idle_action_trigger_time: "Idle action trigger time",
  if_either_is_set_to_blank_no_statistical_notifications_will_be_s:
    "If either is set to blank, no statistical notifications will be sent.",
  if_the_above_steps_are_correct_you_can_reset_the_wifi_and_reconn:
    "If the above steps are correct, you can reset the WIFI and reconnect by turning the volume to maximum and clicking the volume up key five times consecutively",
  if_the_black_body_temp_is_30_the_set_temp_is_300:
    "If the black body temperature is 30, the set temperature is 300.",
  if_the_device_is_not_connected_for_a_long_time_you_can_try_the_f:
    "If the device is not connected for a long time, you can try the following methods to troubleshoot:",
  if_the_ratio_of_the_total_number_of_frames_recognized_to_the_num:
    "If the ratio of the total number of frames recognized to the number of frames taken is less than or equal to this threshold, it will be considered: no recognizable object in the process.",
  if_the_robot_is_currently_performing_a_patrol_task_one_key_retur:
    "If the robot is currently performing a patrol task, one-key return to the charging pile will cause the current patrol task to end abnormally",
  if_you_confirm_the_ope_the_download_will_be_terminated_after_the:
    "If you confirm the operation, the download will be terminated. After the Wi-Fi name is modified, you need to reconnect the device Wi-Fi.",
  if_you_want_to_add_new_alarms_and_alarm_sources_for_already_set_:
    "If you want to add new alarms and alarm sources for already set personnel, please set them on the modification page.",
  if_you_want_to_add_new_alarms_and_linkage_actions_for_already_se:
    "If you want to add new alarms and linkage actions for already set alarm sources, please set them on the modification page.",
  ignore_aspect_ratio: "Ignore aspect ratio",
  illegal_region_name: "Illegal region name",
  illegal_role_name: "Illegal role name",
  illuminator: "Illuminator",
  image: "Image",
  image_adjust: "Image Adjust",
  image_analysis: "Image Analysis",
  image_capture: "Image capture",
  image_flip: "Image Flip",
  image_fusion: "Image fusion",
  image_mode: "Image Mode",
  imgs_for_ai_recognition_will_be_extracted_within_the_specified_d:
    "Images for AI recognition will be extracted within the specified duration near the trigger moment",
  img_brightness: "Image brightness",
  img_captured_successfully_pls_check_in_the_phone_gallery:
    "Image captured successfully. Please check in the phone gallery",
  img_capture_failed: "Image capture failed",
  img_capture_succeeded: "Image capture succeeded",
  img_contrast: "Image contrast",
  img_loading_failed: "Image loading failed",
  img_offset: "Image Offset",
  img_preview: "Image preview",
  img_saved_successfully: "Image saved successfully.",
  img_save_failed: "Image save failed.",
  img_stabilization: "Image stabilization",
  img_upload_failed_pls_contact_the_administrator:
    "Image upload failed. Please contact the administrator",
  img_viewing: "Image viewing",
  imix: "IMIX",
  imix_mode: "IMIX mode",
  imo_code: "IMO code",
  impor: "Import",
  importing: "Importing",
  importing_closing_will_stop_the_import_process:
    "Importing, closing will stop the import process.",
  import_all_rules: "Import All Rules",
  import_authorization_certificate: "Import authorization certificate",
  import_by_cage: "Import by cage",
  import_by_column: "Import by column",
  import_by_map: "Import by map",
  import_failed: "Import failed",
  import_img: "Import Image",
  import_logo: "Import Logo",
  import_method: "Import method",
  import_points: "Import points",
  import_status: "Import Status",
  import_success: "Import succeeded",
  import_template: "Import Template",
  imu_anomaly: "IMU anomaly",
  imu_information: "IMU information",
  incomplete_device_information_retrieval:
    "Incomplete device information retrieval.",
  incomplete_request_parameters_pls_check_if_devid_starttime_endti:
    "Incomplete request parameters, please check if devId, startTime, endTime are set.",
  incorrect_cage_columns_format: "Incorrect cage columns format",
  incorrect_cage_layers_format: "Incorrect cage layers format",
  incorrect_cage_rows_format: "Incorrect cage rows format",
  incorrect_email_format: "Incorrect email format",
  incorrect_import_img_format: "Incorrect import image format",
  incorrect_input: "Incorrect input",
  incorrect_latitude_format: "Incorrect latitude format",
  incorrect_longitude_format: "Incorrect longitude format",
  incorrect_menu_route_format_format_should_be_sys_menu:
    "Incorrect menu route format, format should be: /sys/menu",
  incorrect_number_of_common_channels_or_abnormal_channel_status_p:
    "Incorrect number of common channels or abnormal channel status, please check device configuration.",
  incorrect_number_of_eos_channels_or_abnormal_channel_status_pls_:
    "Incorrect number of E.O.S. channels or abnormal channel status, please check device configuration.",
  incorrect_original_pwd: "Incorrect original password",
  incorrect_or_expired_verification_code:
    "Incorrect or expired verification code",
  incorrect_password_entered: "Incorrect password entered.",
  incorrect_phone_number_format: "Incorrect Phone Number Format",
  incorrect_phone_number_or_password: "Incorrect phone number or password",
  incorrect_resource_name_format: "Incorrect resource name format",
  incorrect_user_type: "Incorrect user type",
  incorrect_verification_code: "Incorrect verification code",
  independent_report: "Independent report",
  index_mode: "Index mode",
  individual_analysis_for_atp_device: "Individual analysis for ATP device",
  info: "info",
  infrared_flashlight: "Infrared Flashlight",
  inf_camera_abnormal: "Infrared camera abnormal",
  inf_enhancement: "Infrared enhancement",
  inf_full_frame_temp_data: "Infrared full-frame temperature data",
  inf_light: "Infrared light",
  inf_malfunction: "Infrared malfunction",
  inf_panoramic_eos_360: "360° Infrared Panoramic E.O.S",
  inf_panoramic_eos_360_nvr: "360° Infrared Panoramic E.O.S NVR",
  inf_polarity: "Infrared polarity",
  inf_pseudo_color: "Infrared pseudo-color",
  inf_pseudo_color_enabled_successfully_effective_in_inf_fusion_im:
    "Infrared pseudo-color enabled successfully, effective in infrared/fusion image mode",
  inf_scenarios: "Infrared scenarios",
  inf_snapshot: "Infrared snapshot",
  inf_temp_measurement_area_exceeds_limit:
    "Infrared temperature measurement area exceeds limit.",
  inf_visible_light_split_screen: "Infrared-visible light split screen",
  initialization_point: "Initialization point",
  initiate_closure: "Initiate closure",
  input_information_is_illegal_pls_correct_it:
    "Input information is illegal. Please correct it!",
  input_the_new_password_again: "Input the new password again",
  insert_sd_card_or_restart_the_device: "Insert SD card or restart the device",
  inspected: "Inspected",
  inspected_points: "Inspected points",
  inspection_actions: "Inspection actions",
  inspection_anomaly: "Inspection anomaly",
  inspection_completed: "Inspection completed",
  inspection_count: "Inspection count",
  inspection_failed: "Inspection failed",
  inspection_in_progress: "inspecting",
  inspection_method: "Inspection method",
  inspection_point: "Inspection point",
  inspection_point_order: "Inspection point order",
  inspection_point_result: "Inspection point result",
  inspection_progress: "Inspection progress",
  inspection_results: "Inspection results",
  inspection_result_report: "Inspection result report",
  inspection_result_storage_time: "Inspection result storage time",
  inspection_robot: "Inspection robot",
  inspection_status: "Inspection status",
  inspection_tasks: "Inspection tasks",
  inspection_task_abnormality_points_completed_points_remaining_un:
    "Inspection task abnormality, * points completed, * points remaining unexecuted",
  inspection_task_exception_completed_point_count:
    "Inspection task exception, completed point count:",
  inspection_task_issued_but_the_robot_did_not_respond:
    "Inspection task issued but the robot did not respond",
  inspection_task_is_being_started_pls_wait:
    "Inspection task is being started, pls wait",
  inspection_task_start_time_cannot_be_earlier_than_3_minutes_from:
    "Inspection task start time cannot be earlier than 3 minutes from the current time",
  inspection_template: "Inspection template",
  inspection_type: "Inspection type",
  install: "Install",
  installation_position: "Installation position",
  installing: "Installing",
  install_failed_click_to_install_again:
    "Install failed, click to install again",
  install_firmware: "Install firmware",
  install_now: "Install Now",
  install_on_non_system_disk_or_run_as_administrator:
    "Please install software on a non-system disk or run software as an administrator",
  install_success_click_to_restart: "Install success, click to restart",
  instruction_issued_successfully: "Instruction issued successfully",
  insufficient_device_battery_level: "Insufficient device battery level",
  insufficient_device_space: "Insufficient device space",
  insufficient_disk_pls_clean: "Insufficient disk space, please clean up",
  insufficient_disk_space: "Insufficient Disk Space",
  insufficient_memory: "Insufficient Memory",
  insufficient_storage_space_alarm: "Insufficient storage space alarm",
  insulation_sheet: "Insulation sheet",
  integrated_judgment_switch_settings: "Integrated judgment switch settings",
  intelligent_analysis: "Intelligent analysis",
  intelligent_analysis_level: "Intelligent analysis level",
  intelligent_analysis_result: "Intelligent analysis result",
  intelligent_application: "Intelligent Application",
  intelligent_import: "Intelligent import",
  intelligent_import_successful: "Intelligent import successful",
  interface_access_failed: "Interface access failed",
  interface_access_timeout: "Interface access timeout",
  internal: "Internal",
  interpupillary_distance_adjustment_range:
    "Interpupillary Distance Adjustment Range",
  interval: "Interval",
  interval_period_days: "Interval period (Days)",
  intg_assess_settings: "Intg. assess. settings",
  introduction: "Introduction",
  invalid_atmospheric_temp: "Invalid atmospheric temp.",
  invalid_distance: "Invalid distance",
  invalid_email_address: "Invalid email address",
  invalid_emissivity: "Invalid emissivity",
  invalid_ftp_connection: "Invalid FTP connection",
  invalid_ip: "Invalid IP",
  invalid_ip_address: "Invalid IP address",
  invalid_ip_or_mac_address: "Invalid IP or MAC address",
  invalid_mac_address: "Invalid MAC address",
  invalid_recording_plan_id: "Invalid recording plan ID.",
  invalid_reflected_temp: "Invalid reflected temp.",
  invalid_transmittance: "Invalid transmittance",
  invalid_user: "Invalid user",
  inventory: "Inventory",
  inventory_analysis: "Inventory analysis",
  in_auto_mode_now_pls_switch_to_other_modes_for_calibration:
    "In auto mode now, please switch to other modes for calibration!",
  in_extreme_cases_pls: "In extreme cases, please",
  in_progress: "In progress",
  in_statistics: "In statistics",
  in_stock: "In stock",
  in_the_device_option_settings_privacy_imgs_pls_allow_this_app_to:
    "In the device option Settings-Privacy-Images, please allow this App to access your phone gallery",
  in_transition: "In transition",
  in_use: "In Use",
  iot_device: "IoT Device",
  iot_threshold_settings: "IoT Threshold Settings",
  io_alarm: "IO alarm",
  io_alarm_name: "IO alarm name",
  io_channel: "IO Channel",
  io_channel_no: "IO Channel No.",
  io_device: "IO device",
  io_linkage: "IO Linkage",
  io_settings: "IO Settings",
  io_status: "IO Status",
  ipc_event_popup: "IPC Event Popup",
  ipc_popup_switch: "IPC popup switch",
  ip_address: "IP address",
  ip_address_required: "IP Address (Required)",
  ip_already_exists: "IP already exists",
  ip_error: "IP error",
  ip_information: "IP Information",
  ip_is_required: "IP is required",
  ip_or_url: "IP or URL",
  ip_whitelist: "IP Whitelist",
  ir: "IR",
  iron: "Iron",
  irt_vms: "IRT-VMS",
  ir_detector: "IR Detector",
  ir_discovery: "IR Discovery",
  ir_farm_tech: "IR-Farm Tech",
  ir_farm_tech_comprehensive_cloud_platform_all_rights_reserved:
    "IR-Farm Tech Comprehensive Cloud Platform, All Rights Reserved",
  ir_farm_tech_comprehensive_management_cloud_platform:
    "IR-Farm Tech Comprehensive Management Cloud Platform",
  ir_farm_tech_robot_management_cloud_platform:
    "IR-Farm Tech Robot Management Cloud Platform",
  ir_img: "Ir Image",
  ir_mode: "IR mode",
  ir_setting: "IR setting",
  ir_threshold_settings: "IR Threshold Settings",
  isotherm: "Isotherm",
  isothermal: "Isothermal",
  isothermal_setting: "Isothermal Setting",
  isotherm_cannot_be_enabled_in_non_inf_mode:
    "Isotherm cannot be enabled in non-infrared mode",
  isotherm_cannot_be_enabled_in_white_hot_or_black_hot_mode:
    "Isotherm cannot be enabled in White Hot or Black Hot mode",
  isotherm_disabled: "Isotherm disabled",
  isotherm_off: "Isotherm: Off",
  isotherm_on: "Isotherm: On",
  isotherm_switch: "Isotherm switch",
  issue: "Issue",
  issued_successfully: "Issued successfully",
  italian: "Italian",
  its_empty_here: "It's empty here",
  it_can_be_expanded_to_more_than_1000_channels_by_re_licensing:
    "it can be expanded to more than 1000 channels by re-licensing",
  it_is_recommended_to_input_n1_sets_of_data_or_more_distribute_th:
    "It is recommended to input {n1} sets of data or more, distribute the observation targets as widely as possible, and the maximum difference in PTZ angle should be  {n2} degrees.",
  ivs: "IVS",
  ivs_box_channel_id: "IVS Box channel ID",
  i_have_read_and_agree: "I have read and agree",
  i_know: "I know",
  jan: "Jan",
  japanese: "Japanese",
  join_the_company: "Join the company",
  judgment_rule_identifier_cannot_be_empty:
    "Judgment rule identifier cannot be empty",
  judg_ch_assoc_plan: "Judg. ch. assoc. plan",
  judg_rule_settings: "Judg. rule settings",
  jul: "Jul",
  jun: "Jun",
  jungle: "Jungle",
  just_browsing: "Just browsing",
  just_now: "just now",
  keep_close_to_the_device_and_make_sure:
    "Keep close to the device and make sure the device is connected to the phone hotspot or in the same LAN",
  keep_close_to_the_device_and_select_one:
    "Keep close to the device and select one of the following methods to connect the device.",
  kelvin: "Kelvin",
  keywords: "Keywords",
  kg_head: "kg/head",
  knight_blue: "Knight Blue",
  knot: "knot",
  korean: "Korean",
  language: "Language",
  language_option: "Language Option",
  language_switch_is_valid_after_software_restart:
    "Language switch is valid after software restart",
  laser: "Laser",
  laser_range_finder: "Laser Range Finder",
  laser_range_finding: "Laser Range Finding",
  lastest_inspection_time: "Lastest inspection time",
  last_24_hours: "Last 24 hours",
  last_48_hours: "Last 48 hours",
  last_72_hours: "Last 72 hours",
  last_connection_time: "Last connection time",
  last_inspection_time: "Last inspection time",
  last_login_ip: "Last login IP",
  last_login_time: "Last login time",
  last_month: "Last month",
  last_occurrence: "Last occurrence",
  last_seven_days: "Last seven days",
  last_six_months: "Last six months",
  last_three_days: "Last three days",
  last_three_months: "Last three months",
  last_updated_time: "Last updated time",
  last_week: "Last week",
  latitude: "Latitude",
  latitude_and_longitude: "Latitude and Longitude",
  latitude_cannot_be_empty: "Latitude cannot be empty",
  latitude_out_of_current_map_area: "Latitude Out of Current Map Area",
  latitude_required: "Latitude (Required)",
  lava: "Lava",
  layer: "Layer",
  layer1: "Layer*",
  layer_may_exist: "Layer * may exist",
  layer_sel: "Layer Selection",
  layout: "Layout",
  led_alarm: "LED Alarm",
  led_light_malfunction: "LED light malfunction",
  left: "Left",
  left_hand_twist: "Left-hand twist",
  left_hand_twist_right_hand_twist: "Left-hand twist/Right-hand twist",
  left_right_flip: "Left- right Flip",
  left_side: "Left side",
  left_side_device_status: "Left side device status",
  legal_disclaimer: "Legal Disclaimer",
  length_must_be_between_6_to_20_characters:
    "Length must be between 6 to 20 characters",
  length_must_not_exceed_20_characters: "Length must not exceed 20 characters.",
  lens_config: "Lens configuration",
  lens_obstruction: "Lens obstruction",
  lens_offset: "Lens offset",
  less_than: "Less than",
  level: "Level",
  level1: "Level1",
  level2: "Level2",
  level3: "Level3",
  level4: "Level4",
  level_span: "Level/Span",
  lift: "Lift",
  lifting_height: "Lifting height",
  lifting_pole: "Lifting Pole",
  lifting_rod_information: "Lifting rod information",
  lifting_strategy: "Lifting strategy",
  lift_control: "Lift control",
  lift_rod_anomaly: "Lift rod anomaly",
  lift_to: "Lift to",
  light_aluminium_oxide: "Light aluminium oxide",
  limited_time: "Limited time",
  limited_time_shield: "Limited time shield",
  limited_to_20_characters: "Limited to 20 characters",
  limit_of_100_characters: "Limit of 100 characters",
  line: "Line",
  line_chart: "Line Chart",
  line_number_reach_limit: "Line Number reach limit",
  linkage: "Linkage",
  linkage_channel: "Linkage channel",
  linkage_control: "Linkage Control",
  linkage_recording: "Linkage Recording",
  linkage_record_directory: "Linkage Record Directory",
  linkage_record_duration: "Linkage Record Duration",
  linkage_snapshot: "Linkage Snapshot",
  linkage_snapshot_directory: "Linkage Snapshot Directory",
  linkage_sound: "Linkage Sound",
  linkage_strategy_setting_successful: "Linkage strategy setting successful.",
  linked_data_exists_and_deletion_is_not_supported:
    "Linked data exists, and deletion is not supported",
  linked_devices: "Linked Devices",
  linked_device_not_set: "Linked device not set",
  linked_ptz_name: "Linked PTZ Name",
  link_alarm_refresh: "Link Alarm Refresh",
  link_alarm_refresh_time: "Link Alarm Refresh Time",
  link_snapshot_path: "Link Snapshot Path",
  live: "Live",
  livestock_egg_laying_chickens: "Livestock egg-laying chickens",
  livestock_fattening_pigs: "Livestock fattening pigs",
  livestock_meat_chickens: "Livestock meat chickens",
  live_preview: "Live Preview",
  lo: "LO",
  loading: "Loading",
  loading_pls_wait: "Loading, please wait",
  load_failed: "Load failed",
  load_succeeded: "Load succeeded",
  local_device: "Local Device",
  local_file: "Local file",
  local_file_verification_failed: "Local file verification failed",
  local_import: "Local Import",
  local_platform_code: "Local Platform Code",
  local_platform_name: "Local Platform Name",
  local_resource: "Local Resource",
  locate_failed_pls_try_again_later: "Locate failed, please try again later",
  location: "Location",
  location_permi_required: "Location permission required",
  location_permi_required_to_discover_new_devices:
    "Location permission required to discover new devices",
  location_permi_required_to_obtain_gps_data:
    "Location permission required to obtain GPS data",
  lock: "Lock",
  locked: "Locked",
  lock_failed: "Lock failed",
  lock_robot: "Lock robot",
  lock_succeeded: "Lock succeeded.",
  lock_the_robot: "Lock the robot",
  log: "Log",
  login: "Login",
  login_account: "Login account",
  login_again: "Login again",
  login_attempts_are_too_frequent_pls_try_again_in_1_minute:
    "Login attempts are too frequent, please try again in 1 minute",
  login_expired_pls_log_in_again: "Login expired, please log in again.",
  login_failed: "Login failed",
  login_success: "Login success",
  logout: "Logout",
  logout_successful: "Logout Successful",
  logo_setting: "Logo Setting",
  log_query: "Log query",
  longitude: "Longitude",
  longitude_cannot_be_empty: "Longitude cannot be empty",
  longitude_out_of_current_map_area: "Longitude Out of Current Map Area",
  longitude_required: "Longitude (Required)",
  long_distance_pedestrian_warning: "Long-distance pedestrian warning",
  long_distance_vehicle_warning: "Long-distance vehicle warning",
  loop_task_already_exists: "Loop task already exists",
  low: "Low",
  lower_threshold: "Lower threshold",
  low_battery: "Low battery",
  low_battery_alarm: "Low battery",
  low_battery_threshold: "Low battery threshold",
  low_frequency: "Low frequency",
  low_gain: "Low Gain",
  low_highlight: "Low Highlight",
  low_temp: "Low Temp.",
  low_temperature: "Low temperature",
  low_temperature_high_temperature: "Low temperature < high temperature",
  low_temp_equal_to: "Low temperature equal to",
  low_temp_mode: "Low temperature mode",
  low_temp_value: "Low temperature value",
  l_of_rule_n_cannot_be_empty: "{l} of Rule {n} cannot be empty",
  m: "M",
  machine_code_cannot_be_empty: "Machine code cannot be empty",
  mac_address: "MAC address",
  mac_whitelist: "MAC Whitelist",
  magnification: "Magnification",
  maintenance_due_time: "maintenance due time",
  main_application: "Main Application",
  main_stream: "Main stream",
  male: "Male",
  management: "Management",
  management_and_config: "Management and Config",
  manager: "Manager",
  manual: "Manual",
  manual_adjustment: "Manual adjustment",
  manual_analysis_level: "Manual analysis level",
  manual_control: "Manual control",
  manual_event: "Manual event",
  manual_events_are_only_stored_on_the_device_if_you_want_to_save_:
    "Manual events are only stored on the device. If you want to save to your phone, please download locally",
  manual_excl: "Manual Excl.",
  manual_focus: "Manual focus",
  manual_follow: "Manual Follow",
  manual_layer_labeling: "Manual layer labeling",
  manual_markup_layer_not_displayed_pls_display_it_in_layer_sel:
    "Manual Markup Layer Not Displayed; Please Display It in Layer Selection.",
  manual_mode: "Manual mode",
  manual_time_calibration: "Manual time calibration",
  manual_time_sync_set_successfully: "Manual time sync set successfully",
  manufacturer: "Manufacturer",
  manufacturer_list: "Manufacturer list",
  manufacturer_name_already_exists_pls_edit_again:
    "Manufacturer name already exists, please edit again",
  man_overboard_detection: "Man overboard detection",
  map: "Map",
  map_config: "Map Config",
  map_display: "Map Display",
  map_management: "Map management",
  map_name: "Map name",
  map_name_cannot_be_empty: "Map name cannot be empty",
  map_name_should_consist_of_letters_numbers_or_chinese_characters:
    "Map name should consist of letters, numbers, or Chinese characters, and should not exceed 20",
  map_survey: "Map survey",
  map_sync_failed_network_connection_abnormal:
    "Map sync failed, network connection abnormal",
  map_update_failed: "Map update failed",
  map_ver_number_or_point_ver_number_update_failed:
    "Map version number or point version number update failed",
  mar: "Mar",
  marble: "Marble",
  marker: "Marker",
  marking_area: "Marking Area",
  marking_line: "Marking Line",
  marking_point: "Marking Point",
  markup_information: "Markup Information",
  material: "Material",
  matte_paint: "Matte paint",
  max: "Max.",
  maximize: "Maximize",
  max_10_linkage_channels: "Max. 10 linkage channels",
  max_alarm_data_retention_period: "Maximum Alarm Data Retention Period",
  max_count_per_cage: "Maximum count per cage",
  max_egg_production: "Maximum egg production",
  max_egg_production_rate: "Maximum egg production rate",
  max_number_of_files_that_can_be_seled:
    "Max. number of files that can be selected",
  max_number_of_intelligent_judgment_repetitions:
    "Max number of intelligent judgment repetitions",
  max_number_of_intelligent_judgment_repetitions_cannot_be_empty:
    "Max number of intelligent judgment repetitions cannot be empty",
  max_number_of_temp_difference_rules_is:
    "Maximum number of temp. difference rules is",
  max_offset_cannot_be_empty: "Max offset cannot be empty",
  max_offset_m: "Max offset (m)",
  max_of_0_resources_allowed_currently_1_resources_exist:
    "Maximum of {0} resources allowed, currently {1} resources exist.",
  max_of_1000_resources_allowed_currently_1000_resources_exist:
    "Maximum of 1000 resources allowed, currently 1000 resources exist.",
  max_of_8_imgs_are_seled: "Maximum of 8 images are selected",
  max_sel_quantity: "Maximum selection quantity",
  max_temp: "Max Temp.",
  max_temp_big_than: "Max. temp. >",
  max_temp_big_than_min_temp: "Max. Temp. > Min. Temp.",
  max_temp_is_required: "Max. temp is required",
  max_temp_less_than: "Max. temp. <",
  max_time_interval: "Max time interval",
  max_time_interval_cannot_be_empty: "Max time interval cannot be empty",
  may: "May",
  mearge_alarm_export: "Mearge Alarm Export",
  measurement: "Measurement",
  measurement_range: "Measurement Range",
  measure_area: "Measure Area",
  meat_chicken_customer_administrator: "Meat chicken customer administrator",
  media_format: "Media format",
  media_library: "Media library",
  medical: "Medical",
  medical_transport_vessel: "Medical transport vessel",
  medium: "Medium",
  menu: "Menu",
  menu_management: "Menu management",
  menu_name: "Menu name",
  menu_permissions: "Menu permissions",
  menu_route: "Menu route",
  menu_url: "Menu URL",
  merge: "Merge",
  merge_alarm: "Merge Alarm",
  merge_failed: "Merge Failed",
  merge_repeated_alarms: "Merge repeated alarms",
  merge_time_interval_s: "Merge Time Interval (s)",
  merging: "Merging",
  messagebox: "MessageBox",
  message_prompt: "Message Prompt",
  message_push: "Message push",
  message_queue_exception: "Message queue exception.",
  metal: "Metal",
  meter: "Meter",
  methane: "Methane",
  method_1: "Method 1",
  method_2: "Method 2",
  method_3: "Method 3",
  microphone: "microphone",
  microservice_invocation_exception: "Microservice invocation exception.",
  middleware_ver: "Middleware version",
  midgrey: "MidGrey",
  military_opes_vessel: "Military operations vessel",
  min: "Min.",
  mine: "Me",
  minimize: "Minimize",
  minor: "Minor",
  minutes: "Minutes",
  minutes_15: "15 minutes",
  minutes_30: "30 minutes",
  min_15_seconds_for_linkage_recording_duration:
    "Min. 15 seconds for linkage recording duration",
  min_ago: "min ago",
  min_data_collection_period_is_5_minutes:
    "Minimum data collection period is 5 minutes.",
  min_egg_production: "Minimum egg production",
  min_egg_production_rate: "Minimum egg production rate",
  min_temp: "Minimum temperature",
  min_temp_big_than: "Min. temp. >",
  min_temp_is_required: "Min. temp is required",
  min_temp_less_than: "Min. temp. <",
  mirage: "Mirage",
  mirror_display: "Mirror display",
  mirror_img: "Mirror image",
  missed_cage_report: "Missed cage report",
  missed_coop_report: "Missed coop report",
  missed_inspection_report: "Missed inspection report",
  missed_report_entry: "Missed report entry",
  missed_report_img: "Missed report image",
  mmenu: "Menu",
  mmsi: "MMSI",
  mobile: "Mobile",
  mobile_binding_successful: "Mobile binding successful",
  mobile_login: "Mobile login",
  mobile_number_binding: "Mobile number binding",
  mobile_number_changed_successfully: "Mobile number changed successfully",
  mobile_number_format_error: "Mobile number format error",
  mobile_number_not_bound_unable_to_modify_via_phone_verification:
    "Mobile number not bound, unable to modify via phone verification",
  mobile_phone_imei: "Mobile phone IMEI",
  mobile_robot: "Mobile robot",
  mobile_verification_modification: "Mobile verification modification",
  mode: "Mode",
  model: "Model",
  model_confirmed_reboot_soon: "Model confirmed, reboot soon.",
  moderate: "Moderate",
  mode_setup: "Mode setup",
  mode_switching_failed_due_to_no_mode_seled_or_incorrect_mode_sel:
    "Mode switching failed due to no mode selected or incorrect mode selected",
  modification_failed: "Modification failed",
  modify: "Modify",
  modify_alias: "Modify Alias",
  modify_all: "Modify all",
  modify_area: "Modify area",
  modify_cage: "Modify cage",
  modify_config: "Modify configuration",
  modify_data_permi: "Modify data permission",
  modify_department: "Modify department",
  modify_device_name: "Modify device name",
  modify_house: "Modify house",
  modify_map: "Modify map",
  modify_organization: "Modify organization",
  modify_point: "Modify point",
  modify_push_notification_personnel: "Modify push notification personnel",
  modify_pwd: "Modify Password",
  modify_role: "Modify role",
  modify_success: "Modified success",
  modify_template: "Modify template",
  modify_the_same_channel: "Modify the same channel",
  modify_this_point_only: "Modify this point only",
  modify_time: "Modifying Time",
  modify_user: "Modify user",
  module: "Module",
  module_temperature: "Module Temperature",
  monday: "Mon.",
  monitoring_description: "OpsDescription",
  monitoring_devices: "Monitoring devices",
  monitoring_device_details: "Monitoring Device Details",
  monitoring_end_time: "Monitoring end time",
  monitoring_frequency: "Monitoring frequency",
  monitoring_handling_time: "Monitoring handling time",
  monitoring_range_layer: "Monitoring Range Layer",
  monitoring_record: "Monitoring record",
  monitoring_records: "OpsRecord",
  monitoring_record_processing: "Monitoring record processing",
  monitoring_screen: "Monitoring screen",
  monitoring_start_time: "Monitoring start time",
  monitoring_type: "Monitoring type",
  month: "Month",
  monthly: "Monthly",
  monthly_alarm_count: "Monthly alarm count",
  more: "More",
  morning: "Morning",
  motion_detection: "Motion detection",
  motor: "Motor",
  motor_anomaly: "Motor anomaly",
  motor_information: "Motor information",
  motor_malfunction: "Motor malfunction",
  mounted_equipment: "Mounted equipment",
  mouse_follow: "Mouse follow",
  move_down: "Move Down",
  move_down_failed: "Move down failed.",
  move_failed: "Move failed.",
  move_to: "Move to...",
  move_to1: "Move to",
  move_up: "Move Up",
  move_up_failed: "Move up failed.",
  ms_word_required: "Note: MS-Word is required",
  multichannel: "multichannel",
  multi_frame_occurrence_confidence_threshold:
    "Multi-frame/occurrence confidence threshold",
  mute_alarm_sound: "Mute alarm sound.",
  mute_notifications: "Mute notifications",
  mute_notifications_setting_succeeded: "Mute notifications setting succeeded",
  mute_notifications_time: "Mute notifications time",
  muzzle_velocity: "Muzzle velocity",
  mysubmailcom: "mysubmail.com",
  my_coupon: "My coupon",
  my_equipment: "My equipment",
  my_order: "My Order",
  my_patrol: "My Patrol",
  my_view: "My View",
  m_serial: "M Serial",
  n1_an_inspection_task_is_being_delivered:
    "{n1} An inspection task is being delivered",
  n1_inspection_task_is_resuming: "{n1} inspection task is resuming",
  n1_inspection_task_is_re_executing: "{n1} inspection task is re-executing",
  n1_inspection_task_resumption_execution_failed_network_connectio:
    "{n1} inspection task resumption execution failed, network connection error",
  n1_inspection_task_resumption_succeeded:
    "{n1} inspection task resumption succeeded",
  n1_inspection_task_re_execution_failed_network_connection_error:
    "{n1} inspection task re-execution failed, network connection error",
  n1_inspection_task_re_execution_failed_robot_unresponsive:
    "{n1} inspection task re-execution failed, *robot unresponsive",
  n1_inspection_task_re_execution_succeeded:
    "{n1} inspection task re-execution succeeded",
  n1_the_inspection_task_fails_to_be_delivered_and_the_n2_robot_do:
    "{n1} The inspection task fails to be delivered and the {n2} robot does not respond",
  n1_the_inspection_task_fails_to_be_delivered_because_the_point_o:
    "{n1} The inspection task fails to be delivered because the point of the {n2} robot is inconsistent with the platform",
  n1_the_inspection_task_fails_to_be_restarted_because_the_n2_robo:
    "{n1} The inspection task fails to be restarted because the {n2} robot does not respond",
  n1_the_inspection_task_fails_to_be_restored_and_the_n2_robot_doe:
    "{n1} The inspection task fails to be restored, and the {n2} robot does not respond",
  n1_the_inspection_task_fails_to_be_terminated_and_the_n2_robot_d:
    "{n1} The inspection task fails to be terminated and the {n2} robot does not respond",
  n1_the_inspection_task_fails_to_be_terminated_because_the_networ:
    "{n1} The inspection task fails to be terminated because the network connection is abnormal",
  n1_the_inspection_task_is_delivered_successfully:
    "{n1} The inspection task is delivered successfully",
  n1_the_inspection_task_is_terminated:
    "{n1} The inspection task is terminated",
  n1_the_inspection_task_is_terminated_successfully:
    "{n1} The inspection task is terminated successfully",
  name: "Name",
  names_can_only_contain_chinese_characters_numbers_english_and_:
    'Names can only contain Chinese characters, numbers, English, "-", and "_"',
  name_already_exists: "Name already exists",
  name_already_exists_pls_enter_a_new_name:
    "Name already exists, please enter a new name.",
  name_is_required: "Name is required",
  name_must_be_less_than_10: "Name must be less than 10",
  national_sip_domain: "National SIP domain",
  navigate_to_this_location: "Navigate to this location",
  navigation_camera: "Navigation camera",
  navigation_camera_illuminator: "Navigation camera illuminator",
  navigation_camera_information: "Navigation camera information",
  navigation_point: "Navigation point",
  near_focus: "Near Focus",
  need_to_access_your_camera_to_capture_imgs:
    "Need to access your camera to capture images",
  need_your_permission_to_access_the_album:
    "Need your permission to access the album. If not, you will not be able to save pictures or videos to your local album",
  network_abnormal_login_failed: "Network abnormal, login failed",
  network_communication_error_xxx_inspection_task_generation_faile:
    "Network communication error, XXX inspection task generation failed",
  network_congestion: "Network Congestion",
  network_connection_timed_out: "Network connection timed out.",
  network_device: "Network Device",
  network_exception_pls_check_the_network_settings:
    "Network exception, please check the network settings",
  network_issue_download_interrupted: "Network issue,download interrupted",
  network_name: "Network Name",
  network_or_service_exception_pls_check_and_retry:
    "Network or Service Exception; Please Check and Retry.",
  network_setup: "Network Setup",
  network_status: "Network Status",
  never_end: "Never end",
  newdual_targetkb: "New-Dual Target-KB",
  newly_added_today: "Newly added today",
  newsingle_targetkb: "New-Single Target-KB",
  new_alarms_today: "Daily alarms",
  new_firmware_ver_detected_for_this_device_would_you_like_to_upgr:
    "New firmware version detected for this device. Would you like to upgrade?",
  new_name: "New name",
  new_page: "New Page",
  new_password_cannot_be_the_same_as_old_password:
    "New password cannot be the same as old password",
  new_pwd: "New Password",
  new_pwd_is_required: "New password is required",
  new_ver_exist: "New version exists",
  new_ver_found: "New version found",
  next: "Next",
  next_frame: "Next Frame",
  next_page: "Next Page",
  next_point: "Next point",
  nickname: "Nickname",
  nickname_not_set: "Nickname not set",
  night: "Night",
  no: "No",
  none: "None",
  non_administrators_cannot_add_linkage_strategies:
    "Non-administrators cannot add linkage strategies.",
  non_admin_users_cannot_del_linkage_strategies:
    "Non-admin users cannot delete linkage strategies.",
  non_armed_conflict_state_ships_and_aircraft:
    "Non-armed conflict state ships and aircraft",
  non_car: "Non-car",
  non_excavator: "Non-excavator",
  non_fire: "Non-Fire",
  non_laying_hens: "Non-laying hens",
  non_laying_hen_analysis: "Non-laying hen",
  non_preset: "Non-preset",
  non_productive_chicken_alarm: "Non-productive chicken alarm",
  non_standard_inf_file: "Non-standard infrared file",
  normal: "Normal",
  note: "Note",
  noteclick_this_button_then_click_on_the_map_to_draw_the_area:
    "Note:Click this button, then click on the map to draw the area.",
  note_excluding_coriolis_effect_from_calculations:
    "Note: Excluding Coriolis effect from calculations",
  note_if_you_want_to_add_new_personnel_and_alarm_sources_pls_set_:
    "Note: If you want to add new personnel and alarm sources, please set them on the modification page",
  note_the_robot_can_only_issue_one_loop_task_and_loop_tasks_canno:
    "Note: The robot can only issue one loop task, and loop tasks cannot coexist with scheduled tasks",
  notice: "Notice",
  notification_channel: "Notification channel",
  notification_channel_setting: "Notification channel setting",
  notification_method: "Notification method",
  notification_personnel: "Notification personnel",
  not_added: "Not Added",
  not_a_false_alarm: "Not a false alarm",
  not_binding_for_now: "Not binding for now",
  not_calibrated: "Not Calibrated",
  not_connected: "Not connected",
  not_connected_to_original_device: "Not connected to original device",
  not_executed: "Not executed",
  not_filled_in: "Not filled in",
  not_null: "Not null",
  not_online: "Not online",
  not_picked: "Not picked",
  not_supported: "Not Supported",
  not_upgrading_for_now: "Not upgrading for now",
  not_yet_added_temp_measurement_area:
    "Not yet added temperature measurement area",
  nov: "Nov",
  no_account: "No Account",
  no_alarm: "No alarm",
  no_alarms: "No alarms",
  no_anomaly: "No anomaly",
  no_available_channels_found_pls_check_the_device:
    "No available channels found, please check the device.",
  no_available_location_provider: "No available location provider",
  no_base_map: "No base map",
  no_column_currently_requires_synchronizing_age_in_days:
    "No column currently, requires synchronizing age in days",
  no_content: "No content",
  no_data: "No Data",
  no_data_available: "No data available",
  no_data_exported: "No data exported",
  no_data_reported_by_robot: "No data reported by robot",
  no_devices_connected: "No devices connected",
  no_devices_seled_or_devices_under_the_organization_not_loaded:
    "No devices selected or devices under the organization not loaded.",
  no_device_detected_if_no_device_is_connected_for_a_long_time_pls:
    "No device detected. If no device is connected for a long time, please check:",
  no_device_found_nearby: "No device found nearby",
  no_device_info: "No device info.",
  no_downloads_yet: "No downloads yet",
  no_file: "No file",
  no_files: "No files",
  no_files_selected: "No files selected",
  no_files_seled_for_download: "No files selected for download",
  no_flip: "No Flip",
  no_highlight: "No Highlight",
  no_image_to_analyze: "No image to analyze",
  no_inspection_points_in_the_map_associated_with_this_robot:
    "No points in the map associated with this robot",
  no_inspection_results: "No inspection results",
  no_inspection_tasks: "No inspection tasks",
  no_installation_permi: "No installation permission",
  no_linkage_chan: "No Linkage chan",
  no_linkage_strategy_information_found:
    "No linkage strategy information found.",
  no_more_data: "No more data",
  no_more_data_available: "No more data available",
  no_offline_information_for_this_device:
    "No offline information for this device",
  no_off_not_allowed_during_linkage_recording:
    "No/Off not allowed during linkage recording",
  no_other_streams: "No other streams",
  no_pdf: "No PDF",
  no_permission: "No permission",
  no_permi_to_access_this_video_stream_or_recording:
    "No permission to access this video stream or recording.",
  no_photo: "No image",
  no_photos_in_sd_card: "No photos in SD Card",
  no_playback: "No playback",
  no_preview: "No preview",
  no_preview_of_panoramic_window_found: "No preview of panoramic window found",
  no_processing_template: "No Processing Template",
  no_prompt: "No prompt",
  no_ptz_control_permi_pls_contact_the_administrator_for_config:
    "No PTZ control permission, please contact the administrator for configuration.",
  no_push_recipients: "No push recipients.",
  no_real_time_preview_permi_pls_contact_the_administrator_for_con:
    "No real-time preview permission, please contact the administrator for configuration.",
  no_recording: "No recording",
  no_relevant_locations_found: "No Relevant Locations Found",
  no_robot_associated: "No robot associated",
  no_rule: "No rule",
  no_sdcard: "NO SDCard",
  no_signal: "No Signal",
  no_snapshot: "No snapshot",
  no_statistics_data: "No statistics data",
  no_storage_permi: "No storage permission",
  no_strategies_submitted_ope_failed:
    "No strategies submitted, operation failed.",
  no_strategy_seled_for_deletion: "No strategy selected for deletion.",
  no_such_recording: "No such recording.",
  no_task_template: "No task template",
  no_task_templates_available: "No task templates available",
  no_temp_video_recording_in_visible_mode:
    "No temperature video recording  in visible mode",
  no_track_information_for_this_individual:
    "No track information for this individual",
  no_update_directory_detected: "No update directory detected",
  no_video: "No video",
  no_videos_during_the_seled_time_period:
    "No videos during the selected time period",
  ntp_port: "NTP port",
  ntp_time_calibration: "NTP time calibration",
  num: "Num",
  number_of_alarm_snapshots: "Number of alarm snapshots",
  number_of_bound_firearms: "Number of bound firearms",
  number_of_broken_eggs: "Number of broken eggs",
  number_of_cages_with_dead_chickens: "Number of cages with dead chickens",
  number_of_cage_columns: "Number of cage columns",
  number_of_chickens: "Number of chickens",
  number_of_chicken_cages: "Number of chicken cages",
  number_of_chicken_cage_layers: "Number of chicken cage layers",
  number_of_connected_devices: "Number of connected devices",
  number_of_dead_chicken_cages: "Number of dead chicken cages",
  number_of_eggs: "Number of eggs",
  number_of_eggs_produced: "eggs",
  number_of_failed_tasks_today: "Number of failed tasks today",
  number_of_failures: "Number of failures",
  number_of_laying_hens: "hens",
  number_of_online_devices: "Number of online devices",
  number_of_pigs: "Number of pigs",
  number_of_pigs_heads: "Number of pigs (heads)",
  number_of_tasks_completed_today: "Number of tasks completed today",
  number_of_times: "Number of times",
  number_order: "NO.",
  numeric_or_rate_val_cannot_be_empty: "Numeric or rate value cannot be empty",
  observation: "Observation",
  observation_distance: "Observation Distance",
  obsidian_black: "Obsidian Black",
  obtaining_device_config: "Obtaining device configuration",
  obtain_verification_code: "Obtain verification code",
  obtain_via_bluetooth_device: "Obtain via Bluetooth device",
  oct: "Oct",
  odometer_information: "Odometer information",
  odom_anomaly: "Odom anomaly",
  off: "Off",
  offline: "Offline",
  offline_analysis: "Offline Analysis",
  offline_analyzed_and_cannot_be_deleted:
    "It is being offline analyzed and cannot be deleted",
  offline_status_setting_failed: "Offline status setting failed",
  ok: "OK",
  old_password: "Old password",
  old_password_cannot_be_empty: "Old password cannot be empty",
  on: "On",
  once_only: "Once only",
  once_the_algorithm_judgment_begins_alarms_with_repeated_occurren:
    "Once the algorithm judgment begins, alarms with repeated occurrences equal to or less than [the threshold for repeated alarm times + this threshold] will be continuously triggered for AI recognition.",
  one_click_clear: "One-click clear",
  one_click_import: "One-click import",
  one_click_preview: "One-click Preview",
  one_click_return_to_charging_pile: "Retrun",
  one_click_return_to_charging_pile_failed:
    "One-click return to charging pile failed",
  one_cropping_task_is_running_do_you_want_to_exit_the_program:
    "One cropping task is running, do you want to exit the program",
  one_cropping_task_is_running_pls_wait:
    "One cropping task is running, please wait",
  one_week_ago: "One week ago",
  ongoing: "Ongoing",
  online: "Online",
  online_analysis: "Online Analysis",
  online_ratio: "Online Ratio",
  only_allow_drawing_areas_with_3_or_more_points:
    "Only allow drawing areas with 3 or more points.",
  only_available_in_inf_mode_except_for_black_hot_and_white_hot_ps:
    "Only available in infrared mode (except for black hot and white hot pseudo color)",
  only_csv_files_allowed: "Only CSV files allowed!",
  only_dead_chickens: "Only dead chickens",
  only_jpg_png_jpeg_files_can_be_uploaded_and_no_larger_than_500kb:
    "Only .jpg/.png/.jpeg files can be uploaded, and no larger than 500KB",
  only_numbers: "Only numbers",
  only_one_device_can_be_seled: "Only one device can be selected",
  only_one_file_can_be_renamed_at_a_time:
    "Only one file can be renamed at a time",
  only_one_image_can_be_shared_at_a_time:
    "Only one image can be shared at a time",
  only_today: "Only today",
  only_upload_imgs_in_jpg_jpeg_bmp_tif_png_formats:
    "Only upload images in jpg, jpeg, bmp, tif, png formats.",
  onvif_protocol: "ONVIF Protocol",
  on_site_pictures: "On-site pictures",
  opaque_plastic: "Opaque plastic",
  open: "Open",
  openid_error: "openId error",
  opening_bank: "Opening bank",
  open_a_local_file: "Open a local file",
  open_device: "Open device",
  open_device_for_firmware_upgrade: "Open device for firmware upgrade",
  open_directory: "Open Directory",
  open_factory_password: "Open factory password",
  open_failed: "Open failed",
  open_file: "Open file",
  open_file_failed: "Open file failed",
  open_folder: "Open Folder",
  open_source_component_license: "Open Source Component License",
  open_source_software_license: "Open Source Software License",
  open_source_software_licenses: "Open Source Software Licenses",
  open_wifi: "Open Wi-Fi",
  operating_channel_sel: "Operating channel selection",
  operation: "Operation",
  operation_temperature_range: "Operation Temperature Range",
  operator: "Operator",
  opes_are_too_frequent: "Operations are too frequent.",
  opes_center: "Operations Center",
  opes_information: "Operations information",
  opes_too_frequent_pls_try_again_later:
    "Operations too frequent, please try again later",
  ope_and_maintenance_management: "Operation and maintenance management",
  ope_and_maintenance_monitoring: "Malfunction",
  ope_and_maintenance_record: "Operation and maintenance record",
  ope_behavior: "Operation behavior",
  ope_details: "Operation details",
  ope_failed: "Operation failed",
  ope_information: "Operation information",
  ope_information_only_includes_the_robots_own_status_data_used_on:
    "Operation information only includes the robot's own status data, used only by maintenance personnel for troubleshooting, and will not be granted for other uses;",
  ope_logs: "Operation logs",
  ope_monitoring: "Operation monitoring",
  ope_permis: "Operation permissions",
  ope_prohibited: "Operation prohibited",
  ope_succeeded: "Operation succeeded",
  ope_time: "Operation time",
  ope_too_frequent_pls_try_again_later:
    "Operation too frequent, please try again later",
  optional: "Optional",
  opt_img: "Opt Image",
  order: "Order",
  order_appraise: "Order appraise",
  order_channel: "Order channel",
  order_info: "Order Info.",
  order_number: "Order Number",
  order_of_temp_rise_threshold_is_wrong:
    "Order of temp. rise threshold is wrong",
  order_of_temp_threshold_is_wrong: "Order of temp. threshold is wrong",
  order_status: "Order Status",
  ordinary_recording_mode: "Ordinary recording mode",
  organization: "Organization",
  organizational_settings: "Organizational settings",
  organization_administrator: "Organization administrator",
  organization_cannot_be_empty: "Organization cannot be empty",
  organization_does_not_exist_pls_download_the_latest_template:
    "Organization does not exist, please download the latest template.",
  organization_id: "Organization ID",
  organization_information: "Organization information",
  organization_name: "Organization Name",
  organization_name_cannot_be_empty: "Organization name cannot be empty",
  organization_name_must_be_letters_numbers_or_chinese_characters_:
    "Organization name must be letters, numbers, or Chinese characters, and no longer than 20 characters",
  organization_not_enabled_unable_to_log_in:
    "Organization not enabled, unable to log in",
  organization_remarks: "Organization remarks",
  organization_required: "Organization (Required)",
  organization_type: "Organization type",
  organization_type_error: "Organization type error",
  original_frame: "Original Frame",
  original_pwd: "Original Password",
  original_pwd_is_required: "Original password is required",
  osd: "OSD",
  oss_get_error: "OSS get error",
  other: "Other",
  other_features: "Other Features",
  other_img: "Other Image",
  other_reasons: "Other reasons",
  other_setting: "Other Settings",
  other_types: "Other types",
  outdoor: "Outdoor",
  outline: "Outline",
  overlay_traj_point_count: "Overlay Traj. Point Count",
  p: "P",
  page: "Page",
  page_permis: "Page permissions",
  palette: "Palette",
  panorama: "Panorama",
  panoramic_area_intrusion: "Panoramic area intrusion",
  panoramic_device_config: "Panoramic Device Config.",
  panoramic_event_popup: "Panoramic Event Popup",
  panoramic_popup_switch: "Panoramic popup switch",
  pan_angle: "Pan angle",
  pan_angle_must_be_an_integer_within_0_360:
    "Pan angle must be an integer within [0-360)",
  pan_tilt_control_failed: "Pan-tilt control failed.",
  pan_tilt_control_request_failed: "Pan-tilt control request failed.",
  pan_tilt_position_not_recorded_in_event_log:
    "Pan-tilt position not recorded in event log.",
  paper: "Paper",
  parameters: "Parameters",
  parameters_cannot_be_empty: "Parameters cannot be empty",
  parameters_cannot_be_repeated: "Parameters cannot be repeated",
  parameter_error: "Parameter error",
  parameter_missing_addition_failed: "Parameter missing, addition failed.",
  parameter_setting: "Parameter Setting",
  parameter_validation_failed: "Parameter validation failed.",
  parent_child_linkage: "Parent-child linkage",
  parent_department: "Parent department",
  parent_department_cannot_be_empty: "Parent department cannot be empty",
  parent_directory: "Parent directory",
  parent_menu: "Parent menu",
  passenger_ship: "Passenger ship",
  passwords_do_not_match: "Passwords do not match",
  passwords_entered_do_not_match: "Passwords entered do not match",
  password_changed_successfully: "Password changed successfully",
  password_changed_successfully_pls_log_in_again:
    "Password changed successfully, please log in again",
  password_format_should_be_letters_and_numbers_with_a_length_of_8:
    "Password format should be letters and numbers, with a length of 8~20 characters",
  password_length_is_less_than_10: "Password length is less than 10",
  password_login: "Password login",
  password_required: "Password (Required)",
  password_reset_successful: "Password reset successful",
  paste: "Paste",
  path: "Path",
  path_length_exceeds_256_characters: "Path length exceeds 256 characters",
  path_to_open_files: "Path to open files",
  patrol: "Patrol",
  patrol_fast_backward: "Patrol Fast Backward",
  patrol_fast_forward: "Patrol Fast Forward",
  patrol_track: "Patrol track",
  pause: "Pause",
  pause_manual_control: "Pause (manual control)",
  pause_patrol: "Pause Patrol",
  pause_recharging: "Pause (recharging)",
  pay: "Pay",
  payment_channel: "Payment channel",
  pay_success: "Pay success",
  pdf_library: "PDF library",
  pebble: "Pebble",
  pedestrian_animal_alarm: "Pedestrian/animal alarm",
  pedestrian_target_frame_display: "Pedestrian target frame display",
  pending_alarms: "Pending alarms",
  pending_outbound: "Pending outbound",
  pen_management: "Pen management",
  pen_name_must_be_numbers_or_chinese_characters_and_no_longer_tha:
    "Pen name must be numbers or Chinese characters, and no longer than 20 characters",
  periodic_time: "Periodic time",
  period_setting: "Period setting",
  permanent: "Permanent",
  permi_character: "Permission character",
  permi_character_cannot_be_empty: "Permission character cannot be empty",
  permi_character_must_be_chinese_characters_or_letters_and_no_lon:
    "Permission character must be Chinese characters or letters, and no longer than 20 characters",
  permi_config: "Permission configuration",
  permi_scope: "Permission scope",
  personal_information: "Personal information",
  personnel_coordinates: "Personnel coordinates",
  person_in_charge: "Person in charge",
  phone: "Phone",
  phone_number_cannot_be_empty: "Phone number cannot be empty",
  photos: "Photos",
  photo_interval: "Photo Interval",
  photo_setting: "Photo setting",
  photo_taken: "Photo Taken",
  picked: "Picked",
  pic_data_error: "Picture data error",
  piece: "Piece",
  pieces: "pieces",
  pieces_per_hen: "pieces/per hen",
  piece_cost: "Piece cost",
  piece_price: "Piece price",
  pigpen_details: "Pigpen details",
  pigsty_data_statistics: "Pigsty data statistics",
  pigsty_management: "Pigsty management",
  pig_age_in_days: "Pig age in days",
  pig_temp_measurement: "Pig temperature measurement",
  "pig_temp_threshold_℃": "Pig temperature threshold (℃)",
  pilot_boat: "Pilot boat",
  pip: "PIP",
  pip_adjustment: "PIP Adjustment",
  pip_mode: "PIP mode",
  pip_settings: "PIP settings",
  pitch: "Pitch",
  pitch_angle: "Pitch angle",
  pitch_angle_information: "Pitch Angle Information",
  pitch_angle_must_be_an_integer_within_90_90:
    "Pitch angle must be an integer within [-90,90]",
  pitch_angle_n_offset: "Pitch Angle {n} Offset",
  pitch_angle_offset: "Pitch angle offset",
  pixel: "Pixel",
  place_the_crosshair_on_the_target_and_click_confirm:
    'Place the crosshair on the target and click "Confirm"',
  plain_text: "Plain Text",
  plan_name_required: "Plan name required",
  plan_type: "Plan Type",
  plastic_pvc: "Plastic(PVC)",
  platform_authorization: "Platform authorization",
  platform_cascading: "Platform Cascading",
  platform_name: "Platform name",
  platform_name_settings: "Platform name settings",
  platform_national_code_settings: "Platform national code settings",
  platform_terminates_inspection_task: "Platform terminates inspection task",
  play: "Play",
  playback: "Playback",
  playback_ended: "Playback ended",
  playback_error: "Playback error",
  playback_failed_pls_refresh_and_load_again:
    "Playback failed, please refresh and load again",
  playback_history: "Playback History",
  playback_speed: "Playback speed",
  playback_start_failed: "Playback start failed",
  playback_timeout: "Playback timeout.",
  play_audio: "Play audio",
  play_failed: "Play failed",
  play_list: "Play List",
  please_calibrate_the_device: "Please calibrate the device",
  please_enter_a_network_name: "Please enter a network name",
  please_enter_file_name: "Please enter file name",
  please_select_a_picture_or_video_to_delete:
    "Please select a picture or video to delete",
  please_wait: "Please  wait",
  pls_add_at_least_one_view: "Please add at least one view.",
  pls_add_channel: "Please add channel.",
  pls_add_preset: "Please add preset.",
  pls_add_the_inspection_action_list: "Please add the inspection action list",
  pls_add_view: "Please add view",
  pls_check_network_connection: "Please check network connection",
  pls_check_the_mobile_hotspot_and_the_device_connection_status:
    "Please check the mobile hotspot and the device connection status",
  pls_check_the_network_connection: "Please check the network connection",
  pls_check_the_path: "Please check the path",
  pls_check_the_sms_platform: "Please check the SMS platform",
  pls_check_your_network_and_try_connecting_again:
    "Please check your network and try connecting again",
  pls_choose_associated_ir_img: "Please choose associated IR image",
  pls_clear_device_channels_first: "Please clear device channels first.",
  pls_click_here_to_complete_the_shipping_address:
    "Please click here to complete the shipping address",
  pls_click_the_settings_button_to_add_a_channel:
    "Please click the [Settings] button to add a channel",
  pls_complete_the_information: "Please complete the information",
  pls_complete_the_shipping_address: "Please complete the shipping address",
  pls_confirm_information_modification:
    "Please confirm information modification.",
  pls_confirm_the_password: "Please confirm the password",
  pls_confirm_whether_to_modify_the_encryption_type:
    "Please confirm whether to modify the encryption type.",
  pls_confirm_whether_to_modify_the_wifi_name:
    "Please confirm whether to modify the Wi-Fi name.",
  pls_confirm_whether_to_modify_the_wifi_password:
    "Please confirm whether to modify the Wi-Fi password.",
  pls_connect_the_device: "Please connect the device",
  pls_connect_the_device_first: "Please connect the device first",
  pls_connect_the_hotspot_first: "Please connect the hotspot first",
  pls_contact_the_administrator_to_assign_roles:
    "Please contact the administrator to assign roles.",
  pls_del_after_sel: "Please delete after selection",
  pls_del_device_first: "Please delete device first",
  pls_disable_isotherm_function_first: "Please disable isotherm function first",
  pls_end_the_stated_tasks_first: "Pls end the stated tasks first",
  pls_end_the_tasks_in_electric_mode_first:
    "Pls end the tasks in electric mode first",
  pls_end_the_tasks_in_general_mode_first:
    "Pls end the tasks in general mode first",
  pls_ensure_device_battery_and_storage_space_are_sufficient:
    "Please ensure device battery and storage space are sufficient",
  pls_ensure_you_are_connected_to_the_devices_wifi_network:
    "Please ensure you are connected to the device's Wi-Fi network",
  pls_enter_abbreviation: "Please enter abbreviation",
  pls_enter_account_name: "Please enter account name",
  pls_enter_administrator: "Please enter administrator",
  pls_enter_alarm_device: "Please enter alarm device",
  pls_enter_an_email: "Please enter an email",
  pls_enter_associated_cage_number: "Please enter associated cage number",
  pls_enter_associated_column_number: "Please enter associated column number",
  pls_enter_associated_point: "Please enter associated point",
  pls_enter_associated_task: "Please enter associated task",
  pls_enter_a_channel_name: "Please enter a channel name.",
  pls_enter_a_correct_email_address: "Please enter a correct email address.",
  pls_enter_a_mac: "Please enter a MAC.",
  pls_enter_a_name: "Please enter a name",
  pls_enter_a_new_device_name: "Please enter a new device name",
  pls_enter_a_new_password: "Please enter a new password",
  pls_enter_a_new_wifi_name: "Please enter a new Wi-Fi name.",
  pls_enter_a_valid_email_address: "Please enter a valid email address",
  pls_enter_a_valid_phone_number: "Please enter a valid phone number",
  pls_enter_a_valid_value: "Please enter a valid value",
  pls_enter_browser_time: "Please enter browser time",
  pls_enter_building_name: "Please enter building",
  pls_enter_bullet_name: "Please enter bullet name",
  pls_enter_bullet_notes: "Please enter bullet notes",
  pls_enter_cage_name: "Please enter cage name",
  pls_enter_cage_number: "Please enter cage number",
  pls_enter_contact_information: "Please enter contact information",
  pls_enter_contact_number: "Please enter contact number",
  pls_enter_content: "Please enter content",
  pls_enter_correct_latitude_and_longitude:
    "Please Enter Correct Latitude and Longitude",
  pls_enter_database_table: "Please enter database table",
  pls_enter_data_permi_field: "Please enter data permission field",
  pls_enter_data_permi_name: "Please enter data permission name",
  pls_enter_data_permi_remarks: "Please enter data permission remarks",
  pls_enter_day_age: "Please enter day age",
  pls_enter_department_name: "Please enter department name",
  pls_enter_device_name: "Please enter device name",
  pls_enter_dictionary_label: "Please enter dictionary label",
  pls_enter_dictionary_name: "Please enter dictionary name",
  pls_enter_disposal_opinion: "Please enter disposal opinion",
  pls_enter_distance_from_origin: "Please enter distance from origin",
  pls_enter_firearm_name: "Please enter firearm name",
  pls_enter_firearm_notes: "Please enter firearm notes",
  pls_enter_handler: "Please enter handler",
  pls_enter_house_name: "Please enter house name",
  pls_enter_inspection_point: "Please enter inspection point",
  pls_enter_integers_1_2: "Pls enter integers %1~%2",
  pls_enter_ip_address: "Please enter IP address",
  pls_enter_keywords: "Please Enter Keywords",
  pls_enter_lift_height: "Please enter lift height",
  pls_enter_map_name: "Please enter map name",
  pls_enter_monitoring_device: "Please enter monitoring device",
  pls_enter_new_phone_number: "Please enter new phone number",
  pls_enter_ntp_port: "Please enter NTP port",
  pls_enter_numbers_between_1_2: "Pls enter numbers between %1 and %2",
  pls_enter_number_of_cage_columns: "Please enter number of cage columns",
  pls_enter_number_of_cage_layers: "Please enter number of cage layers",
  pls_enter_number_of_cage_rows: "Please enter number of cage rows",
  pls_enter_old_password: "Please enter old password",
  pls_enter_operator: "Please enter operator",
  pls_enter_organization_name: "Please enter organization name",
  pls_enter_password: "Please enter password",
  pls_enter_pen_name: "Please enter pen name",
  pls_enter_permi_character: "Please enter permission character",
  pls_enter_person_in_charge: "Please enter person in charge",
  pls_enter_phone_number: "Please enter phone number",
  pls_enter_point_name: "Please enter point name",
  pls_enter_point_type: "Please enter point type",
  pls_enter_port: "Please enter port",
  pls_enter_reason_description: "Please enter reason description",
  pls_enter_remarks: "Please enter remarks",
  pls_enter_remarks_no_more_than_100_characters:
    "Please enter remarks, no more than 100 characters",
  pls_enter_report_title: "Please enter report title",
  pls_enter_resource_id: "Please enter resource ID",
  pls_enter_resource_type: "Please enter resource type.",
  pls_enter_robot: "Please enter robot",
  pls_enter_robot_model: "Please enter robot model",
  pls_enter_robot_name: "Please enter robot name",
  pls_enter_robot_name_or_channel_name_to_filter:
    "Please enter robot name or channel name to filter",
  pls_enter_robot_type: "Please enter robot type",
  pls_enter_role_name: "Please enter role name",
  pls_enter_scope_notes: "Please enter scope notes",
  pls_enter_server_address: "Please enter server address",
  pls_enter_sn_code: "Please enter SN code",
  pls_enter_task_name: "Please enter task name",
  pls_enter_text_content: "Please enter text content",
  pls_enter_the_admin_username_to_create:
    "Please enter the admin username to create",
  pls_enter_the_affiliated_map: "Please enter the affiliated map",
  pls_enter_the_affiliated_robot: "Please enter the affiliated robot",
  pls_enter_the_area_code: "Please enter the area code.",
  pls_enter_the_association_name_up_to_50_characters:
    "Please enter the association name, up to 50 characters",
  pls_enter_the_column_number: "Please enter the column number",
  pls_enter_the_correct_verification_code:
    "Please enter the correct verification code.",
  pls_enter_the_graphic_verification_code:
    "Please enter the graphic verification code",
  pls_enter_the_missed_cage_position_in_the_order_of_column_cage_a:
    "Please enter the missed cage position in the order of column, cage, and layer, for example, 3, 2, 1 corresponds to 3rd column, 2nd cage, 1st layer",
  pls_enter_the_new_password_again: "Please enter the new password again",
  pls_enter_the_password_again: "Please enter the password again",
  pls_enter_the_shielded_area_name: "Please enter the shielded area name.",
  pls_enter_the_sms_verification_code: "Please enter the SMS verification code",
  pls_enter_the_template_name: "Please enter the template name",
  pls_enter_the_template_name_first: "Please enter the template name first",
  pls_enter_the_users_name_not_exceeding_20_characters:
    "Please enter the user's name, not exceeding 20 characters",
  pls_enter_the_verification_code: "Please enter the verification code",
  pls_enter_title: "Please enter title",
  pls_enter_username: "Please enter username",
  pls_enter_users_name: "Please enter user's name",
  pls_enter_user_entity_corresponding_field:
    "Please enter user entity corresponding field",
  pls_enter_user_table_corresponding_field:
    "Please enter user table corresponding field",
  pls_enter_verification_code: "Please enter verification code",
  pls_enter_wifi_name: "Please enter Wi-Fi name",
  pls_enter_your_account: "Please enter your account",
  pls_enter_your_mobile_number: "Please enter your mobile number",
  pls_enter_your_new_password: "Please enter your new password",
  pls_enter_your_original_password: "Please enter your original password",
  pls_enter_your_password: "Please enter your password",
  pls_exit_account: "please exit account",
  pls_fill_in_a_description_of_more_than_10_characters_so_that_we_:
    "Please fill in a description of more than 10 characters so that we can provide better assistance.",
  pls_fill_in_the_angle_val: "Please fill in the angle value",
  pls_fill_in_the_manufacturer: "Please fill in the manufacturer",
  pls_fill_in_the_remarks: "Please fill in the remarks",
  pls_follow_the_path_below_to_modify_the_mobile_hotspots_password:
    "Please follow the path below to modify the mobile hotspot's password to match the device: Settings - Personal Hotspot - Enable Allow Others to Join - Modify Wi-Fi Password",
  pls_go_to_the_area_settings_module_to_add_an_area:
    "Please go to the area settings module to add an area",
  pls_import_task_template: "Please import task template",
  pls_include_deviceid_in_request_parameters:
    "Please include deviceId in request parameters",
  pls_input: "Please input",
  pls_input_account: "Please input account",
  pls_input_correct_phone_number: "Please input correct phone number",
  pls_input_details: "Please input details",
  pls_input_phone_number: "Please input phone number",
  pls_input_price: "Please input price",
  pls_input_pwd: "Please input password",
  pls_input_sequence: "Please input sequence",
  pls_input_serial_number: "Please input serial number",
  pls_input_the_calibrated_temp: "Please input the calibrated temperature",
  pls_input_the_new_name: "Please input the new name",
  pls_keep_the_device_on: "Please keep the device on",
  pls_keep_this_page_open_during_the_upgrade_and_do_not_put_the_ap:
    "Please keep this page open during the upgrade and do not put the app in the background.",
  pls_light_the_star: "Please light the star",
  pls_login_first: "please login first",
  pls_log_in_the_cloud_first: "Please log in the cloud first",
  pls_operate_after_stop_recording: "Please operate after stop recording",
  pls_plug_in_the_device: "Please plug in the device",
  pls_press_again_to_exit: "Please press again to exit",
  pls_read_carefully_and_agree_to_the_following_terms:
    "Please read carefully and agree to the following terms",
  pls_remove_all_patrols_under_this_group_before_deleting_the_grou:
    "Please remove all patrols under this group before deleting the group.",
  pls_remove_all_views_under_this_group_before_deleting_the_group:
    "Please remove all views under this group before deleting the group.",
  pls_renew_it_promptly: "Please renew it promptly",
  pls_scan_qr_code: "Please scan QR code",
  pls_sel: "Please select",
  pls_select_a_file: "Please select a file",
  pls_select_device_first: "Please select device first",
  pls_select_first: "Please select first",
  pls_select_media_first: "Please select photos or videos first",
  pls_select_the_device_model: "Please select the device model",
  pls_select_the_file_to_analyze_first:
    "Please select the file to analyze first",
  pls_select_time_type_again:
    "Please select start time and end time type again",
  pls_sel_alarm_name: "Please select alarm name.",
  pls_sel_alarm_name_and_export_by_type:
    "Please select alarm name and export by type.",
  pls_sel_alarm_name_query__export_by_type:
    "Please select alarm name, query & export by type.",
  pls_sel_alarm_source: "Please select alarm source.",
  pls_sel_alarm_type: "Please select alarm type.",
  pls_sel_an_alarm_item: "Please select an alarm item",
  pls_sel_an_organization: "Please select an organization",
  pls_sel_a_file_to_download: "Please select a file to download",
  pls_sel_a_robot: "Please select a robot",
  pls_sel_a_type: "Please select a type",
  pls_sel_category: "Please select category",
  pls_sel_channel: "Please select channel",
  pls_sel_channels_under_the_robot: "Please select channels under the robot",
  pls_sel_data_permi_type: "Please select data permission type",
  pls_sel_date: "Please select date",
  pls_sel_device_type: "Please select device type",
  pls_sel_end_action: "Please select end action",
  pls_sel_execution_frequency: "Please select execution frequency",
  pls_sel_execution_method: "Please select execution method",
  pls_sel_execution_strategy: "Please select execution strategy",
  pls_sel_fee_mode: "Please select Fee Mode",
  pls_sel_file_format: "Please select file format",
  pls_sel_inspection_point: "Please select inspection point",
  pls_sel_inspection_result: "Please select inspection result",
  pls_sel_layout: "Please select layout.",
  pls_sel_linkage_action: "Please select linkage action",
  pls_sel_linkage_channel: "Please select linkage channel",
  pls_sel_monitoring_type: "Please select monitoring type",
  pls_sel_notification_personnel: "Please select notification personnel.",
  pls_sel_point_type: "Please select point type",
  pls_sel_preview_channel: "Please select preview channel",
  pls_sel_region_first: "Please select region first",
  pls_sel_start_time: "Please select start time",
  pls_sel_statistics_rule: "Please select statistics rule",
  pls_sel_system_time: "Please select system time",
  pls_sel_target_location_first: "Please select target location first",
  pls_sel_target_point: "Please select target point",
  pls_sel_task_status: "Please select task status",
  pls_sel_the_alarm_frequency: "Please select the alarm frequency",
  pls_sel_the_alarm_level: "Please select the alarm level",
  pls_sel_the_alarm_reason: "Please select the alarm reason",
  pls_sel_the_alarm_status: "Please select the alarm status",
  pls_sel_the_associated_map: "Please select the associated map",
  pls_sel_the_associated_robot: "Please select the associated robot",
  pls_sel_the_charging_point: "Please select the charging point",
  pls_sel_the_chicken_coop_first: "Please select the chicken coop first",
  pls_sel_the_device_again_for_a_wifi_connection_if_the_connection:
    "Please select the device again for a Wi-Fi connection. If the connection fails, it is recommended that you reboot the device.",
  pls_sel_the_inspection_record: "Please select the inspection record",
  pls_sel_the_record_status: "Please select the record status",
  pls_sel_the_target_inspection_point:
    "Please select the target inspection point",
  pls_sel_the_user_to_unbind: "Please select the user to unbind",
  pls_sel_time: "Please select time",
  pls_share_after_wifi_enabled: "Please share after Wi-Fi enabled",
  pls_switch_device_network: "Please switch device network",
  pls_try_again_in_good_network_condition:
    "Please try again in good network condition",
  pls_try_again_later: "Please try again later.",
  pls_turn_on_wifi: "Please turn on WiFi",
  pls_unbind_the_firearm_before_deleting:
    "Please unbind the firearm before deleting",
  pls_wait: "Please wait",
  pn_and_sn_is_required: "PN and SN is required",
  pn_sn_exists: "PN/SN exists",
  point: "Point",
  point_associated_with_inspection_template_deletion_failed:
    "Point associated with inspection template, deletion failed",
  point_does_not_exist: "Point does not exist",
  point_exists_in_unfinished_tasks_deletion_failed:
    "Point exists in unfinished tasks, deletion failed",
  point_information: "Point information",
  point_invalid_belonging_map_has_been_deld:
    "Point invalid, belonging map has been deleted",
  point_list: "Point list",
  point_management: "Point management",
  point_name: "Point name",
  point_name_already_exists_pls_modify_and_try_again:
    "Point name already exists, please modify and try again",
  point_name_cannot_be_empty: "Point name cannot be empty",
  point_name_should_consist_of_letters_numbers_or_chinese_characte:
    "Point name should consist of letters, numbers, or Chinese characters, and should not exceed 20 characters",
  point_not_associated: "Point not associated",
  point_order: "Point order",
  point_status_update_failed: "Point status update failed",
  point_sync_failed: "Point sync failed",
  point_sync_failed_network_connection_error:
    "Point sync failed, network connection error",
  point_sync_successful: "Point sync successful",
  point_type: "Point type",
  polish: "Polish",
  polished_aluminium_or_aluminum_foil: "Polished aluminium or aluminum foil",
  polished_cast_iron: "Polished cast iron",
  polygon: "Polygon",
  port: "Port",
  port_is_required: "Port is required",
  port_number: "Port number",
  port_number_must_be_numeric: "Port number must be numeric",
  port_range_1_65535: "Port range 1-65535",
  port_required: "Port (Required)",
  port_supply_vessel: "Port supply vessel",
  positioning_3d: "3D positioning",
  positioning_3d_failed: "3D positioning failed.",
  position_reset: "Position reset",
  power: "Power",
  power_supply: "Power Supply",
  preset: "Preset",
  preset_name: "Preset name",
  preset_name_for_this_channel_already_exists_pls_choose_another_n:
    "Preset name for this channel already exists, please choose another name.",
  preset_number: "Preset number",
  preset_patrol_plan_setting_failed: "Preset patrol plan setting failed.",
  preset_tour: "Preset tour",
  press_back_button_to_quit: "press back button to quit",
  press_enter_to_search: "Press Enter to search",
  preview: "Preview",
  preview_failed: "Preview failed",
  preview_module: "Preview Module",
  preview_not_supported: "Preview not supported.",
  preview_playback: "Preview & Playback",
  previous: "Previous",
  previous_frame: "Previous Frame",
  previous_inspection_task_not_completed:
    "Previous inspection task not completed",
  previous_page: "Previous Page",
  previous_point: "Previous point",
  previous_task_incomplete: "Previous task incomplete",
  pre_upload_failed: "Pre upload failed",
  price: "Price",
  primary_server_status: "Primary Server Status",
  privacy_agreement: "Privacy agreement",
  privacy_policy: "Privacy Policy",
  process: "Process",
  processed: "Processed",
  processed_or_not: "Processed or not",
  processing: "Processing",
  processing_cast_iron: "Processing cast iron",
  processing_comments: "Processing Comments",
  processing_comments_cannot_be_empty: "Processing comments cannot be empty.",
  processing_failed: "Processing Failed",
  processing_time: "Processing Time",
  processing_user: "Processing User",
  production_data: "Production data",
  production_report: "Production report",
  production_report_statistics: "Production report statistics",
  production_statistics: "Production statistics",
  product_: "Product ID",
  product_added_to_your_cart: "Product added to your cart",
  product_collection: "Product collection",
  product_does_not_exist: "Product does not exist",
  product_info: "Product Info.",
  product_list: "Product List",
  product_name: "Product name",
  product_number: "Product Number",
  product_temp: "Product Temp.",
  profile: "Personal Center",
  progress: "Progress",
  prompt: "Prompt",
  proprietary_protocol: "Proprietary protocol",
  protocol: "Protocol",
  province: "Province",
  pseudo_color_config_not_possible_for_the_current_channel:
    "Pseudo-color configuration not possible for the current channel.",
  pseudo_color_settings_not_supported_for_the_current_channel:
    "Pseudo-color settings not supported for the current channel.",
  ptz_adjustment: "PTZ adjustment",
  ptz_angle: "PTZ Angle",
  ptz_commands: "PTZ commands",
  ptz_control: "PTZ Control",
  ptz_control_failed: "PTZ control failed.",
  ptz_mode: "PTZ mode",
  ptz_pitch_angle: "PTZ Pitch Angle",
  ptz_reset: "PTZ Reset",
  ptz_sensitivity: "PTZ Sensitivity",
  ptz_settings: "PTZ Settings",
  ptz_tracking_failed: "PTZ tracking failed",
  public_patrol: "Public Patrol",
  public_view: "Public View",
  pull_down_to_refresh: "Pull down to refresh",
  pull_up_to_load: "Pull up to load",
  pull_up_to_show_more: "Pull up to show more",
  puor: "PuOr",
  purchase_type: "Purchase type",
  push_area: "Push Area",
  push_config_settings_succeeded: "Push configuration settings succeeded",
  push_notification_settings: "Push Notification Settings",
  push_successful: "Push successful.",
  pwd: "Password",
  pwd_cannot_be_empty: "Password cannot be empty",
  pwd_combination_rules_8_16:
    "8-16 chart combination of numbers, capital and lower-case letters",
  pwd_confirm_is_required: "Password confirmation is required",
  pwd_control: "Password Control",
  pwd_error: "password error",
  pwd_inconformity: "Password inconformity",
  p_serial: "P Serial",
  qa: "Q&A",
  qr_code: "QR Code",
  qr_code_number: "QR code number",
  qr_code_point: "QR code point",
  qr_code_point_retrieval_failed: "QR code point retrieval failed",
  qr_code_point_retrieval_successful: "QR code point retrieval successful",
  quantity: "Quantity",
  quantity_up_to_limit: "Quantity up to limit",
  query: "Query",
  query_current_robot_inspection_progress_successful:
    "Query current robot inspection progress successful",
  query_record_is_empty: "Query record is empty.",
  query_time: "Query Time",
  questions_and_comments: "Questions and Comments",
  questions_and_suggestions: "Questions and Suggestions",
  quick_guide: "Quick  Start Guide",
  quick_input: "Quick input",
  quick_report: "Quick Report",
  quick_report_completed: "Quick report completed",
  quick_report_failed: "Quick report failed",
  quit_alarm_snapshot: "Quit alarm snapshot",
  quit_editing: "Quit editing",
  quit_the_inspection_task: "Quit the inspection task",
  quit_timelapsed_image_capture: "Quit timelapsed image capture",
  radar: "Radar",
  radar_chart: "Radar Chart",
  radar_malfunction: "Radar malfunction",
  rail_robot: "Rail robot",
  rainbow: "Rainbow",
  rainbow_hc: "Rainbow HC",
  random: "Random",
  range: "Range",
  rangefinder: "Rangefinder",
  rangefinding: "Rangefinding",
  rangefinding_for_p2: "Rangefinding for P2",
  range_inner: "Range Inner",
  range_outer: "Range Outer",
  raythink: "RayThink",
  rdgy: "RdGy",
  read: "Read",
  reading_files: "Reading files",
  ready: "Ready",
  read_files: "Read files",
  read_status: "Read Status",
  realtime_alarm: "Real-time Alarm",
  real_name: "Real Name",
  real_name_cannot_be_empty: "Real name cannot be empty",
  real_time: "Real-Time",
  real_time_data: "Real-time Data",
  real_time_temp_curve: "Real Time Temp. Curve",
  rear_radar: "Rear radar",
  rear_radar_anomaly: "Rear radar anomaly",
  rear_radar_information: "Rear radar information",
  reason: "Reason",
  reauthorize: "Reauthorize",
  rebuild_cache: "Rebuild Cache",
  receiving_email: "Receiving Email",
  receiving_failed: "Receiving failed",
  recently_used_devices: "Recently used devices",
  recent_alarm_time: "Recent Alarm Time",
  recent_trigger_time: "Recent trigger time",
  recognition_distance: "Recognition Distance",
  recognition_failed: "Recognition failed.",
  recognition_result: "Recognition result",
  recognition_successful: "Recognition successful.",
  recommended_size: "Recommended size",
  reconnect: "Reconnect",
  reconnecting: "Reconnecting",
  reconnect_failed: "Reconnect failed",
  record: "Record",
  recording: "Recording",
  recordings: "Recording(s)",
  recording_directory: "Recording Directory",
  recording_failed: "Recording failed",
  recording_file: "Recording File",
  recording_file_duration: "Recording file duration",
  recording_method: "Recording method",
  recording_pause: "Recording pause",
  recording_plan_deld_successfully: "Recording plan deleted successfully.",
  recording_plan_deletion_failed: "Recording plan deletion failed.",
  recording_plan_disabled_successfully: "Recording plan disabled successfully.",
  recording_plan_enabled_successfully: "Recording plan enabled successfully.",
  recording_plan_is_in_progress_cannot_be_deld:
    "Recording plan is in progress, cannot be deleted.",
  recording_plan_time_conflicts_with_0:
    "Recording plan time conflicts with: {0}",
  recording_plan_update_failed: "Recording plan update failed.",
  recording_playback_ended: "Recording playback ended",
  recording_pls_try_again_later: "Recording, please try again later",
  recording_saved_successfully: "Recording saved successfully.",
  recording_save_failed: "Recording save failed.",
  recording_source_platform: "Recording source: platform",
  recording_succeeded: "Recording succeeded",
  recording_type: "Recording Type",
  recording_video_save_and_exit: "Recording video, save and exit",
  record_does_not_exist: "Record does not exist.",
  record_from_d1_to_d2: "Record from d1 to d2",
  record_status: "Record status",
  record_the_min_storage_time: "Record the minimum  storage time",
  record_video: "Record Video",
  rectangle: "Rectangle",
  recurring_task: "Recurring task",
  red: "Red",
  reddish_brown: "Reddish brown",
  redhot: "Redhot",
  redis_server_exception: "Redis server exception.",
  redownload: "Redownload",
  red_brick: "Red brick",
  red_shades: "Red Shades",
  reflected_temp: "Reflected Temp.",
  reflected_temp_is_out_of_range: "Reflected temp. is out of range",
  reflected_temp_is_required: "Reflected temp. is required",
  refresh: "Refresh",
  refreshing: "Refreshing",
  refreshing_list: "Refreshing list",
  refresh_alarm_subscription: "Refresh alarm subscription",
  refresh_cloud_platform_ip: "Refresh cloud platform IP",
  refresh_completed: "Refresh completed",
  refresh_device: "Refresh device",
  refresh_failed: "Refresh failed",
  refresh_map: "Refresh map",
  refresh_successful: "Refresh successful",
  refresh_the_list: "Refresh the list",
  refresh_user_permissions: "Refresh user permissions",
  refund: "Refund",
  refunding: "Refunding",
  refund_and_service: "Refund&Service",
  refund_success: "Refund Success",
  region: "Region",
  regional_statistics: "Regional Statistics",
  region_config: "Region Configuration",
  region_io: "Region IO",
  region_linkage: "Region Linkage",
  region_name: "Region Name",
  region_number: "Region number",
  region_number_reach_limit: "Region Number reach limit",
  region_or_font_color: "Region & Font color",
  region_qty_less_than: "Region num <",
  region_temp: "Region Temp.",
  region_thermometry: "Region thermometry",
  region_type: "Region type",
  register: "Register",
  registered_password: "Registered password",
  registration: "Registration",
  regular_devices: "Regular Devices",
  reg_now: "Register Now",
  reissue: "Reissue",
  related_records: "Related records",
  relative_time: "Relative time",
  relay: "relay",
  release_to_load: "Release to load",
  release_to_refresh: "Release to refresh",
  release_to_start_loading_data: "Release to start loading data",
  relocation_completed: "Relocation completed",
  relocation_failed: "Relocation failed",
  remaining_unexecuted_point_count: "remaining unexecuted point count:",
  remaining_valid_duration: "Remaining Valid Duration",
  remarks: "Remarks",
  remarks_cannot_exceed_100_characters: "Remarks cannot exceed 100 characters",
  remarks_should_not_exceed_100_characters:
    "Remarks should not exceed 100 characters",
  remember_information: "Remember information",
  reminder_for_driving_distance: "Reminder for driving distance",
  reminder_for_front_vehicle_start: "Reminder for front vehicle start",
  reminder_for_starting_distance: "Reminder for starting distance",
  remind_me_later: "Remind me later",
  remote_battery_capacity: "Remote battery capacity",
  remote_device: "Remote Device",
  remote_device_control_live_img_view: "Remote device control, live image view",
  remote_files: "Remote files",
  remote_gallery: "Remote gallery",
  removal_successful: "Removal successful",
  remove: "Remove",
  remove_coriolis_effect: "Remove Coriolis Effect",
  remove_robot: "Remove robot",
  remove_target_failed: "Remove target failed.",
  rename: "Rename",
  renting: "Renting",
  repeated_alarm_count: "Repeated Alarm Count",
  repeated_alarm_n_times: "Repeated alarm {n} times",
  repeat_count: "Repeat Count",
  repeat_event_alarm_interval: "Repeat event alarm interval",
  report_designer: "Report Designer",
  report_downloaded_successfully: "Report downloaded successfully",
  report_download_failed: "Report download failed",
  report_export_failed: "Report export failed",
  report_generating: "Report generating",
  report_generation_time: "Report generation time",
  report_has_been_downloaded: "Report has been downloaded",
  report_info: "Report Info.",
  report_loading: "Report loading",
  report_number: "Report number",
  report_template_settings: "Report Template Settings",
  report_title: "Report Title",
  report_to_center: "Report To Center",
  report_type: "Report type",
  reposition: "Reposition",
  requesting: "Requesting",
  request_canceled: "Request canceled",
  request_error: "Request error.",
  reset: "Reset",
  reset_alarm: "Reset Alarm",
  reset_alarm_failed: "Reset alarm failed.",
  reset_failed: "Reset Failed",
  reset_password: "Reset password",
  reset_successful: "Reset Successful",
  reset_to_default_successful: "Reset to default successful",
  resolution: "Resolution",
  resolved: "Resolved",
  resource: "Resource",
  resource_id: "Resource ID",
  resource_id_cannot_be_empty: "Resource ID cannot be empty",
  resource_import_file_is_empty: "Resource import file is empty.",
  resource_import_template_generation_failed:
    "Resource import template generation failed.",
  resource_information_management: "Resource Information Management",
  resource_layer: "Resource Layer",
  resource_management: "Resource Management",
  resource_name: "Resource Name",
  resource_name_already_exists: "Resource name already exists",
  resource_name_cannot_be_empty: "Resource name cannot be empty",
  resource_name_only_allows_chinese_characters_numbers_english:
    "Resource name only allows Chinese characters, numbers, English, “-” and “_”",
  resource_name_required_name_must_be_unique:
    "Resource Name (Required, name must be unique)",
  resource_type: "Resource Type",
  resource_type_cannot_be_empty: "Resource type cannot be empty",
  resource_type_name_only_allows_chinese_characters_numbers_englis:
    "Resource type name only allows Chinese characters, numbers, English, “-” and “_”",
  resource_type_required: "Resource Type (Required)",
  restart: "Restart",
  restart_successful: "Restart successful",
  restart_the_robot: "Restart the robot",
  restart_to_take_effect: "Restart to take effect",
  restore: "Restore",
  restore_default: "Restore default",
  restore_factory_settings: "Restore Factory Settings",
  restore_task: "Restore",
  results_are_being_synchronized: "Results are being synchronized",
  resume_execution: "Resume execution",
  reticle: "Reticle",
  retry: "Retry",
  retry_after_seconds: "Retry after seconds",
  retry_after_x_seconds: "Retry after X seconds",
  retu: "Return",
  return_to_app: "Return to App",
  return_to_charging_pile: "Return to charging pile",
  return_to_charging_point: "Return to charging point",
  return_to_charging_station: "Return to charging station",
  reverse_img: "Reverse image",
  reverse_img_display: "Reverse image display",
  reverse_linkage: "Reverse linkage",
  review_order: "Review Order",
  review_route: "Review route",
  revoke_authorization: "Revoke authorization",
  re_search: "Re-search",
  right: "Right",
  right_hand_twist: "Right-hand twist",
  right_side: "Right side",
  right_side_device_status: "Right side device status",
  ring_graph: "Ring Graph",
  robot: "Robot",
  robots_are_not_allowed_to_be_duplicated:
    "Robots are not allowed to be duplicated",
  robot_application_system: "Robot application system",
  robot_battery_config: "Robot battery configuration",
  robot_control: "Robot control",
  robot_details: "Robot details",
  robot_hardware_failure_unable_to_continue_navigation:
    "Robot hardware failure, unable to continue navigation",
  robot_has_reached_the_target_point: "Robot has reached the target point",
  robot_inspection_config: "Robot inspection configuration",
  robot_integration: "Robot integration",
  robot_is_already_associated_with_an_organization_pls_unassociate:
    "Robot is already associated with an organization, please unassociate before deleting",
  robot_is_in_auto_mode_confirm_to_switch_to_manual_mode:
    "Robot is in auto mode, confirm to switch to manual mode?",
  robot_is_moving_task_cannot_be_resumed:
    "Robot is moving, task cannot be resumed",
  robot_is_moving_to_the_target_point_manual_control_is_not_possib:
    "Robot is moving to the target point, manual control is not possible",
  robot_is_offline: "Robot is offline",
  robot_list: "Robot list",
  robot_location_lost: "Robot location lost",
  robot_locked: "Robot locked",
  robot_malfunction: "Robot malfunction",
  robot_management: "Robot management",
  robot_management_cloud_platform: "Robot Management Cloud Platform",
  robot_model: "Robot model",
  robot_name: "Robot name",
  robot_name_cannot_be_empty: "Robot name cannot be empty",
  robot_network_exception_ope_failed:
    "Robot network exception, operation failed",
  robot_not_bound: "Robot not bound",
  robot_not_bound_to_map: "Robot not bound to map",
  robot_offline: "offline",
  robot_operating_voltage: "Robot operating voltage",
  robot_point_inconsistent_with_platform:
    "Robot point inconsistent with platform",
  robot_started_moving_towards_target_point:
    "Robot started moving towards target point",
  robot_status: "Robot status",
  robot_storage_config: "Robot storage configuration",
  robot_successfully_switched_to_auto_mode:
    "Robot successfully switched to auto mode",
  robot_successfully_switched_to_manual_mode:
    "Robot successfully switched to manual mode",
  robot_system: "Robot system",
  robot_unable_to_reach_target_point: "Robot unable to reach target point",
  robot_unresponsive: "Robot unresponsive",
  roi_temp: "Roi Temp.",
  role: "Role",
  role_cannot_be_empty: "Role cannot be empty",
  role_data: "Role data",
  role_id: "Role ID",
  role_information: "Role information",
  role_management: "Role management",
  role_name: "Role name",
  role_name_cannot_be_empty: "Role name cannot be empty",
  role_name_must_be_chinese_characters_or_letters_and_no_longer_th:
    "Role name must be Chinese characters or letters, and no longer than 20 characters",
  role_name_must_be_letters_or_chinese_characters_and_no_longer_th:
    "Role name must be letters or Chinese characters, and no longer than 20 characters",
  role_order: "Role order",
  role_order_cannot_be_empty: "Role order cannot be empty",
  role_settings: "Role settings",
  role_status: "Role status",
  roof_materials: "Roof materials",
  roof_of_the_car: "Roof of the car",
  rotate_90clockwise: "Rotate 90° Clockwise",
  rotate_90counterclockwise: "Rotate 90° Counterclockwise",
  rotate_left: "Rotate Left",
  rotate_right: "Rotate Right",
  rotation_speed: "Rotation speed",
  route_vector_layer: "Route Vector Layer",
  row: "*row",
  row_details: "Row details",
  row_no: "Row No.",
  rubber_soft_and_hard: "Rubber(soft and hard)",
  rule: "Rule",
  rules_cannot_be_empty_and_there_must_be_at_least_one_enabled_rul:
    "Rules cannot be empty, and there must be at least one enabled rule. Alarms that do not match any rule will be considered false alarms and will not be prompted.",
  rule_name: "Rule Name",
  rule_setting: "Rule Setting",
  rural_straw_burning: "Rural Straw Burning",
  russian: "Russian",
  s: "s",
  sailboat: "Sailboat",
  sale: "Sale",
  sales_volume: "Sales volume",
  sales_volume_priority: "Sales volume priority",
  same_as_browser_time: "Same as browser time",
  same_as_current_location: "Same as current location",
  same_as_env_weather: "Same as environmental weather",
  saturday: "Sat.",
  save: "Save",
  save_0_event_records: "Save 0 Event Records",
  save_and_generate_reports: "Save and generate reports",
  save_as: "Save As",
  save_as_template: "Save as template",
  save_curve: "Save Curve",
  save_directory: "Save Directory",
  save_directory_is_required: "Save directory is required",
  save_failed: "Save failed",
  save_file: "Save File",
  save_image: "Save Image",
  save_in_segment: "Save in segment",
  save_password: "Save Password",
  save_path_format_error: "Save path format error",
  save_path_starting_with_eg_mnt_record_storage:
    "Save path, starting with /, e.g., /mnt/record_storage",
  save_settings: "Save Settings",
  save_settings_failed: "Save settings failed",
  save_success: "Save success",
  save_view: "Save View",
  scanning: "Scanning",
  scan_qr_code: "Scan QR Code",
  scan_tour: "Scan tour",
  scan_to_download_app: "Scan to download App",
  scene_mode: "Scene Mode",
  scheduled_reboot: "Scheduled reboot",
  scope: "Scope",
  scope_calibration_unit: "Scope calibration unit",
  scope_height: "Scope height",
  scope_information: "Scope information",
  score: "Score",
  screenshot: "Screenshot",
  screenshot_count: "Screenshot (count)",
  screen_display: "Screen display",
  screen_tilt: "Screen tilt",
  sd_card_detected_update: "SD card detected, update",
  sd_card_is_full: "SD card is full",
  search: "Search",
  searching: "Searching",
  search_and_rescue_vessel: "Search and rescue vessel",
  search_by_column_name: "Search by column name",
  search_by_informant: "Search by informant",
  search_by_robot_name: "Search by robot name",
  search_device: "Search device",
  search_failed: "Search failed.",
  search_for_bluetooth_devices: "Search for Bluetooth devices",
  search_product: "Search Product",
  search_resource: "Search Resource",
  secondary_server_status: "Secondary Server Status",
  second_calibration: "Second Calibration",
  select: "Select",
  selected: "Selected",
  select_all: "Select All",
  select_color: "Select Color",
  select_directory: "Select Directory",
  select_the_current_wifi_name: "Select the current Wi-Fi name",
  seled: "Selected",
  selfie: "Selfie",
  self_gps: "Self GPS",
  self_positioning: "Self-positioning",
  self_positioning_failed: "Self-positioning failed",
  sel_alarm_item: "Select alarm item",
  sel_alarm_name: "Select alarm name",
  sel_alarm_source: "Select alarm source",
  sel_channel: "Select channel",
  sel_coupon: "Select coupon",
  sel_date: "Select date",
  sel_device: "Select Device",
  sel_end_time: "Select end time",
  sel_inspection_points: "Select inspection points",
  sel_inspection_point_or_enter_distance:
    "Select inspection point or enter distance",
  sel_linkage_action: "Select linkage action",
  sel_notification_personnel: "Select notification personnel",
  sel_parent_department: "Select parent department",
  sel_picture: "Select Picture",
  sel_pseudo_color: "Select pseudo-color",
  sel_recording_time: "Select recording time",
  sel_robot: "Select robot",
  sel_start_time: "Select start time",
  sel_the_wifi_network_with_current_device_name_to_connect:
    "Select the Wi-Fi network with current device name to connect",
  sel_the_wifi_network_with_the_name_of_the_connecting_device:
    "Select the Wi-Fi network with the name of the connecting device",
  sel_time: "Select time",
  sel_time_cannot_be_empty: "Selection time cannot be empty",
  sel_time_range: "Select time range",
  sel_user: "Select user",
  sending: "Sending",
  sending_failed: "Sending failed",
  send_a_report: "Send a report",
  sensor: "Sensor",
  sensor_alarm: "Sensor alarm",
  sensor_device: "Sensor Device",
  sensor_malfunction: "Sensor malfunction",
  sep: "Sep",
  sequence: "Sequence",
  serial_number: "Serial number",
  series: "Series",
  server_access_timeout: "Server Access Timeout",
  server_address: "Server Address",
  server_address_cannot_be_empty: "Server address cannot be empty",
  server_alarm: "Server Alarm",
  server_background: "Server background",
  server_connection_failed: "Server connection failed",
  server_ip_cant_be_empty: "Server IP can't be empty.",
  server_ip_invalid: "Server IP Invalid.",
  server_offline: "Server Offline",
  server_port_cant_be_empty: "Server port can't be empty.",
  server_recording_storage_settings: "Server recording storage settings.",
  service_exception: "Service exception.",
  service_request_timed_out: "Service request timed out.",
  servo: "Servo",
  servo_information: "Servo information",
  servo_malfunction: "Servo malfunction",
  setting: "Setting",
  settings_general_about_modify_name:
    "Please follow the path below to modify the mobile hotspot's account to match the device: Settings - General - About - Modify Name",
  settings_personal_hotspot_modify_settings_name_modify_password:
    "Please follow the path below to modify the mobile hotspot's account and password to match the device: Settings - Personal Hotspot - Modify Settings Name - Modify Password (Different phone models may have variations)",
  settings_successful_settings_failed_devices:
    "Settings successful: {0}, settings failed: {1}, failed devices: {2}",
  setting_failed: "Setting failed",
  setting_failed_pls_try_again: "Setting failed, please try again",
  setting_in_process_pls_wait: "Setting in process, please wait",
  setting_success: "Setting succeeded",
  settle: "Settle",
  set_as_default: "Set as Default",
  set_atmospheric_temp_failed: "Set atmospheric temp. failed",
  set_auto_tracking_succeeded: "Set auto tracking succeeded",
  set_brightness_failed: "Set brightness failed",
  set_color_palette_failed: "Set color palette failed",
  set_contrast_failed: "Set contrast failed",
  set_dde_enabled_failed: "Set DDE enabled failed",
  set_dde_failed: "Set DDE failed",
  set_distance_failed: "Set distance failed",
  set_emissisivity_failed: "Set emissisivity failed",
  set_filter_enabled_failed: "Set filter enabled failed",
  set_gain_mode_failed: "Set gain mode failed",
  set_image_flip_failed: "Set image flip failed",
  set_manual_tracking_succeeded: "Set manual tracking succeeded",
  set_measurement_range_failed: "Set measurement range failed",
  set_mobile_wifi: "Set mobile Wi-Fi",
  set_osd_failed: "Set OSD failed",
  set_phone_number_in_user_settings: "Set phone number in user settings.",
  set_reflected_temp_failed: "Set reflected temp. failed",
  set_to_0: "Set  to  0",
  set_tracking_mode_failed: "Set tracking mode failed",
  set_tracking_status_failed: "Set tracking status failed",
  set_transmittance_failed: "Set transmittance failed",
  set_valid_environmental_parameters_failed:
    "Set valid environmental parameters failed",
  set_valid_env_parameters_succeeded:
    "Set valid environmental parameters succeeded",
  share: "Share",
  shared_channels: "Shared Channels",
  shared_channel_number: "Shared Channel Number",
  share_by_qrcode: "Share by QR Code",
  sheet_metal: "Sheet metal",
  shield: "Shield",
  shielded_alarm: "Shielded alarm",
  shielded_area_config: "Shielded Area Configuration",
  shielded_area_name: "Shielded Area Name",
  shielded_area_sa: "Shielded Area",
  shielding_distance_compensation: "Shielding distance compensation",
  shield_area_layer: "Shield Area Layer",
  shield_duration: "Shield Duration",
  shield_name: "Shield Name",
  shield_range: "Shield Range",
  shipping_address: "Shipping address",
  shipping_cost: "Shipping cost",
  shipping_credits: "Shipping credits",
  ships_equipped_with_pollution_prevention_facilities_or_equipment:
    "Ships equipped with pollution prevention facilities or equipment",
  shld_ar_mgmt: "Shld Ar Mgmt",
  shooting_device: "Shooting Device",
  shooting_time: "Shooting time",
  should_bigger_than_0: "should bigger than 0",
  should_the_area_near_this_location_be_set_as_a_shieled_area:
    "Should the area near this location be set as a shieled area?",
  show_details: "Show Details",
  show_logo: "Show Logo",
  show_only_malfunctioning_robots: "Show only malfunctioning robots",
  show_video: "Show Video",
  shutter: "Shutter",
  shutter_calibration_failed: "Shutter calibration failed",
  shutter_calibration_succeeded: "Shutter calibration succeeded",
  shutter_correction: "Shutter correction",
  shutter_correction_failed: "Shutter correction failed",
  sick_chicken_analysis: "Sick chicken",
  side_alarm_bar_switch: "Side alarm bar switch",
  signal_light: "Signal light",
  silk: "Silk",
  simplified_chinese: "Simplified Chinese",
  single: "Single",
  single_frame_occurrence_confidence_threshold:
    "Single frame/occurrence confidence threshold",
  single_rangefinding: "Single rangefinding",
  single_task: "Single task",
  sip_server_ip: "SIP server IP",
  sip_server_number: "SIP server number",
  sip_server_number_should_be_20_characters_in_length:
    "SIP server number should be 20 characters in length.",
  sip_server_port: "SIP server port",
  sip_service_ip: "SIP Service IP",
  sip_service_national_standard_code: "SIP Service National Standard Code",
  sip_service_national_standard_domain: "SIP Service National Standard Domain",
  sip_service_port: "SIP Service Port",
  skin: "Skin",
  skip_frames: "Skip Frames",
  sky: "Sky",
  slam_radar: "SLAM radar",
  slam_radar_anomaly: "SLAM radar anomaly",
  slam_radar_information: "SLAM radar information",
  slave_address: "Slave address",
  slave_address_range_2_254: "Slave address range 2-254",
  sleep: "Sleep",
  slow: "Slow",
  slow_forward: "Slow Forward",
  smart_image_capture_list: "Smart image capture list",
  smart_import_will_automatically_create_single_ip_dual_channel_de:
    "Smart import will automatically create single IP dual-channel device associations and associations for single-channel devices with similar names. Therefore, before performing smart import, it is necessary to set the device names and channel names in the system.",
  smart_inspection_snapshot_is_disabled_under_visual_mode:
    "Smart inspection snapshot is disabled under visual mode",
  smart_patrol: "Smart patrol",
  smart_patrol_tasks: "Smart patrol tasks",
  smokefire_detection: "Smoke&Fire Detection",
  smoke_detection: "Smoke detection",
  smoke_recognition_algorithm_visible: "Smoke recognition algorithm (visible)",
  smooth_black_paint: "Smooth black paint",
  sms: "SMS",
  sms_login: "SMS login",
  sms_platform: "SMS platform",
  sms_platform_account: "SMS platform account",
  sms_platform_password: "SMS platform password",
  sms_platform_settings: "SMS platform settings",
  sms_sent: "SMS sent",
  sms_signature: "SMS signature",
  sn: "SN",
  snapshot: "Snapshot",
  snapshot_directory: "Snapshot Directory",
  snapshot_failed: "Snapshot failed",
  snapshot_interval: "Snapshot interval",
  snapshot_limit_5_100: "Snapshot limit: 5-100",
  snapshot_resolution: "Snapshot Resolution",
  snapshot_success: "Snapshot succeeded",
  snapshot_time_limit_5_100s: "Snapshot time limit 5-100S",
  snapshot_type: "Snapshot Type",
  sn_cannot_be_empty: "SN cannot be empty",
  software_license: "Software License",
  software_license_and_services_agreement:
    "Software License and Services Agreement",
  software_upgrade: "Software upgrade",
  software_ver: "Software version",
  sold: "Sold",
  solved: "Solved",
  sorry_currently_no_data_available: "Sorry, currently no data available",
  sorry_this_feature_is_currently_occupied_by_the_computer_addres:
    "Sorry, this feature is currently occupied by {0}, the computer address is: {1}, MAC address is: {2}, you can use it after it's released.",
  sort: "Sort",
  source: "Source",
  source_address_error: "Source address error.",
  so_that_we_can_contact_you: "So that we can contact you",
  space_cleanup_threshold: "Space cleanup threshold",
  spanish: "Spanish",
  speaker: "Speaker",
  speaker_malfunction: "Speaker malfunction",
  special: "Special",
  special1: "Special1",
  special2: "Special2",
  specified_time: "Specified time",
  speech_remarks: "Speech remarks",
  speed: "Speed",
  speed_dome: "Speed dome",
  speed_limit: "Speed limit",
  speed_setting_failed: "Speed setting failed",
  spot: "Spot",
  spot_number_reach_limit: "Spot Number reach limit",
  square_1_2_diagonal_length: "Square, 1/2 diagonal length",
  standby: "Standby",
  start: "Start",
  start_a_new_order_after_settlement: "Start a new order after settlement",
  start_date: "Start date",
  start_date_required: "Start date required",
  start_date_should_be_earlier_than_end_date:
    "Start date should be earlier than end date.",
  start_frame_less_than_end_frame: "Start frame < End frame",
  start_from_d1_to_d2_record_from_t1_to_t2_for_each_w:
    "Start from d1 to d2, record from t1 to t2 for each w",
  start_from_d_record_fromt1_to_t2_for_each_w_never_stop:
    "Start from d, record fromt1 to t2 for each w, never stop",
  start_inspection: "Start",
  start_locate: "Start Locate",
  start_observing: "Start observing",
  start_recording: "Start Recording",
  start_recording_failed: "Start recording failed",
  start_recording_success: "Start recording succeeded",
  start_smart_image_capture_auto_alarm_snapshot_paused:
    "Start smart image capture, auto alarm snapshot paused",
  start_time: "Start Time",
  start_timed_image_capture: "Start timed image capture",
  start_time_required: "Start time required",
  start_time_should_be_earlier_than_end_time:
    "Start time should be earlier than end time.",
  start_tour: "Start tour",
  start_upgrade: "Start upgrade",
  start_video_recording: "Start video recording",
  start_zoom_speed: "Start zoom speed",
  start_zoom_speed_should_be_higher_than_end_zoom_speed:
    "Start zoom speed should be higher than end zoom speed",
  statistical_cloud_map: "Statistical cloud map",
  statistical_planning: "Statistical planning",
  statistical_results: "Statistical results",
  statistical_rules: "Statistical rules",
  statistics: "Statistics",
  statistics_type: "Statistics Type",
  stats_failed: "Stats failed.",
  status: "Status",
  steady_on: "Steady on",
  step_1_configure_mobile_hotspot: "Step 1: Configure mobile hotspot",
  step_2_wait_for_the_device_to_connect:
    "Step 2: Wait for the device to connect",
  step_3_device_connection_successful: "Step 3: Device connection successful",
  stone: "Stone",
  stop: "Stop",
  stop_alarm: "Stop alarm",
  stop_audio: "Stop Audio",
  stop_failed: "Stop failed",
  stop_in_place: "Stop in place",
  stop_moving_window: "Stop Moving Window",
  stop_rangefinding: "Stop rangefinding",
  stop_record: "Stop Record",
  stop_recording: "Stop recording",
  stop_video_recording: "Stop video recording",
  storage: "Storage",
  storage_space_alarm: "Storage space alarm",
  storage_space_alarm_threshold: "Storage space alarm threshold",
  storage_temperature_range: "Storage Temperature Range",
  streaming: "Streaming",
  streaming_failed: "Streaming failed",
  streaming_media_server_exception: "Streaming media server exception.",
  streaming_media_server_ip: "Streaming media server IP",
  streaming_media_server_port: "Streaming media server port",
  streaming_successful: "Streaming successful",
  stream_playback_failed: "Stream playback failed.",
  stream_switch_failed: "Stream Switch Failed",
  stream_switch_succeeded: "Stream Switch Succeeded",
  street_building_number_house_number: "Street, building number, house number",
  strong_aluminium_oxide: "Strong aluminium oxide",
  stuck_chicken: "Stuck chicken",
  stuck_chicken_alarm: "Stuck chicken alarm",
  stuck_chicken_analysis: "Stuck chicken",
  submission_failed: "Submission failed",
  submission_failed_pls_check_your_network_connection:
    "Submission failed. Please check your network connection.",
  submit: "Submit",
  submitted: "Submitted",
  submit_and_continue: "Submit and continue",
  submit_order: "Submit Order",
  subnet_mask: "Subnet Mask",
  subscriber_does_not_exist: "Subscriber does not exist.",
  subscription_added_successfully: "Subscription added successfully.",
  subscription_information_already_exists_pls_modify_the_existing_:
    "Subscription information already exists, please modify the existing one.",
  subscription_information_does_not_exist:
    "Subscription information does not exist.",
  sub_application: "Sub Application",
  sub_stream: "Sub stream",
  success: "Success",
  success_prompt: "Success Prompt",
  success_to_del_data_in_cloud: "Succeeded to delete data in cloud",
  suggestions_and_feedback: "Suggestions and Feedback",
  suggest_for_you: "Recommended",
  sunday: "Sun.",
  superior_function: "Superior function",
  superior_organization: "Superior organization",
  superior_platform_code: "Superior Platform Code",
  superior_platform_ip: "Superior Platform IP",
  superior_platform_port: "Superior Platform Port",
  superior_platform_status: "Superior Platform Status",
  superior_sip_service_ip: "Superior SIP Service IP",
  superior_sip_service_national_standard_code:
    "Superior SIP Service National Standard Code",
  superior_sip_service_national_standard_domain:
    "Superior SIP Service National Standard Domain",
  superior_sip_service_port: "Superior SIP Service Port",
  super_admin_cannot_be_modified: "Super admin cannot be modified.",
  super_resolution: "Super-resolution",
  super_resolution_off: "Super-Resolution Off",
  super_resolution_on: "Super-Resolution On",
  sure_to_cancel_the_order: "Are you sure to cancel the order",
  sure_to_close_the_order_and_settle: "Sure to close the order and settle",
  surface: "Surface",
  surplus: "Surplus",
  suspected_abnormal: "Suspected abnormal",
  suspected_chicken_opening_mouth_detected:
    "Suspected chicken opening mouth detected",
  suspected_dead_chickens_found_in_chicken_cage_x_x_layer_x:
    "Suspected dead chickens found in chicken cage x-x, layer x",
  suspected_dead_chicken_detected: "Suspected dead chicken detected",
  suspected_dirty_chicken_coop_detected:
    "Suspected dirty chicken coop detected",
  suspected_discovery: "Suspected discovery",
  suspected_false_alarm: "Suspected false alarm",
  suspected_non_laying_chicken_detected:
    "Suspected non-laying chicken detected",
  suspected_normal: "Suspected normal",
  suspected_presence: "Suspected presence",
  suspected_presence_of_x_chickens: "Suspected presence of x chickens",
  suspected_trapped_chicken_detected: "Suspected trapped chicken detected",
  suspected_uneven_feed_line_detected: "Suspected uneven feed line detected",
  suspected_water_line_anomaly_detected:
    "Suspected water line anomaly detected",
  suspected_weak_chicken_detected: "Suspected weak chicken detected",
  switching_device_network: "Switching device network",
  switching_failed_current_status_unchanged:
    "Switching failed, current status  unchanged.",
  switching_successful_current_mode_is_1_restart_to_take_effect:
    "Switching successful, current mode is %1, restart to take effect.",
  switching_successful_in_high_gain_mode_now:
    "Switching successful, in high gain mode now.",
  switching_successful_in_low_gain_mode_now:
    "Switching successful, in  low gain mode  now.",
  switching_to_high_gain_mode_pls_wait:
    "Switching to high gain mode, please wait.",
  switching_to_low_gain_mode_pls_wait:
    "Switching to low gain mode, please wait.",
  switch_main_tream: "Switch Main Stream",
  switch_mode: "Switch mode",
  switch_soon: "Switch soon.",
  switch_sub_stream: "Switch Sub Stream",
  switch_successful: "Switch successful",
  switch_target_failed: "Switch target failed",
  switch_tracking: "Switch Tracking",
  switch_view: "Switch View",
  sync: "Sync",
  synchronization_time_failed: "Synchronization time failed",
  synchronization_time_succeeded: "Synchronization time succeeded",
  sync_phone_time_to_the_device: "Sync phone time to the device",
  sync_playback: "Sync Playback",
  sync_points: "Sync points",
  sync_successful: "Sync successful",
  sync_time: "Sync. Time",
  sync_to_platform: "Sync to platform",
  system: "System",
  system_alarm_email_subject:
    "[System Notification] System Operation Alarm Statistics Notification",
  system_alarm_statistics_sending_settings:
    "System Alarm Statistics Sending Settings",
  system_config: "System Config.",
  system_error: "System error",
  system_functions: "System Functions",
  system_function_mode: "System Function Mode",
  system_information: "System information",
  system_is_playing_a_video_do_you_want_to_shut_down:
    "System is playing a video. Do you want to shut down?",
  system_is_recording_do_you_want_to_shut_down:
    "System is recording. Do you want to shut down?",
  system_logo: "System Logo",
  system_maintenance: "System maintenance",
  system_management: "System Management",
  system_name: "System name",
  system_name_cannot_exceed_10_characters:
    "System name cannot exceed 10 characters",
  system_setting: "System Setting",
  system_time: "System time",
  system_ver_information: "System version information",
  sys_dev_online_ratio: "Sys Dev Online Ratio",
  s_resend: "s Resend",
  s_serial: "S Serial",
  target_auto_excl: "Target Auto Excl.",
  target_azimuth_angle: "Target Azimuth Angle",
  target_distance: "Target Distance",
  target_elevation_angle: "Target Elevation Angle",
  target_gps: "Target GPS",
  target_latitude_and_longitude: "Target Latitude and Longitude",
  target_location: "Target Location",
  target_point: "Target Point",
  target_point_latitude: "Target Point Latitude",
  target_point_longitude: "Target Point Longitude",
  target_positioning: "Target positioning",
  target_positioning_failed: "Target positioning failed",
  target_tracking: "Target Tracking",
  target_traj_overlay: "Target Traj. Overlay",
  target_type: "Target Type",
  tas: "TAS",
  task: "Task",
  task_can_be_issued: "Task can be issued",
  task_completion_rate: "Task completion rate",
  task_creation_time: "Task creation time",
  task_details: "Task details",
  task_distribution_failed_for_the_same_robot_recurring_tasks_and_:
    "Task distribution failed, for the same robot, recurring tasks and scheduled tasks cannot coexist",
  task_distribution_failed_only_one_recurring_task_can_be_issued_f:
    "Task distribution failed, only one recurring task can be issued for the same robot",
  task_distribution_invalid_cyclic_tasks_and_scheduled_tasks_canno:
    "Task distribution invalid! Cyclic tasks and scheduled tasks cannot coexist for the same robot",
  task_distribution_invalid_cyclic_task_start_and_end_times_cannot:
    "Task distribution invalid! Cyclic task start and end times cannot be empty",
  task_distribution_invalid_only_one_cyclic_task_can_be_issued_for:
    "Task distribution invalid! Only one cyclic task can be issued for the same robot",
  task_distribution_invalid_same_named_task_already_exists_for_the:
    "Task distribution invalid! Same-named task already exists for the robot",
  task_distribution_invalid_scheduled_task_start_time_cannot_be_wi:
    "Task distribution invalid! Scheduled task start time cannot be within 3 minutes",
  task_end_time: "Task end time",
  task_execution: "Task execution",
  task_execution_frequency: "Task execution frequency",
  task_execution_method: "Task execution method",
  task_files_not_existed: "Task files not existed",
  task_file_format_error: "Task file format error",
  task_in_progress: "Task in progress",
  task_issuance: "Task issuance",
  task_name: "Task Name",
  task_name_already_exists_pls_modify_and_try_again:
    "Task name already exists, please modify and try again",
  task_name_cannot_be_empty: "Task name cannot be empty",
  task_name_must_be_letters_numbers_or_chinese_characters_and_no_l:
    "Task name must be letters, numbers, or Chinese characters, and no longer than 20 characters",
  task_name_validation_passed: "Task name validation passed",
  task_progress: "Task progress",
  task_ready: "Task ready",
  task_start_time: "Task start time",
  task_start_time_cannot_be_empty: "Start time cannot be empty",
  task_status: "Task status",
  task_success_rate: "Task success rate",
  task_template: "Task template",
  task_template_cannot_be_empty: "Task template cannot be empty",
  task_template_not_imported: "Task template not imported",
  task_template_not_seled_cannot_import:
    "Task template not selected, cannot import",
  task_termination: "Task termination",
  task_termination_failure: "Task termination failure",
  task_type: "Task Type",
  taxpayer_identification_number: "Taxpayer Identification Number",
  temp: "Temp.",
  temperature_parameter_settings: "Temperature parameter settings",
  temperature_trend_display: "Temperature trend display",
  temperature_video_recording_mode: "Temperature video recording mode",
  template_content: "Template Content",
  template_has_been_deld_pls_sel_again:
    "Template has been deleted, please select again",
  template_name: "Template Name",
  template_name_cannot_be_empty: "Template name cannot be empty",
  template_name_duplicate: "Template name duplicate.",
  temp_alarm: "Temp. Alarm",
  temp_and_humidity_sensor_abnormal: "Temperature and humidity sensor abnormal",
  temp_calibration: "Temperature calibration",
  temp_chart: "Temp. chart",
  temp_cloud_map: "Temperature",
  temp_collection: "Temp. Collection",
  temp_curve: "Temp. Curve",
  temp_diff: "Diff. Temp.",
  temp_difference: "Temperature difference",
  temp_difference_absolute_value: "Temperature difference absolute value",
  temp_difference_alarm: "Temperature difference alarm",
  temp_difference_equal_to: "Temperature difference equal to",
  temp_difference_greater_than: "Temperature difference greater than",
  temp_difference_less_than: "Temperature difference less than",
  temp_error: "Temperature error",
  temp_exceeds_limit: "Temperature exceeds limit",
  temp_greater_than: "Temperature greater than",
  temp_icon_style: "Temperature icon style",
  temp_information_display_mode: "Temp. information display mode",
  temp_interval: "Temp.  interval",
  temp_less_than: "Temperature less than",
  temp_level_threshold_is_required: "Temp. level threshold is required",
  temp_lower_limit_over_floating: "Temp. Lower Limit Over Floating",
  temp_meas: "Temp. Meas.",
  temp_measurement_analysis_report: "Temperature Measurement Analysis Report",
  temp_measurement_enabled_successfully:
    "Temperature measurement enabled successfully.",
  temp_measurement_enablement_failed:
    "Temperature measurement enablement failed",
  temp_measurement_gear: "Temp. Measurement Gear",
  temp_measurement_rule_name: "Temp. measurement rule name",
  temp_meas_rule: "Temp. Meas. Rule",
  temp_range: "Temp Range",
  temp_range_setting: "Temp Range Setting",
  temp_record: "Temp. Record",
  temp_rise: "Temperature rise",
  temp_rise_alarm: "Temp. Rise Alarm",
  temp_rise_alarm_rise_by_t_every_s1_seconds_lasting_for_s2_secon:
    "Temperature rise alarm (Rise by {t}℃ every {s1} seconds, lasting for {s2} seconds)",
  temp_rise_alarm_rise_by_t_every_s_seconds_for_n_times:
    "Temperature rise alarm (Rise by {t}℃ every {s} seconds, for {n} times)",
  temp_rise_level_threshold_is_required:
    "Temp. rise level threshold is required",
  temp_rise_threshold_is_required: "Temp. rise threshold is required",
  temp_rise_time_interval: "Temperature rise time interval",
  temp_sensor_status: "Temperature sensor status",
  temp_slope: "Temperature slope",
  temp_slope_equal_to: "Temperature slope equal to",
  temp_slope_greater_than: "Temperature slope greater than",
  temp_slope_less_than: "Temperature slope less than",
  temp_statistics: "Temp. Statistics",
  temp_threshold_is_required: "Temp. threshold is required",
  temp_unit: "Temp. Unit",
  temp_upper_limit_over_floating: "Temp. Upper Limit Over Floating",
  temp_video_is_cannot_displayed_on_the_device:
    "The temperature video is unable to be displayed on the device.",
  "temp℃": "Temperature (℃)",
  tenant_id_cannot_be_empty: "Tenant ID cannot be empty",
  ten_minutes: "ten minutes",
  terminate: "Terminate",
  terminated_successfully: "Terminated successfully",
  terminate_again: "Terminate again",
  testing_environment: "Test environment",
  test_alarm: "Test alarm",
  test_reports: "Test Reports",
  text_remarks: "Text remarks",
  text_setting: "Text Setting",
  tgt_dist_m: "TGT Dist (m)",
  thank_you_for_your_participation: "Thank you for your participation.",
  there_are_bound_users_under_this_role:
    "There are bound users under this role",
  there_are_no_bound_users_under_this_role:
    "There are no bound users under this role",
  there_are_no_channels_being_playback: "There are no channels being playback",
  there_are_no_channels_being_previewed:
    "There are no channels being previewed",
  there_are_still_count_points_not_inspected:
    "There are still {count} points not inspected",
  there_are_still_unprocessed_alarms_are_you_sure_you_want_to_leav:
    "There are still unprocessed alarms, are you sure you want to leave without handling them?",
  there_are_users_bound_to_this_role_pls_unbind_all_users_before_d:
    "There are users bound to this role. Please unbind all users before deleting",
  there_can_be_no_cross_overlapping_isothermal_temperature_ranges:
    "There can be no cross-overlapping isothermal temperature ranges",
  there_is_already_a_loop_task_on_the_device:
    "There is already a loop task on the device.",
  there_is_an_unfinished_video_export_task_pls_try_again_later:
    "There is an unfinished video export task. Please try again later",
  there_is_a_file_with_the_same_name_in_the_current_path:
    "There is a file with the same name in the current path",
  there_must_be_at_least_one_active_rule:
    "There must be at least one active rule",
  thermal: "Thermal",
  thermal_camera: "Thermal camera",
  thermal_camera_information: "Thermal camera information",
  thermal_camera_ver: "Thermal camera version",
  thermal_fire: "Thermal - fire",
  thermal_fire_detection: "Thermal  Fire Detection",
  thermal_fire_spreading: "Thermal - fire spreading",
  thermal_imaging_mode: "Thermal Imaging Mode",
  thermal_imgs: "Thermal images",
  thermal_parameters: "Thermal Parameters",
  thermal_screenshot: "Thermal screenshot",
  thermal_x1_visual_x1: "Thermal_x1 Visual_x1",
  thermo_center: "Thermo. Center",
  thermo_report: "Thermo. Report",
  thermo_report_template: "Thermo. Report Template",
  the_affiliated_map_cannot_be_empty: "The affiliated map cannot be empty",
  the_affiliated_robot_cannot_be_empty: "The affiliated robot cannot be empty",
  the_allowed_input_distance: "The allowed input distance",
  the_allowed_input_emissivity_is: "The allowed input emissivity is",
  the_allowed_input_env_temp_is:
    "The allowed input environmental temperature is",
  the_allowed_input_humidity_is: "The allowed input humidity is",
  the_allowed_reflected_temp: "The allowed reflected temperature",
  the_app_needs_to_use_your_local_network_to_send_the_broadcast:
    "The App needs to use your local network to send the broadcast",
  the_associated_inspection_task: "The associated inspection task",
  the_bad_pixel_is_being_saved: "The bad pixel is being saved",
  the_blackhot_is_disabled_under_isotherm_mode:
    "The blackhot is disabled under isotherm mode.",
  the_charging_point_cannot_be_empty: "The charging point cannot be empty",
  the_column_number_should_be_a_positive_integer:
    "The column number should be a positive integer",
  the_current_device_name_is_unable_to_capture_image:
    "The current device name is too long,unable to capture image",
  the_current_directory_contains_submenus_pls_del_the_submenus_fir:
    "The current directory contains submenus, please delete the submenus first.",
  the_current_network_is_not_available_pls_connect_to_the_internet:
    "The current network is not available. Please connect to the internet.",
  the_current_ope_will_modify_the_existing_recording_schedule_time:
    "The current operation will modify the existing recording schedule time. The current recording plan will stop, and the new schedule will be executed. Do you want to continue?",
  the_current_robot_is_in_auto_mode_and_cannot_be_controlled:
    "The current robot is in auto mode and cannot be controlled",
  the_current_software_ver_is: "The current software version is",
  the_current_video_is_not_playing_so_recording_is_not_possible:
    "The current video is not playing, so recording is not possible",
  the_current_video_is_not_playing_unable_to_capture_img:
    "The current video is not playing, unable to capture image",
  the_data_volume_is_too_large_and_the_remaining_alarm_records_can:
    "The data volume is too large, and the remaining alarm records cannot be exported.",
  the_device_already_exists: "The device already exists",
  the_device_discovered_an_emergency_in_the_direction_direction_at:
    "The device discovered an emergency in the {direction} direction at a distance of {distance} ({villageName}).",
  the_device_does_not_currently_support_this_functionality:
    "The device does not currently support this functionality.",
  the_device_information_will_be_removed_after_factory_reset:
    "The device information will be removed after factory reset.",
  the_device_is_currently_in_continuous_rangefinding_do_you_want_t:
    "The device is currently in continuous rangefinding. Do you want to stop",
  the_device_is_disabled: "The device is disabled",
  the_device_is_upgrading_exiting_now_may_cause_the_upgrade_to_fai:
    "The device is upgrading. Exiting now may cause the upgrade to fail.",
  the_device_name_only_supports_chinese_and_english_numbers_dots_h:
    "The device name only supports Chinese and English, numbers, dots, horizontal lines, and underscores",
  the_device_will_restart_shortly_pls_reconnect_to_the_device_late:
    "The device will restart shortly. Please reconnect to the device later.",
  the_end_time_must_be_later_than_the_start_time:
    "The end time must be later than the start time",
  the_horizontal_axis_must_increase_sequentially:
    "The horizontal axis must increase sequentially",
  the_identifier_prefix_for_common_channel_0_does_not_match_the_de:
    "The identifier prefix for common channel {0} does not match the device configuration, please check.",
  the_identifier_prefix_for_eos_channel_0_does_not_match_the_devic:
    "The identifier prefix for E.O.S. channel {0} does not match the device configuration, please check.",
  the_image_has_already_been_captured:
    "The image has already been captured, whether to capture again",
  the_information_of_the_cage_layer_is_incomplete:
    "The information of the cage layer is incomplete",
  the_inspection_task_is_in_progress_pls_end_first:
    "The inspection task is in progress, pls end first",
  the_last_device_in_the_list_has_already_been_captured:
    "The last device in the list has already been captured",
  the_linked_channel_does_not_exist_in_the_system:
    "The linked channel does not exist in the system.",
  the_linked_device_does_not_exist_in_the_system:
    "The linked device does not exist in the system.",
  the_max_env_temp_is_set_as: "The Maximum environmental temperature is set as",
  the_max_reflected_temp_is_set_as:
    "The Maximum reflected temperature is set as",
  the_min_env_temp_is_set_as: "The Minimum environmental temperature is set as",
  the_min_illumination_of_visible_light:
    "The Min. Illumination of Visible Light",
  the_min_reflected_temp_is_set_as:
    "The Minimum reflected temperature is set as",
  the_mobile_number_has_been_registered:
    "The mobile number has been registered",
  the_network_communication_is_abnormal_and_the_n1_inspection_task:
    "The network communication is abnormal and the {n1} inspection task fails to be generated",
  the_next_day: "The next day",
  the_number_of_digits_for_the_account_must_be_20_and_only_numbers:
    "The number of digits for the account must be <=20, and only numbers/English are allowed",
  the_number_of_triggers_for_intelligent_analysis_is_too_low:
    "The number of triggers for intelligent analysis is too low",
  the_organization_name_is_a_combination_of_letters_numbers_or_chi:
    "The organization name is a combination of letters, numbers, or Chinese characters, and the length does not exceed 20",
  the_password_does_not_meet_the_requirements:
    "The password does not meet the requirements.",
  the_password_length_is_8_16_characters:
    "The password length is 8–16 characters.",
  the_password_must_be_8_20_characters_long_and_include_both_numbe:
    "The password must be 8-20 characters long and include both numbers and letters.",
  the_password_should_be_5_20_characters:
    "The password should be 5~20 characters",
  the_past_month: "The past month",
  the_past_three_months: "The past three months",
  the_phone_is_connected_to_the_same_wi_fi_as_the_device:
    "The phone is connected to the same Wi-Fi as the device",
  the_phone_number_is_not_linked_to_any_account:
    "The phone number is not linked to any account!",
  the_preview_screen_shows_the_temperature:
    "The preview screen shows the temperature",
  the_pwd_should_be_more_than_6_chars:
    "The password should be more than 6 characters",
  the_pwd_should_be_more_than_8_chars:
    "The password should be more than 8 characters",
  the_query_time_span_is_12_hour: "The query time span is 12 hour",
  the_query_time_span_is_1_hour: "The query time span is 1 hour",
  the_query_time_span_is_24_hour: "The query time span is 24 hour",
  the_range_maximum_value_needs_to_be_bigger_than_the_max:
    "Note: The range maximum value needs to be bigger than the Max",
  the_range_minimum_value_needs_to_be_less_than_the_min:
    "Note: The range minimum value needs to be less than the Min",
  the_range_minimum_value_needs_to_be_less_than_the_range_maximum:
    "Note: The range minimum value needs to be less than the range maximum",
  the_recorded_file_has_reached_2gb_limit_pls_stop_recording:
    "The recorded file has reached 2GB limit, please stop recording",
  the_recorded_file_has_reached_5gb_limit_pls_stop_recording:
    "The recorded file has reached 5GB limit, please stop recording",
  the_report_is_being_exported_pls_view_it_under_the_specified_pat:
    "The report is being exported. Please view it under the specified path",
  the_robot_is_already_bound_to_the_chicken_coop_pls_choose_again:
    "The robot is already bound to the chicken coop, please choose again",
  the_robot_is_in_an_unlocked_state_are_you_sure_you_want_to_switc:
    "The robot is in an unlocked state, are you sure you want to switch to locked state?",
  the_robot_is_in_auto_mode_are_you_sure_you_want_to_switch_to_man:
    "The robot is in auto mode, are you sure you want to switch to manual mode?",
  the_robot_is_in_a_locked_state_are_you_sure_you_want_to_switch_t:
    "The robot is in a locked state, are you sure you want to switch to unlocked state?",
  the_rule_cannot_be_empty_and_cannot_continue_to_be_deld:
    "The rule cannot be empty and cannot continue to be deleted",
  the_same: "The same",
  the_same_channel_cannot_have_multiple_associated_groups:
    "The same channel cannot have multiple associated groups",
  the_selected_quantity_is: "The selected quantity is",
  the_server_is_having_a_hiccup_pls_try_again_later:
    "The server is having a hiccup, please try again later.",
  the_slave_address_cannot_be_empty: "The slave address cannot be empty",
  the_specified_gb_standard_device_cannot_be_found_pls_check_if_th:
    "The specified GB standard device cannot be found, please check if the device is offline.",
  the_system_does_not_support_this_device:
    "The system does not support this device",
  the_system_is_initializing: "The system is initializing",
  the_system_license_has_expired: "The system license has expired",
  the_system_license_is_about_to_expire:
    "The system license is about to expire",
  the_target_has_left_the_alert_area_and_cannot_be_tracked:
    "The target has left the alert area and cannot be tracked.",
  the_template_name_already_exists: "The template name already exists",
  the_template_name_or_content_cannot_be_empty:
    "The template name or content cannot be empty",
  the_template_name_should_consist_of_letters_numbers_or_chinese_c:
    "The template name should consist of letters, numbers, or Chinese characters, with a maximum length of 20",
  the_time_span_is_longer_than_2_hours: "The time span is longer than 2 hours",
  the_time_span_is_longer_than_one_day: "The time span is longer than one day",
  the_trigger_channel_does_not_exist_in_the_system:
    "The trigger channel does not exist in the system.",
  the_trigger_device_does_not_exist_in_the_system:
    "The trigger device does not exist in the system.",
  the_username_only_supports_chinese_and_english_numbers_dots_hori:
    "The username only supports Chinese and English, numbers, dots, horizontal lines, and underscores",
  the_user_does_not_have_video_playback_permission_for_this_device:
    "The user does not have video playback permission for this device",
  the_user_has_the_permission_to_record_and_replay_videos_on_the_device:
    "The user has the permission to record and replay videos on the device",
  the_user_is_currently_unauthorized: "The user is currently unauthorized",
  the_video_is_currently_being_exported_mp4_after_deletion_the_exp:
    "The video is currently being exported mp4, after deletion, the export task will be automatically cancelled",
  the_view_of_the_linkage_ipc_is_beyond_the_panoramic_field_of_vie:
    "The view of the linkage IPC is beyond the panoramic field of view, and the reverse linkage cannot be achieved",
  the_whitehot_is_disabled_under_isotherm_mode:
    "The whitehot is disabled under isotherm mode.",
  the_wifi_name_does_not_meet_the_requirements:
    "The Wi-Fi name does not meet the requirements.",
  the_wifi_name_length_is_1_32_characters:
    "The Wi-Fi name length is 1–32 characters.",
  third_party_service_exception: "Third-party service exception.",
  this_bullet_cannot_be_deld: "This bullet cannot be deleted",
  this_channel_is_already_favorited: "This channel is already favorited.",
  this_channel_of_the_device_is_offline:
    "This channel of the device is offline",
  this_device_channel_has_been_deld: "This device channel has been deleted.",
  this_device_channel_is_offline: "This device channel is offline.",
  this_function_can_only_be_enabled:
    "This function can only be enabled after the device is connected",
  this_is_already_the_first_alarm: "This is already the first alarm",
  this_is_already_the_last_alarm: "This is already the last alarm",
  this_is_a_piece_of_content: "This is a piece of content",
  this_location_is_within_a_surveillance_blind_spot:
    "This location is within a surveillance blind spot.",
  this_node_does_not_exist: "This node does not exist.",
  this_organization_has_sub_organizations_cannot_be_deld:
    "This organization has sub-organizations, cannot be deleted.",
  this_organization_is_already_associated_with_a_face_database_can:
    "This organization is already associated with a face database, cannot be deleted.",
  this_organization_is_already_associated_with_users_cannot_be_del:
    "This organization is already associated with users, cannot be deleted.",
  this_organization_is_associated_with_devices_cannot_be_deld:
    "This organization is associated with devices, cannot be deleted.",
  this_phone_number_is_already_in_use: "This phone number is already in use.",
  this_protocol_is_not_currently_supported:
    "This protocol is not currently supported.",
  this_record: "This record",
  this_robot_has_no_subordinate_channels_video_playback_is_not_pos:
    "This robot has no subordinate channels, video playback is not possible",
  this_role_is_bound_to_users_cannot_be_deld:
    "This role is bound to users, cannot be deleted.",
  this_role_name_already_exists: "This role name already exists.",
  this_user_does_not_have_permi_to_capture_device_imgs:
    "This user does not have permission to capture device images.",
  this_user_does_not_have_permi_to_take_snapshots:
    "This user does not have permission to take snapshots",
  this_user_does_not_have_ptz_control_permi_to_stop_this_device:
    "This user does not have PTZ control permission to stop this device.",
  this_user_has_no_operable_devices: "This user has no operable devices.",
  this_user_has_no_permi_to_download_device_recordings:
    "This user has no permission to download device recordings.",
  this_user_has_no_permi_to_play_this_device:
    "This user has no permission to play this device.",
  this_user_has_no_subscription_information:
    "This user has no subscription information.",
  this_user_has_permi_to_download_device_recordings:
    "This user has permission to download device recordings.",
  this_video_is_currently_being_exported_mp4_do_you_want_to_re_exp:
    "This video is currently being exported mp4. Do you want to re-export it",
  this_video_server_is_associated_with_devices_pls_remove_the_asso:
    "This video server is associated with devices. Please remove the association before deleting.",
  three_primary_colors: "Three primary colors",
  three_times_or_more: "Three times or more",
  threshold: "Threshold",
  threshold_for_repeated_alarm_times: "Threshold for repeated alarm times",
  threshold_for_repeated_alarm_times_cannot_be_empty:
    "Threshold for repeated alarm times cannot be empty",
  threshold_range_must_be_greater_than_0:
    "Threshold range must be greater than 0",
  threshold_range_must_be_less_than_or_equal_to_1:
    "Threshold range must be less than or equal to 1",
  threshold_switch: "Threshold Switch",
  thumbnail: "Thumbnail",
  thursday: "Thur.",
  tilt_lock_pitch_lock: "Tilt Lock / Pitch Lock",
  time: "Time",
  timed_tasks: "Timed Tasks",
  timeline_format: "Timeline Format",
  timer_photo: "Timer Photo",
  times: "*times",
  time_calibration_config: "Time calibration configuration",
  time_calibration_interval: "Time calibration interval",
  time_calibration_method: "Time calibration method",
  time_cost: "Time cost",
  time_interval_should_not_be_less_than_5s:
    "Time interval should not be less than 5s.",
  time_of_payment: "Time of payment",
  time_price: "Time price",
  time_span_cannot_exceed_24h: "Time span cannot exceed 24H.",
  time_span_cannot_exceed_2h: "Time span cannot exceed 2H.",
  time_span_cannot_exceed_3_days: "Time span cannot exceed 3 days.",
  time_span_cannot_exceed_3_months: "Time span cannot exceed 3 months.",
  time_span_cannot_exceed_5_min: "Time span cannot exceed 5 min.",
  time_span_cannot_exceed_6_months: "Time span cannot exceed 6 months.",
  time_sync: "Time Sync",
  time_synchronization: "Time Synchronization",
  time_synchronization_interval_cannot_be_empty:
    "Time synchronization interval cannot be empty",
  time_synchronization_interval_must_be_numeric:
    "Time synchronization interval must be numeric",
  time_sync_setting: "Time Sync Setting",
  title: "Title",
  to: "to",
  today: "Today",
  todays_alarmed_points: "Today's alarmed points",
  todays_inspected_points: "Today's inspected points",
  token_auth_failed: "Token authentication failed.",
  token_error_pls_check_device_time: "Token error, pls check device time",
  tolerance_temp: "Tolerance temperature",
  too_many_drawing_points_pls_redraw: "Too many drawing points, please redraw.",
  top_left: "Top-left",
  top_level_menu: "Top-Level Menu",
  top_right: "Top-right",
  total: "Total",
  totally_rusted_cast_iron: "Totally rusted cast iron",
  totally_rusted_iron_plate: "Totally rusted iron plate",
  totally_rusted_roll_iron_plate: "Totally rusted roll iron plate",
  totally_rusted_steel_oxide: "Totally rusted steel oxide",
  total_entries: "Total * entries",
  total_frames: "Total Frames",
  total_height: "Total height",
  total_inspection_tasks: "Total tasks",
  total_inventory: "Total inventory",
  total_number_of_ai_recognition_imgs_since_the_start_of_img_captu:
    "Total number of AI recognition images  since the start of image capture",
  total_number_of_columns: "Total number of columns",
  total_number_of_dead_chickens: "Total number of dead chickens",
  total_number_of_frames_for_ai_recognition_extraction:
    "Total number of frames for AI recognition extraction",
  total_number_of_pigsties: "Total number of pigsties",
  total_weight: "Total weight",
  total_weight_of_column: "Total weight of column",
  tour: "tour",
  towboat: "Towboat",
  to_achieve_automatic_ptz_tracking_trajectory_recognition_in_the_:
    "To achieve automatic PTZ tracking, trajectory recognition in the detection area must be enabled.",
  to_adjust_the_ambient_temp_ensure_that_the_atmos_transmittance_i:
    "To adjust the ambient temperature, ensure that the atmospheric transmittance is less than 1. Please adjust the atmospheric transmittance",
  to_adjust_the_reflection_temp_ensure_that_the_emissivity_is_less:
    "To adjust the reflection temperature, ensure that the emissivity is less than 1. Please adjust the emissivity",
  to_settle: "To settle",
  tracking_status: "Tracking status",
  traditional_chinese: "Traditional Chinese",
  trajectory_settings: "Trajectory settings",
  transfer_failed: "Transfer failed",
  transfer_firmware: "Transfer firmware",
  transmission_mode: "Transmission Mode",
  transmittance: "Transmittance",
  transmittance_is_out_of_range: "Transmittance is out of range",
  transmittance_is_required: "Transmittance is required",
  tripwire_intrusion: "Tripwire intrusion",
  tropical: "Tropical",
  true_east: "True east",
  true_heading_of_vessel: "True heading of vessel",
  true_north: "True north",
  true_south: "True south",
  true_west: "True west",
  tuesday: "Tues.",
  tugboat: "Tugboat",
  turkish: "Turkish",
  turning_on_location_switch_required: "Turning on location switch required",
  turn_off_io_time: "(Auto IO Off)Filter Time",
  turn_on_message_notification_to_receive_device_information_in_ti:
    "Turn on message notification to receive device information in time",
  twenty_minutes: "twenty minutes",
  twice: "Twice",
  twist_rate: "Twist rate",
  two_point_rangefinding: "Two-point rangefinding",
  type: "Type",
  typec_usb_interface: "Type-C USB Interface",
  t_serial: "T Serial",
  ultrasonic: "Ultrasonic",
  ultrasonic_anomaly: "Ultrasonic anomaly",
  unable_to_add_the_device_pls_install_the_certificate:
    "Unable to add the device, please install the certificate.",
  unable_to_add_the_device_the_certificate_has_expired_pls_contac:
    "Unable to add the device, the certificate has expired; please contact the administrator for authorization.",
  unable_to_add_the_device_the_number_of_channels_exceeds_the_auth:
    "Unable to add the device, the number of channels exceeds the authorized quantity; please contact the administrator for authorization.",
  unable_to_del_while_downloading: "Unable to delete while downloading",
  unable_to_get_channel_information: "Unable to get channel information",
  unable_to_get_device_information: "Unable to get device information",
  unable_to_get_device_information_pls_confirm_if_the_device_is_co:
    "Unable to get device information. Please confirm if the device is connected.",
  unable_to_locate_the_fire_point: "Unable to locate the fire point",
  unable_to_read_file_format: "Unable to read file format",
  unable_to_recognize_vessel_type: "Unable to recognize vessel type",
  unable_to_record_temporarily: "Unable to record temporarily",
  unanalyzable_file: "Unanalyzable File",
  unassigned: "Unassigned",
  unassociated: "Unassociated",
  unauthorized: "Unauthorized",
  unbind: "Unbind",
  unbind_user: "Unbind user",
  unbound: "Unbound",
  unbound_successfully: "Unbound successfully.",
  uncertificated: "Uncertificated",
  unchangeable_during_linkage_recording:
    "Unchangeable during linkage recording",
  unconfirmed: "Unconf.",
  unconnected_device: "Unconnected device",
  undeletable: "Undeletable",
  undeletable_during_linkage_recording: "Undeletable during linkage recording",
  uneven_feed_line_alarm: "Uneven feed line",
  unfavorite: "Unfavorite",
  unfinished_download_tasks_will_be_cleared_after_exiting_are_you_:
    "Unfinished download tasks will be cleared after exiting. Are you sure to exit?",
  unfinished_download_tasks_will_be_cleared_after_logout_are_you_s:
    "Unfinished download tasks will be cleared after logout. Are you sure to log out?",
  unfold: "Unfold",
  unilateral_inspection: "Unilateral inspection",
  uninspected_points: "Uninspected points",
  unit: "Unit",
  units: "*units",
  unit_settings: "Unit Settings",
  unknown: "Unknown",
  unknown_directory: "Unknown Directory",
  unknown_exception: "Unknown exception",
  unknown_folder: "Unknown folder",
  unknown_img: "Unknown image",
  unknown_ope: "Unknown operation.",
  unknown_points_need_synchronization: "Unknown points (need synchronization)",
  unknown_username_or_incorrect_pwd: "Unknown username or incorrect password",
  unlock: "Unlock",
  unlocked: "Unlocked",
  unlock_failed: "Unlock failed",
  unlock_succeeded: "Unlock succeeded",
  unlock_the_robot: "Unlock the robot",
  unpaid: "Unpaid",
  unprocessed: "Unprocessed",
  unrecoverable_deletion: "Unrecoverable deletion",
  unsale: "UnSale",
  unseled: "Unselected",
  unsel_all: "Unselect all",
  up: "Up",
  update: "Update",
  updated_inspection_point_successfully:
    "Updated inspection point successfully",
  update_and_import: "Update and import",
  update_complete: "Update complete",
  update_date: "Update date",
  update_failed: "Update failed",
  update_failed_check_code_error: "Update failed, check code error",
  update_files: "Update files",
  update_file_not_detected: "Update file not detected",
  update_firmware: "Update Firmware",
  update_from_sd_card: "Update from SD card",
  update_information: "Update information",
  update_location: "Update location",
  update_palette: "Update Palette",
  update_starup_picture: "Update Starup Picture",
  update_succeeded_auto_power_off_after_1_minute:
    "Update succeeded, auto power off after 1 minute.",
  update_success_pls_restart: "Update succeeded, please restart",
  update_time: "Update time",
  updating_patrol_plan_succeeded: "Updating patrol plan succeeded.",
  upgrade: "Upgrade",
  upgrade_completed: "Upgrade completed",
  upgrade_completed_rebooting: "Upgrade completed, rebooting",
  upgrade_failed: "Upgrade failed",
  upgrade_failed_due_to_device_network_issue:
    "Upgrade failed due to device network issue",
  upgrade_failed_pls_exit_and_try_again:
    "Upgrade failed, please exit and try again",
  upgrade_now: "Upgrade now",
  upgrade_package_download_failed: "Upgrade package download failed",
  upgrade_package_download_successful: "Upgrade package download successful",
  upgrade_package_error: "Upgrade package error",
  upgrade_package_upload_failed: "Upgrade package upload failed",
  upgrade_package_upload_successful: "Upgrade package upload successful",
  upgrade_preparation: "Upgrade preparation",
  upgrade_reminder: "Upgrade reminder",
  upgrade_successful: "Upgrade successful",
  upload: "Upload",
  uploaded_file_exceeds_the_limit: "Uploaded file exceeds the limit.",
  uploaded_file_has_exceeded_limits: "Uploaded file has exceeded limits.",
  uploaded_img_size_exceeds: "Uploaded image size exceeds",
  uploaded_logo_size_cannot_exceed_500kb:
    "Uploaded logo size cannot exceed 500KB",
  uploading: "uploading",
  upload_error: "Upload error",
  upload_failed: "Upload failed",
  upload_finish: "Upload finish",
  upload_log: "Upload log",
  upload_success: "Upload success",
  upload_the_upgrade_package_to_the_device:
    "Upload the upgrade package to the device",
  upper_temp_limit_should_be_greater_than_lower_temp_limit:
    "The upper temperature limit should be greater than the lower temperature limit",
  upper_threshold: "Upper threshold",
  up_down_flip: "Up-down Flip",
  up_to_16_channels_can_be_seled: "Up to 16 channels can be selected.",
  urban_fire: "Urban Fire",
  usb_camera: "USB camera",
  usb_disk: "USB disk",
  usb_mode: "Usb mode",
  usb_to_serial_port: "USB to serial port",
  used_to_receive_alert_messages: "Used to receive alert messages",
  user: "User",
  username: "Username",
  username_must_be_letters_numbers_or_chinese_characters_and_no_lo:
    "Username must be letters, numbers, or Chinese characters, and no longer than 20 characters",
  username_must_be_letters_or_numbers_and_no_longer_than_20_charac:
    "Username must be letters or numbers, and no longer than 20 characters",
  username_only_supports_english_numbers_period_hyphen_underscore:
    "Username only supports English, numbers, @, period, hyphen, underscore, backslashes",
  username_or_pwd_error: "Username or password error",
  username_required: "Username (Required)",
  users_full_name: "User's full name",
  user_agreement: "User Agreement",
  user_bound_to_app: "User bound to app",
  user_cannot_be_queried: "User cannot be queried",
  user_defined_frame: "User-defined Frame",
  user_does_not_exist: "User does not exist",
  user_email: "User email",
  user_entity_corresponding_field: "User entity corresponding field",
  user_exist: "User exist",
  user_id: "User ID",
  user_locked: "User locked",
  user_management: "User management",
  user_manual: "User Manual",
  user_name: "User Name",
  user_name_cannot_be_empty: "User name cannot be empty",
  user_name_is_required: "User name is required",
  user_name_must_be_letters_or_chinese_characters_and_no_longer_th:
    "User name must be letters or Chinese characters, and no longer than 20 characters",
  user_name_or_name: "User name or name",
  user_nickname: "User nickname",
  user_nickname_cannot_be_empty: "User nickname cannot be empty",
  user_privacy_policy: "User privacy policy",
  user_remarks: "User remarks",
  user_remarks_cannot_exceed_100_characters:
    "User remarks cannot exceed 100 characters",
  user_role: "User role",
  user_settings: "User settings",
  user_table_corresponding_field: "User table corresponding field",
  val: "Value",
  valid_after_software_restart: "Valid after software restart",
  valid_calibration_failed: "Valid Calibration Failed",
  valid_calibration_succeeded: "Valid Calibration Succeeded",
  vehicle: "Vehicle",
  vehicle_alarm: "Vehicle alarm",
  vehicle_excavator_recognition_algorithm_thermal:
    "Vehicle, excavator recognition algorithm (thermal)",
  vehicle_patrol: "Vehicle Patrol",
  ver: "Ver.",
  verification_code: "Verification Code",
  verification_code_format_error: "Verification code format error",
  verification_code_generation_service_error:
    "Verification code generation service error",
  verification_code_not_existed_or_expired:
    "Verification code not existed or expired",
  verification_code_sending_failed: "Verification code sending failed",
  verification_code_sent_successfully: "Verification code sent successfully",
  verification_code_should_be_6_digits: "Verification code should be 6 digits",
  version: "Version",
  vertical: "Vertical",
  vertical_angle: "Vertical angle",
  vertical_click_value: "Vertical click value",
  vertical_up_down: "Vertical (up, down -)",
  ver_check_failed: "Version check failed",
  ver_cur: "Current version",
  ver_upd: "Version update",
  vessel: "Vessel",
  vessel_coordinates: "Vessel coordinates",
  vessel_destination: "Vessel Destination",
  vessel_latitude_and_longitude: "Vessel Latitude and Longitude",
  vessel_name: "Vessel Name",
  vessel_speed_in_knots: "Vessel Speed (in knots)",
  vessel_type: "Vessel Type",
  ves_speed_knots: "VES Speed (Knots)",
  video: "Video",
  video_alarm: "Video alarm",
  video_analysis: "Video Analysis",
  video_anomaly_recording_failed: "Video anomaly, recording failed.",
  video_application: "Video Application",
  video_blocked: "Video Blocked",
  video_cannot_be_played: "Video cannot be played",
  video_download: "Video download",
  video_download_failed: "Video download failed",
  video_inspection: "Video inspection",
  video_interval: "Video Interval",
  video_larger_than_500m_is_unabled_to_be_uploaded:
    "Video larger than 500M is unabled to be uploaded",
  video_lost: "Video Lost",
  video_merging_in_progress_pls_wait: "Video merging in progress, please wait.",
  video_playback: "Video Playback",
  video_playback_linkage_snapshot: "Video playback&Linkage snapshot",
  video_query_failed: "Video query failed.",
  video_recorded_successfully_pls_check_in_the_phone_gallery:
    "Video recorded successfully. Please check in the phone gallery",
  video_recording: "Video Recording",
  video_replay: "Video replay",
  video_saving: "Video saving",
  video_server: "Video server",
  video_server_already_exists: "Video server already exists.",
  video_settings: "Video Settings",
  video_surveillance_alarmvid_sur_alm: "Video Surveillance Alarm(Vid Sur Alm)",
  video_transcoding: "Video transcoding",
  video_transcoding_succeeded: "Video transcoding succeeded",
  video_wall: "Video Wall",
  view: "View",
  viewtrack: "View&Track",
  view_and_manage_the_imgs_videos_in_the_device:
    "View and manage the images/videos in the device",
  view_cage_positions: "View cage positions",
  view_details: "View Details",
  view_device_alarms: "View device alarms",
  view_event_alarms: "View event alarms",
  view_id: "View ID",
  view_img: "View image",
  view_information: "View information",
  view_inspection_results: "View inspection results",
  view_logistics: "View logistics",
  view_map: "View map",
  view_mode: "View Mode",
  view_more: "View more",
  view_name: "View Name",
  view_pen: "View pen",
  view_report: "View report",
  view_task_queue: "View task queue",
  view_the_report: "View the report",
  view_video: "View video",
  vip: "VIP",
  visible: "Visible",
  visible_fire: "Visible - fire",
  visible_fire_detection: "Visible - fire detection",
  visible_light_malfunction: "Visible light malfunction",
  visible_mode: "Visible mode",
  visible_mode_no_measurement_set: "Visible Mode No Measurement Set",
  visible_mode_no_palette_set: "Visible Mode No Palette Set",
  visible_mode_no_params_set: "Visible Mode No Params Set",
  visible_smoke: "Visible - smoke",
  visible_smoke_detection: "Visible - smoke detection",
  visible_smoke_detection_visible_fire_detection:
    "Visible - smoke detection & visible - fire detection",
  visible_smoke_visible_fire: "Visible - smoke & visible - fire",
  visual_imgs: "Visual images",
  visual_screenshot: "Visual screenshot",
  visual_settings: "Visual settings",
  visual_smokefire_detection: "Visual Smoke&Fire Detection",
  visual_snapshot: "Visual snapshot",
  vis_3000_player_format: "VIS-3000 Player format",
  voice_announcement: "Voice Announcement",
  voltage: "Voltage",
  volume: "Volume",
  waiting: "waiting",
  waiting_for_download: "Waiting for download",
  wait_apply: "Wait apply",
  wait_pay: "Wait pay",
  wait_receive: "Wait receive",
  warning: "Warning",
  warning_blue: "Warning Blue",
  warning_green: "Warning Green",
  warning_prompt: "Warning Prompt",
  warning_red: "Warning Red",
  warranty: "Warranty",
  water: "Water",
  waterline: "Waterline",
  waterline_recognition: "Waterline recognition",
  watermark: "Watermark",
  water_line_alarm: "Water line alarm",
  wavelength: "Wavelength",
  weak_chicken_alarm: "Weak chicken alarm",
  weak_gps_signal: "Weak GPS signal",
  weather: "Weather",
  website: "Website",
  wechat_pay: "Wechat Pay",
  wednesday: "Wed.",
  week: "Week",
  weekly: "Weekly",
  weight: "Weight",
  weight_analysis: "Weight analysis",
  weight_gain_analysis: "Weight gain analysis",
  welcome: "Welcome",
  welcome_login: "Welcome Login",
  welcome_to: "Welcome to",
  west_northwest: "West-northwest",
  west_southeast: "West-southeast",
  we_detected_that_you_are_currently_using_mobile_data_for_the_dow:
    "We detected that you are currently using mobile data for the download. Do you want to continue?",
  when_setting_a_shielded_area_for_a_specific_period_the_valid_tim:
    "When setting a shielded area for a specific period, the valid time cannot be empty.",
  whether_there_are_other_hotspots_with_the_same_name_around_the_d:
    "Whether there are other hotspots with the same name around the device",
  whether_the_hotspot_name_matches_the_device:
    "Whether the hotspot name matches the device",
  whether_the_mobile_hotspot_is_turned_on:
    "Whether the mobile hotspot is turned on",
  whether_to_del_sel: "Whether or not to delete the selected items",
  white_brick: "White brick",
  white_hot: "White Hot",
  wifi: "Wi-Fi",
  wifi_characters:
    "1 to 32-bit characters, only numbers and upper and lower case letters",
  wifi_image_transmission: "Wi-Fi Image Transmission",
  wifi_information_setting_failed: "Wi-Fi information setting failed",
  wifi_modified_restart:
    "Wi-Fi has been modified successfully. Please restart the device if it cannot be connected",
  wifi_modified_successfully: "WiFi modified successfully",
  wifi_modified_successfully_the_device_needs_to_be_restarted_to_t:
    "WiFi modified successfully,The device needs to be restarted to take effect",
  wifi_must_be_enabled_on_the_device: "Wi-Fi must be enabled on the device",
  wifi_name: "Wi-Fi name",
  wifi_name_cannot_be_longer_than_32_chars:
    "Wi-Fi name cannot be longer than 32 chars",
  wifi_name_too_short: "Wi-Fi name too short",
  wifi_password: "Wi-Fi Password",
  wifi_password_too_short: "Wi-Fi password too short",
  wifi_pwd_modified_restart:
    "The device Wi-Fi password has been successfully modified. Please restart the device manually and re-enter the app",
  wifi_setting: "WIFI setting",
  wind: "Wind",
  wind_direction: "Wind  direction",
  wind_speed: "Wind speed",
  wind_speed_cloud_map: "Wind speed",
  wind_speed_m_s: "Wind speed (m/s)",
  wind_speed_sensor_status: "Wind speed sensor status",
  wiper: "Wiper",
  wiper_control_exception_pls_check_the_device:
    "Wiper control exception, please check the device",
  wireless_device: "Wireless devices",
  wlan: "WLAN",
  wlan_hotspot_switch: "WLAN hotspot switch",
  wood: "Wood",
  wool: "Wool",
  write: "Write",
  write_files_to_the_phone_memory:
    "The App writes image and video files to the phone memory.",
  wrong_password_attempts_left: "Wrong password, %1 attempts left",
  xsentry_main_server_status: "XSENTRY Main Server Status",
  xsentry_secondary_server_status: "XSENTRY Secondary Server Status",
  xxx_inspection_task_failed_to_resume_execution_due_to_network_co:
    "XXX inspection task failed to resume execution due to network connection error",
  xxx_inspection_task_failed_to_re_execute_due_to_network_connecti:
    "XXX inspection task failed to re-execute due to network connection error",
  xxx_inspection_task_issuance_failed_xxx_robot_not_responding:
    "XXX inspection task issuance failed, XXX robot not responding",
  xxx_inspection_task_issuance_failed_xxx_robot_points_do_not_matc:
    "XXX inspection task issuance failed, XXX robot points do not match the platform",
  xxx_inspection_task_issued_successfully:
    "XXX inspection task issued successfully",
  xxx_inspection_task_issuing: "XXX inspection task issuing",
  xxx_inspection_task_is_resuming: "XXX inspection task is resuming",
  xxx_inspection_task_is_re_executing: "XXX inspection task is re-executing",
  xxx_inspection_task_resumed_successfully:
    "XXX inspection task resumed successfully",
  xxx_inspection_task_re_executed_successfully:
    "XXX inspection task re-executed successfully",
  xxx_inspection_task_re_execution_failed_xxx_robot_did_not_respon:
    "XXX inspection task re-execution failed, XXX robot did not respond",
  xxx_inspection_task_terminated_successfully:
    "XXX inspection task terminated successfully",
  xxx_inspection_task_terminating: "XXX inspection task terminating",
  xxx_inspection_task_termination_failed_network_connection_error:
    "XXX inspection task termination failed, network connection error",
  xxx_inspection_task_termination_failed_xxx_robot_not_responding:
    "XXX inspection task termination failed, XXX robot not responding",
  yacht: "Yacht",
  yaw_angle_offset: "Yaw angle offset",
  year: "Year",
  year_month: "Year * Month",
  yes: "Yes",
  yesterday: "Yesterday",
  your_access_is_too_frequent_pls_retry_after_30_seconds:
    "Your access is too frequent, please retry after 30 seconds.",
  you_can_enter_1_32_characters_including_digits_letters___and_or:
    "You can enter 1–32 characters including digits, letters, -, and/or _.",
  you_can_enter_8_16_characters_including_digits_letters___and_or:
    "You can enter 8–16 characters including digits, letters, -, and/or _.",
  you_can_upgrade_in_device_information_check_for_updates:
    "You can upgrade in device information - check for updates",
  you_have_not_completed_the_company_information:
    "You have not completed the company information",
  you_need_to_enable_location_services_to_discover_new_devices:
    "You need to enable location services to discover new devices",
  you_need_to_turn_on_bluetooth_to_discover_new_devices:
    "You need to turn on Bluetooth to discover new devices",
  zeroing_config_unit: "Zeroing configuration unit",
  zeroing_distance: "Zeroing distance",
  zeroing_weather: "Zeroing weather",
  zoom: "Zoom",
  zoom_level: "Zoom Level",
  zoom_out: "Zoom Out",
};
